import * as ls from "react";
import rn, { createContext as Jn, useContext as Kn, useState as Z, useCallback as Lt, useEffect as Ie, useMemo as Fn, useRef as Zt, Fragment as Qu } from "react";
import Be from "@mui/material/Box";
import ec from "@mui/material/Avatar";
import tc from "@mui/material/Menu";
import Ir from "@mui/material/MenuItem";
import Is from "@mui/material/ListItemIcon";
import nc from "@mui/material/Divider";
import ua from "@mui/material/IconButton";
import Pr from "@mui/material/Tooltip";
import rc from "@mui/icons-material/Person";
import sc from "@mui/material/AppBar";
import ic from "@mui/material/Toolbar";
import { Box as ye, CircularProgress as Yn, Typography as Xe, Button as Ge, Breadcrumbs as oc, CardActionArea as ac, Card as Ar, CardContent as Ur, Stack as ln, Chip as ca, IconButton as Lr, TextField as $n, FormControlLabel as la, Checkbox as da, Link as Pi, Alert as Bn, List as uc, ListItemButton as cc, ListItemText as lc, MenuItem as dc, Table as fc, TableHead as hc, TableRow as Ai, TableCell as Dt, TableBody as pc, Divider as mc, Dialog as pr, DialogTitle as ds, DialogContent as mr, DialogActions as Ps, Snackbar as gc } from "@mui/material";
import { colors as fa, Logo as vc } from "brand";
import { AuthProvider as bc, useAuth as Jt } from "react-oidc-context";
import { Delete as yc, ArrowBack as wc, Add as Sc, People as xc, Edit as Rc } from "@mui/icons-material";
import Nr from "@mui/material/Skeleton";
import Dr from "@mui/material/Stack";
import { ThemeProvider as Oc, styled as ts, useColorScheme as ha } from "@mui/material/styles";
import _c from "@mui/material/CssBaseline";
import Ec from "@mui/material/List";
import Cc from "@mui/material/ListItem";
import Tc from "@mui/material/ListItemText";
import pa from "@mui/icons-material/Home";
import ma from "@mui/icons-material/Settings";
import jc from "@mui/icons-material/ChevronLeft";
import kc from "@mui/icons-material/ChevronRight";
import { Navigate as ga, useLocation as Ic } from "react-router-dom";
import Mn from "@mui/material/Typography";
import va from "@mui/material/Select";
import Pc from "@mui/icons-material/Event";
import ba from "@mui/material/Chip";
import Ac from "@mui/icons-material/Business";
import Uc from "@mui/icons-material/AdminPanelSettings";
import ya from "@mui/icons-material/Brightness4";
import wa from "@mui/icons-material/Brightness7";
import Sa from "@mui/icons-material/Logout";
import Lc from "@mui/icons-material/DeleteOutline";
import Nc from "@mui/icons-material/Lock";
import Dc from "axios";
var As = { exports: {} }, xn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ui;
function Fc() {
  if (Ui) return xn;
  Ui = 1;
  var e = rn, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, u, c) {
    var l, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), u.key !== void 0 && (f = "" + u.key), u.ref !== void 0 && (h = u.ref);
    for (l in u) r.call(u, l) && !i.hasOwnProperty(l) && (d[l] = u[l]);
    if (a && a.defaultProps) for (l in u = a.defaultProps, u) d[l] === void 0 && (d[l] = u[l]);
    return { $$typeof: t, type: a, key: f, ref: h, props: d, _owner: s.current };
  }
  return xn.Fragment = n, xn.jsx = o, xn.jsxs = o, xn;
}
var Rn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Li;
function $c() {
  return Li || (Li = 1, process.env.NODE_ENV !== "production" && function() {
    var e = rn, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), v = Symbol.iterator, m = "@@iterator";
    function O(g) {
      if (g === null || typeof g != "object")
        return null;
      var _ = v && g[v] || g[m];
      return typeof _ == "function" ? _ : null;
    }
    var K = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(g) {
      {
        for (var _ = arguments.length, j = new Array(_ > 1 ? _ - 1 : 0), G = 1; G < _; G++)
          j[G - 1] = arguments[G];
        J("error", g, j);
      }
    }
    function J(g, _, j) {
      {
        var G = K.ReactDebugCurrentFrame, he = G.getStackAddendum();
        he !== "" && (_ += "%s", j = j.concat([he]));
        var Oe = j.map(function(oe) {
          return String(oe);
        });
        Oe.unshift("Warning: " + _), Function.prototype.apply.call(console[g], console, Oe);
      }
    }
    var H = !1, ie = !1, Q = !1, De = !1, Te = !1, Ye;
    Ye = Symbol.for("react.module.reference");
    function at(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === r || g === i || Te || g === s || g === c || g === l || De || g === h || H || ie || Q || typeof g == "object" && g !== null && (g.$$typeof === f || g.$$typeof === d || g.$$typeof === o || g.$$typeof === a || g.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === Ye || g.getModuleId !== void 0));
    }
    function xe(g, _, j) {
      var G = g.displayName;
      if (G)
        return G;
      var he = _.displayName || _.name || "";
      return he !== "" ? j + "(" + he + ")" : j;
    }
    function Fe(g) {
      return g.displayName || "Context";
    }
    function we(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case c:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case a:
            var _ = g;
            return Fe(_) + ".Consumer";
          case o:
            var j = g;
            return Fe(j._context) + ".Provider";
          case u:
            return xe(g, g.render, "ForwardRef");
          case d:
            var G = g.displayName || null;
            return G !== null ? G : we(g.type) || "Memo";
          case f: {
            var he = g, Oe = he._payload, oe = he._init;
            try {
              return we(oe(Oe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ue = Object.assign, le = 0, st, ke, bt, Tt, Ee, Ce, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function Re() {
      {
        if (le === 0) {
          st = console.log, ke = console.info, bt = console.warn, Tt = console.error, Ee = console.group, Ce = console.groupCollapsed, $e = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        le++;
      }
    }
    function Me() {
      {
        if (le--, le === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ue({}, g, {
              value: st
            }),
            info: ue({}, g, {
              value: ke
            }),
            warn: ue({}, g, {
              value: bt
            }),
            error: ue({}, g, {
              value: Tt
            }),
            group: ue({}, g, {
              value: Ee
            }),
            groupCollapsed: ue({}, g, {
              value: Ce
            }),
            groupEnd: ue({}, g, {
              value: $e
            })
          });
        }
        le < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ut = K.ReactCurrentDispatcher, jt;
    function Mt(g, _, j) {
      {
        if (jt === void 0)
          try {
            throw Error();
          } catch (he) {
            var G = he.stack.trim().match(/\n( *(at )?)/);
            jt = G && G[1] || "";
          }
        return `
` + jt + g;
      }
    }
    var ct = !1, kt;
    {
      var ss = typeof WeakMap == "function" ? WeakMap : Map;
      kt = new ss();
    }
    function vi(g, _) {
      if (!g || ct)
        return "";
      {
        var j = kt.get(g);
        if (j !== void 0)
          return j;
      }
      var G;
      ct = !0;
      var he = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Oe;
      Oe = ut.current, ut.current = null, Re();
      try {
        if (_) {
          var oe = function() {
            throw Error();
          };
          if (Object.defineProperty(oe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(oe, []);
            } catch (Ve) {
              G = Ve;
            }
            Reflect.construct(g, [], oe);
          } else {
            try {
              oe.call();
            } catch (Ve) {
              G = Ve;
            }
            g.call(oe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ve) {
            G = Ve;
          }
          g();
        }
      } catch (Ve) {
        if (Ve && G && typeof Ve.stack == "string") {
          for (var ne = Ve.stack.split(`
`), Ze = G.stack.split(`
`), Pe = ne.length - 1, Ae = Ze.length - 1; Pe >= 1 && Ae >= 0 && ne[Pe] !== Ze[Ae]; )
            Ae--;
          for (; Pe >= 1 && Ae >= 0; Pe--, Ae--)
            if (ne[Pe] !== Ze[Ae]) {
              if (Pe !== 1 || Ae !== 1)
                do
                  if (Pe--, Ae--, Ae < 0 || ne[Pe] !== Ze[Ae]) {
                    var it = `
` + ne[Pe].replace(" at new ", " at ");
                    return g.displayName && it.includes("<anonymous>") && (it = it.replace("<anonymous>", g.displayName)), typeof g == "function" && kt.set(g, it), it;
                  }
                while (Pe >= 1 && Ae >= 0);
              break;
            }
        }
      } finally {
        ct = !1, ut.current = Oe, Me(), Error.prepareStackTrace = he;
      }
      var Yt = g ? g.displayName || g.name : "", zt = Yt ? Mt(Yt) : "";
      return typeof g == "function" && kt.set(g, zt), zt;
    }
    function ju(g, _, j) {
      return vi(g, !1);
    }
    function ku(g) {
      var _ = g.prototype;
      return !!(_ && _.isReactComponent);
    }
    function er(g, _, j) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return vi(g, ku(g));
      if (typeof g == "string")
        return Mt(g);
      switch (g) {
        case c:
          return Mt("Suspense");
        case l:
          return Mt("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case u:
            return ju(g.render);
          case d:
            return er(g.type, _, j);
          case f: {
            var G = g, he = G._payload, Oe = G._init;
            try {
              return er(Oe(he), _, j);
            } catch {
            }
          }
        }
      return "";
    }
    var Sn = Object.prototype.hasOwnProperty, bi = {}, yi = K.ReactDebugCurrentFrame;
    function tr(g) {
      if (g) {
        var _ = g._owner, j = er(g.type, g._source, _ ? _.type : null);
        yi.setExtraStackFrame(j);
      } else
        yi.setExtraStackFrame(null);
    }
    function Iu(g, _, j, G, he) {
      {
        var Oe = Function.call.bind(Sn);
        for (var oe in g)
          if (Oe(g, oe)) {
            var ne = void 0;
            try {
              if (typeof g[oe] != "function") {
                var Ze = Error((G || "React class") + ": " + j + " type `" + oe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[oe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ze.name = "Invariant Violation", Ze;
              }
              ne = g[oe](_, oe, G, j, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Pe) {
              ne = Pe;
            }
            ne && !(ne instanceof Error) && (tr(he), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", G || "React class", j, oe, typeof ne), tr(null)), ne instanceof Error && !(ne.message in bi) && (bi[ne.message] = !0, tr(he), C("Failed %s type: %s", j, ne.message), tr(null));
          }
      }
    }
    var Pu = Array.isArray;
    function is(g) {
      return Pu(g);
    }
    function Au(g) {
      {
        var _ = typeof Symbol == "function" && Symbol.toStringTag, j = _ && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return j;
      }
    }
    function Uu(g) {
      try {
        return wi(g), !1;
      } catch {
        return !0;
      }
    }
    function wi(g) {
      return "" + g;
    }
    function Si(g) {
      if (Uu(g))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Au(g)), wi(g);
    }
    var xi = K.ReactCurrentOwner, Lu = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ri, Oi;
    function Nu(g) {
      if (Sn.call(g, "ref")) {
        var _ = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function Du(g) {
      if (Sn.call(g, "key")) {
        var _ = Object.getOwnPropertyDescriptor(g, "key").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function Fu(g, _) {
      typeof g.ref == "string" && xi.current;
    }
    function $u(g, _) {
      {
        var j = function() {
          Ri || (Ri = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        j.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: j,
          configurable: !0
        });
      }
    }
    function Bu(g, _) {
      {
        var j = function() {
          Oi || (Oi = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        j.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: j,
          configurable: !0
        });
      }
    }
    var Mu = function(g, _, j, G, he, Oe, oe) {
      var ne = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: g,
        key: _,
        ref: j,
        props: oe,
        // Record the component responsible for creating this element.
        _owner: Oe
      };
      return ne._store = {}, Object.defineProperty(ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ne, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: G
      }), Object.defineProperty(ne, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: he
      }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
    };
    function zu(g, _, j, G, he) {
      {
        var Oe, oe = {}, ne = null, Ze = null;
        j !== void 0 && (Si(j), ne = "" + j), Du(_) && (Si(_.key), ne = "" + _.key), Nu(_) && (Ze = _.ref, Fu(_, he));
        for (Oe in _)
          Sn.call(_, Oe) && !Lu.hasOwnProperty(Oe) && (oe[Oe] = _[Oe]);
        if (g && g.defaultProps) {
          var Pe = g.defaultProps;
          for (Oe in Pe)
            oe[Oe] === void 0 && (oe[Oe] = Pe[Oe]);
        }
        if (ne || Ze) {
          var Ae = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          ne && $u(oe, Ae), Ze && Bu(oe, Ae);
        }
        return Mu(g, ne, Ze, he, G, xi.current, oe);
      }
    }
    var os = K.ReactCurrentOwner, _i = K.ReactDebugCurrentFrame;
    function Kt(g) {
      if (g) {
        var _ = g._owner, j = er(g.type, g._source, _ ? _.type : null);
        _i.setExtraStackFrame(j);
      } else
        _i.setExtraStackFrame(null);
    }
    var as;
    as = !1;
    function us(g) {
      return typeof g == "object" && g !== null && g.$$typeof === t;
    }
    function Ei() {
      {
        if (os.current) {
          var g = we(os.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function qu(g) {
      return "";
    }
    var Ci = {};
    function Hu(g) {
      {
        var _ = Ei();
        if (!_) {
          var j = typeof g == "string" ? g : g.displayName || g.name;
          j && (_ = `

Check the top-level render call using <` + j + ">.");
        }
        return _;
      }
    }
    function Ti(g, _) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var j = Hu(_);
        if (Ci[j])
          return;
        Ci[j] = !0;
        var G = "";
        g && g._owner && g._owner !== os.current && (G = " It was passed a child from " + we(g._owner.type) + "."), Kt(g), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', j, G), Kt(null);
      }
    }
    function ji(g, _) {
      {
        if (typeof g != "object")
          return;
        if (is(g))
          for (var j = 0; j < g.length; j++) {
            var G = g[j];
            us(G) && Ti(G, _);
          }
        else if (us(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var he = O(g);
          if (typeof he == "function" && he !== g.entries)
            for (var Oe = he.call(g), oe; !(oe = Oe.next()).done; )
              us(oe.value) && Ti(oe.value, _);
        }
      }
    }
    function Zu(g) {
      {
        var _ = g.type;
        if (_ == null || typeof _ == "string")
          return;
        var j;
        if (typeof _ == "function")
          j = _.propTypes;
        else if (typeof _ == "object" && (_.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        _.$$typeof === d))
          j = _.propTypes;
        else
          return;
        if (j) {
          var G = we(_);
          Iu(j, g.props, "prop", G, g);
        } else if (_.PropTypes !== void 0 && !as) {
          as = !0;
          var he = we(_);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", he || "Unknown");
        }
        typeof _.getDefaultProps == "function" && !_.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Gu(g) {
      {
        for (var _ = Object.keys(g.props), j = 0; j < _.length; j++) {
          var G = _[j];
          if (G !== "children" && G !== "key") {
            Kt(g), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", G), Kt(null);
            break;
          }
        }
        g.ref !== null && (Kt(g), C("Invalid attribute `ref` supplied to `React.Fragment`."), Kt(null));
      }
    }
    var ki = {};
    function Ii(g, _, j, G, he, Oe) {
      {
        var oe = at(g);
        if (!oe) {
          var ne = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ze = qu();
          Ze ? ne += Ze : ne += Ei();
          var Pe;
          g === null ? Pe = "null" : is(g) ? Pe = "array" : g !== void 0 && g.$$typeof === t ? (Pe = "<" + (we(g.type) || "Unknown") + " />", ne = " Did you accidentally export a JSX literal instead of a component?") : Pe = typeof g, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Pe, ne);
        }
        var Ae = zu(g, _, j, he, Oe);
        if (Ae == null)
          return Ae;
        if (oe) {
          var it = _.children;
          if (it !== void 0)
            if (G)
              if (is(it)) {
                for (var Yt = 0; Yt < it.length; Yt++)
                  ji(it[Yt], g);
                Object.freeze && Object.freeze(it);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ji(it, g);
        }
        if (Sn.call(_, "key")) {
          var zt = we(g), Ve = Object.keys(_).filter(function(Xu) {
            return Xu !== "key";
          }), cs = Ve.length > 0 ? "{key: someKey, " + Ve.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ki[zt + cs]) {
            var Yu = Ve.length > 0 ? "{" + Ve.join(": ..., ") + ": ...}" : "{}";
            C(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, cs, zt, Yu, zt), ki[zt + cs] = !0;
          }
        }
        return g === r ? Gu(Ae) : Zu(Ae), Ae;
      }
    }
    function Wu(g, _, j) {
      return Ii(g, _, j, !0);
    }
    function Vu(g, _, j) {
      return Ii(g, _, j, !1);
    }
    var Ju = Vu, Ku = Wu;
    Rn.Fragment = r, Rn.jsx = Ju, Rn.jsxs = Ku;
  }()), Rn;
}
process.env.NODE_ENV === "production" ? As.exports = Fc() : As.exports = $c();
var p = As.exports;
function Bc({ menuItems: e }) {
  const [t, n] = ls.useState(null), r = !!t, s = (o) => {
    n(o.currentTarget);
  }, i = () => {
    n(null);
  };
  return /* @__PURE__ */ p.jsxs(ls.Fragment, { children: [
    /* @__PURE__ */ p.jsx(Be, { sx: { display: "flex", alignItems: "center", textAlign: "center" }, children: /* @__PURE__ */ p.jsx(Pr, { title: "Account settings", children: /* @__PURE__ */ p.jsx(
      ua,
      {
        onClick: s,
        size: "small",
        sx: { ml: 2 },
        "aria-controls": r ? "account-menu" : void 0,
        "aria-haspopup": "true",
        "aria-expanded": r ? "true" : void 0,
        children: /* @__PURE__ */ p.jsx(ec, { sx: { width: 32, height: 32 }, children: /* @__PURE__ */ p.jsx(rc, {}) })
      }
    ) }) }),
    /* @__PURE__ */ p.jsx(
      tc,
      {
        anchorEl: t,
        id: "account-menu",
        open: r,
        onClose: i,
        onClick: i,
        disableScrollLock: !0,
        slotProps: {
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0
              }
            }
          }
        },
        transformOrigin: { horizontal: "right", vertical: "top" },
        anchorOrigin: { horizontal: "right", vertical: "bottom" },
        children: e.map((o, a) => /* @__PURE__ */ p.jsxs(ls.Fragment, { children: [
          o.divider && /* @__PURE__ */ p.jsx(nc, {}),
          o.href ? /* @__PURE__ */ p.jsxs(Ir, { component: "a", href: o.href, onClick: i, children: [
            o.icon && /* @__PURE__ */ p.jsx(Is, { children: o.icon }),
            o.text
          ] }) : /* @__PURE__ */ p.jsxs(
            Ir,
            {
              onClick: () => {
                var u;
                (u = o.onClick) == null || u.call(o), i();
              },
              children: [
                o.icon && /* @__PURE__ */ p.jsx(Is, { children: o.icon }),
                o.text
              ]
            }
          )
        ] }, a))
      }
    )
  ] });
}
const Mc = 64, zc = ({ rightContent: e = null, brandLogo: t = null, sx: n = {} }) => /* @__PURE__ */ p.jsx(sc, { sx: { ...n }, position: "fixed", elevation: 1, children: /* @__PURE__ */ p.jsxs(
  ic,
  {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      pl: 0,
      minHeight: `${Mc}px !important`
    },
    children: [
      t,
      /* @__PURE__ */ p.jsx(Be, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: e })
    ]
  }
) }), fp = ({ children: e, sx: t = {} }) => /* @__PURE__ */ p.jsx(
  Be,
  {
    component: "footer",
    sx: {
      position: "fixed",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "56px",
      borderTop: 1,
      borderColor: "divider",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: (n) => n.zIndex.appBar,
      ...t
    },
    children: e
  }
), qc = 64, Hc = ({ children: e }) => /* @__PURE__ */ p.jsx(
  Be,
  {
    component: "main",
    sx: {
      p: "20px",
      pb: 0,
      flexGrow: 1,
      mb: "56px",
      // space for footer
      minHeight: `calc(100vh - ${qc}px - 56px)`,
      overflow: "auto"
    },
    children: e || /* @__PURE__ */ p.jsx("div", { children: "MainContent (stub)" })
  }
), xa = "common-fe.navRailExpanded", Ra = 72, Zc = 200, Gc = () => {
  try {
    return window.localStorage.getItem(xa) === "true";
  } catch {
    return !1;
  }
}, Wc = (e) => {
  try {
    window.localStorage.setItem(xa, String(e));
  } catch {
  }
}, Oa = Jn({
  expanded: !1,
  width: Ra,
  toggleExpanded: () => {
  }
}), Vc = ({ children: e }) => {
  const [t, n] = Z(Gc), r = Lt(() => {
    n((i) => {
      const o = !i;
      return Wc(o), o;
    });
  }, []), s = t ? Zc : Ra;
  return /* @__PURE__ */ p.jsx(Oa.Provider, { value: { expanded: t, width: s, toggleExpanded: r }, children: e });
}, _a = () => Kn(Oa), fs = 64, Jc = { xs: 2, sm: 4, md: 8 }, Kc = ({ appFooterEnabled: e, children: t, appFooter: n, appBar: r, navRail: s }) => {
  const { width: i } = _a();
  return /* @__PURE__ */ p.jsxs(Be, { sx: { minHeight: "100vh", width: "100%" }, children: [
    /* @__PURE__ */ p.jsx(
      Be,
      {
        sx: {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          zIndex: 1300
        },
        children: r
      }
    ),
    /* @__PURE__ */ p.jsxs(
      Be,
      {
        sx: {
          display: "flex",
          flexDirection: "row",
          pt: `${fs}px`
        },
        children: [
          s && /* @__PURE__ */ p.jsx(
            Be,
            {
              sx: {
                width: i,
                flexShrink: 0,
                position: "fixed",
                height: `calc(100vh - ${fs}px)`,
                top: fs,
                left: 0,
                zIndex: 1200,
                transition: "width 0.15s ease"
              },
              children: s
            }
          ),
          /* @__PURE__ */ p.jsx(
            Be,
            {
              sx: {
                flexGrow: 1,
                minWidth: 0,
                ml: s ? `${i}px` : 0,
                px: Jc,
                transition: "margin-left 0.15s ease"
              },
              children: /* @__PURE__ */ p.jsx(Hc, { children: t })
            }
          )
        ]
      }
    ),
    e && n
  ] });
}, hp = ({
  appFooterEnabled: e = !0,
  children: t,
  appFooter: n = null,
  appBar: r = null,
  navRail: s = null
}) => /* @__PURE__ */ p.jsx(Vc, { children: /* @__PURE__ */ p.jsx(
  Kc,
  {
    appFooterEnabled: e,
    appFooter: n,
    appBar: r,
    navRail: s,
    children: t
  }
) });
function gr({ message: e }) {
  return /* @__PURE__ */ p.jsxs(
    ye,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal
      },
      children: [
        /* @__PURE__ */ p.jsx(Yn, { sx: { color: fa.foxOrange } }),
        e && /* @__PURE__ */ p.jsx(Xe, { variant: "h6", sx: { mt: 2 }, children: e })
      ]
    }
  );
}
const Ea = ["/", "/callback", "/logout", "/logged-out"];
function Yc(e) {
  return typeof e == "string" && e.startsWith("/") && !Ea.includes(e);
}
function pp({ navigateFunction: e, location: t }) {
  return Ie(() => {
    const n = setTimeout(() => {
      const r = localStorage.getItem("redirect_url");
      localStorage.removeItem("redirect_url");
      const s = Yc(r) ? r : "/";
      e(s, { replace: !0 });
    }, 500);
    return () => clearTimeout(n);
  }, [e, t]), /* @__PURE__ */ p.jsx(gr, { message: "Signing you in..." });
}
let Ca = !1;
function mp() {
  Ca = !0;
}
function Xc() {
  return Ca;
}
function Qc({ children: e }) {
  const t = Jt();
  return Ie(() => {
    const n = window.location.pathname;
    Ea.includes(n) || localStorage.setItem("redirect_url", n);
  }, []), Ie(() => {
    !t.isLoading && !t.isAuthenticated && !t.error && !Xc() && t.signinRedirect();
  }, [t.isLoading, t.isAuthenticated, t.error, t]), t.isLoading ? /* @__PURE__ */ p.jsx(gr, { message: "Loading..." }) : t.error ? /* @__PURE__ */ p.jsx(
    gr,
    {
      message: `Encountering error... ${t.error.message}`
    }
  ) : t.isAuthenticated ? e : /* @__PURE__ */ p.jsx(gr, { message: "Redirecting to login..." });
}
function el() {
  return typeof window < "u" && !!window.Cypress;
}
function gp({ cognitoAuthConfig: e, children: t }) {
  const n = el() ? { ...e, automaticSilentRenew: !1, monitorSession: !1 } : e;
  return /* @__PURE__ */ p.jsx(bc, { ...n, children: /* @__PURE__ */ p.jsx(Qc, { children: t }) });
}
const vp = ({
  onConfirm: e,
  onCancel: t,
  confirmText: n = "Confirm",
  cancelText: r = "Cancel",
  buttonText: s = "Delete",
  buttonIcon: i = /* @__PURE__ */ p.jsx(yc, {}),
  variant: o = "outlined",
  color: a = "error",
  size: u = "small",
  disabled: c = !1,
  "data-testid": l,
  confirmButtonTestId: d,
  cancelButtonTestId: f
}) => {
  const [h, v] = Z(!1), m = () => {
    v(!0);
  }, O = () => {
    v(!1), e();
  }, K = () => {
    v(!1), t && t();
  };
  return h ? /* @__PURE__ */ p.jsxs(ye, { sx: { display: "flex", gap: 1 }, children: [
    /* @__PURE__ */ p.jsx(
      Ge,
      {
        variant: "contained",
        color: a,
        size: u,
        onClick: O,
        "data-testid": d,
        children: n
      }
    ),
    /* @__PURE__ */ p.jsx(
      Ge,
      {
        variant: "outlined",
        size: u,
        onClick: K,
        "data-testid": f,
        children: r
      }
    )
  ] }) : /* @__PURE__ */ p.jsx(
    Ge,
    {
      variant: o,
      color: a,
      size: u,
      startIcon: i,
      onClick: m,
      disabled: c,
      "data-testid": l,
      children: s
    }
  );
};
function bp({
  rows: e = 5,
  columns: t = 1,
  showHeader: n = !0,
  dense: r = !1,
  sx: s,
  ...i
}) {
  const o = r ? 28 : 40, a = r ? 0.75 : 1.25, u = Math.max(1, t), c = (l, d) => /* @__PURE__ */ p.jsx(Dr, { direction: "row", spacing: a, sx: { width: "100%" }, children: Array.from({ length: u }).map((f, h) => /* @__PURE__ */ p.jsx(
    Nr,
    {
      variant: "rounded",
      height: d,
      sx: { flex: 1, borderRadius: 1 }
    },
    h
  )) }, l);
  return /* @__PURE__ */ p.jsx(
    Be,
    {
      role: "progressbar",
      "aria-busy": "true",
      "aria-label": "Loading",
      "data-testid": "table-skeleton",
      sx: { width: "100%", ...s },
      ...i,
      children: /* @__PURE__ */ p.jsxs(Dr, { spacing: a, children: [
        n && c("header", o * 0.7),
        Array.from({ length: Math.max(1, e) }).map(
          (l, d) => c(`row-${d}`, o)
        )
      ] })
    }
  );
}
function yp() {
  return /* @__PURE__ */ p.jsxs("div", { children: [
    "You have been logged out. ",
    /* @__PURE__ */ p.jsx("a", { href: "/", children: "Go to home" })
  ] });
}
function wp({ navigateFunction: e }) {
  const t = Jt();
  return Ie(() => {
    let n = !0;
    async function r() {
      await t.removeUser(), n && e("/logged-out", { replace: !0 });
    }
    return r(), () => {
      n = !1;
    };
  }, [t, e]), /* @__PURE__ */ p.jsx("div", { children: "You have been logged out." });
}
function Sp({ theme: e, children: t }) {
  return !e || typeof e != "object" ? (console.error("Invalid theme object provided to MuiThemeProvider"), t) : /* @__PURE__ */ p.jsxs(Oc, { theme: e, children: [
    /* @__PURE__ */ p.jsx(_c, {}),
    t
  ] });
}
const tl = ts(Be)(({ theme: e, backgroundColor: t, color: n, width: r }) => ({
  width: r,
  height: "100%",
  backgroundColor: t || e.palette.background.paper,
  color: n || e.palette.text.primary,
  borderRight: `1px solid ${e.palette.divider}`,
  display: "flex",
  flexDirection: "column",
  paddingTop: e.spacing(1),
  overflow: "hidden",
  transition: "width 0.15s ease"
})), nl = ts(ua)(({ theme: e, backgroundColor: t, color: n }) => ({
  position: "absolute",
  top: e.spacing(1.5),
  right: 0,
  transform: "translateX(50%)",
  width: 20,
  height: 20,
  padding: 0,
  borderRadius: 4,
  backgroundColor: t || e.palette.background.paper,
  color: n || e.palette.text.primary,
  border: `1px solid ${e.palette.divider}`,
  zIndex: 1,
  "&:hover": {
    backgroundColor: t || e.palette.background.paper,
    opacity: 0.8
  }
})), xp = ({
  navItems: e,
  backgroundColor: t = "#1a1a1a",
  color: n = "inherit"
}) => {
  const { expanded: r, width: s, toggleExpanded: i } = _a(), o = [
    {
      icon: /* @__PURE__ */ p.jsx(pa, {}),
      text: "Home",
      onClick: () => {
      }
    },
    {
      icon: /* @__PURE__ */ p.jsx(ma, {}),
      text: "Settings",
      onClick: () => {
      }
    }
  ], a = e && e.length > 0 ? e : o;
  return /* @__PURE__ */ p.jsxs(Be, { sx: { position: "relative", width: "100%", height: "100%" }, children: [
    /* @__PURE__ */ p.jsx(tl, { backgroundColor: t, color: n, width: s, children: /* @__PURE__ */ p.jsx(Ec, { sx: { width: "100%", p: 0 }, children: a.map((u, c) => {
      const l = /* @__PURE__ */ p.jsxs(
        Cc,
        {
          onClick: u.onClick,
          sx: {
            flexDirection: r ? "row" : "column",
            justifyContent: r ? "flex-start" : "center",
            py: 1,
            px: r ? 2 : 0,
            gap: r ? 1.5 : 0,
            color: "inherit",
            // #582 — nav items are clickable; show the pointer (hand) cursor
            // on hover (ListItem alone doesn't imply a button cursor).
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "transparent",
              opacity: 0.8
            }
          },
          children: [
            /* @__PURE__ */ p.jsx(
              Is,
              {
                sx: {
                  minWidth: "auto",
                  color: "inherit"
                },
                children: u.icon
              }
            ),
            r && /* @__PURE__ */ p.jsx(
              Tc,
              {
                primary: u.text,
                primaryTypographyProps: {
                  variant: "caption",
                  align: "left",
                  sx: {
                    fontSize: "0.75rem",
                    color: "inherit",
                    whiteSpace: "nowrap"
                  }
                }
              }
            )
          ]
        },
        c
      );
      return r ? l : /* @__PURE__ */ p.jsx(Pr, { title: u.text, placement: "right", children: l }, c);
    }) }) }),
    /* @__PURE__ */ p.jsx(Pr, { title: r ? "Collapse navigation" : "Expand navigation", children: /* @__PURE__ */ p.jsx(
      nl,
      {
        onClick: i,
        "aria-label": r ? "Collapse navigation" : "Expand navigation",
        backgroundColor: t,
        color: n,
        children: r ? /* @__PURE__ */ p.jsx(jc, { sx: { fontSize: 14 } }) : /* @__PURE__ */ p.jsx(kc, { sx: { fontSize: 14 } })
      }
    ) })
  ] });
};
function Rp({ children: e }) {
  return Jt().isAuthenticated ? e : /* @__PURE__ */ p.jsx(ga, { to: "/callback", replace: !0 });
}
const Op = ({
  children: e,
  maxWidth: t = 600,
  minWidth: n = 320,
  backTo: r,
  backLabel: s,
  breadcrumbs: i,
  onBack: o
}) => {
  const a = () => {
    o && o();
  };
  return /* @__PURE__ */ p.jsxs(
    ye,
    {
      maxWidth: t,
      minWidth: n,
      mt: 4,
      pb: 8,
      sx: {
        overflowX: "auto"
      },
      children: [
        /* @__PURE__ */ p.jsx(
          ye,
          {
            sx: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              mb: 3
            },
            children: /* @__PURE__ */ p.jsxs(ye, { sx: { display: "flex", alignItems: "center", gap: 2, flex: 1 }, children: [
              r && /* @__PURE__ */ p.jsx(
                Ge,
                {
                  startIcon: /* @__PURE__ */ p.jsx(wc, {}),
                  onClick: a,
                  variant: "outlined",
                  size: "small",
                  children: s || "Back"
                }
              ),
              i && /* @__PURE__ */ p.jsx(oc, { separator: "", children: rn.Children.map(i, (u, c) => {
                const l = rn.Children.count(i);
                let d = "middle";
                return l === 1 ? d = "single" : c === 0 ? d = "first" : c === l - 1 && (d = "last"), rn.cloneElement(u, { position: d });
              }) })
            ] })
          }
        ),
        e
      ]
    }
  );
}, lt = "12px", rl = ts(Be, {
  shouldForwardProp: (e) => e !== "position"
})(({ theme: e, position: t }) => {
  const n = () => {
    switch (t) {
      case "first":
        return `polygon(0 0, 100% 0, calc(100% - ${lt}) 100%, 0 100%)`;
      case "middle":
        return `polygon(${lt} 0, 100% 0, calc(100% - ${lt}) 100%, 0 100%)`;
      case "last":
        return `polygon(${lt} 0, calc(100% - ${lt}) 0, 100% 50%, calc(100% - ${lt}) 100%, 0 100%)`;
      case "single":
      default:
        return `polygon(0 0, calc(100% - ${lt}) 0, 100% 50%, calc(100% - ${lt}) 100%, 0 100%)`;
    }
  };
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "24px",
    backgroundColor: e.palette.mode === "dark" ? e.palette.grey[800] : e.palette.grey[200],
    color: e.palette.getContrastText(
      e.palette.mode === "dark" ? e.palette.grey[800] : e.palette.grey[200]
    ),
    cursor: "pointer",
    textDecoration: "none",
    clipPath: n(),
    // Nudge the items together to overlap
    marginLeft: t === "middle" || t === "last" ? `-${lt}` : 0,
    // Adjust padding to make space for the clipped areas
    paddingLeft: t === "middle" || t === "last" ? `calc(${lt} + ${e.spacing(1)})` : e.spacing(2),
    paddingRight: `calc(${lt} + ${e.spacing(1)})`,
    "&:hover, &:focus-within": {
      backgroundColor: e.palette.mode === "dark" ? e.palette.grey[700] : e.palette.grey[300]
    }
  };
}), sl = ts(Mn)({
  whiteSpace: "nowrap",
  fontSize: "0.8125rem",
  fontWeight: 400,
  color: "inherit"
}), _p = ({ label: e, component: t = "a", ...n }) => /* @__PURE__ */ p.jsx(rl, { component: t, ...n, children: /* @__PURE__ */ p.jsx(sl, { children: e }) }), Ep = ({ onClick: e, label: t, "data-testid": n }) => /* @__PURE__ */ p.jsx(
  ac,
  {
    onClick: e,
    sx: {
      height: "100%",
      minHeight: 140,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: (r) => r.palette.mode === "dark" ? r.palette.grey[800] : r.palette.grey[200],
      borderRadius: (r) => r.shape.borderRadius,
      padding: 2,
      "&:hover": {
        backgroundColor: (r) => r.palette.mode === "dark" ? r.palette.grey[700] : r.palette.grey[300]
      }
    },
    "data-testid": n || "new-item-card-button",
    children: /* @__PURE__ */ p.jsxs(
      ye,
      {
        sx: {
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: "3px dashed",
          borderColor: "grey.500",
          borderRadius: "10px",
          padding: "20px",
          color: "grey.500"
        },
        children: [
          /* @__PURE__ */ p.jsx(
            ye,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                borderRadius: "50%",
                border: "3px solid",
                borderColor: "inherit",
                mb: 1
              },
              children: /* @__PURE__ */ p.jsx(Sc, { sx: { fontSize: 32 } })
            }
          ),
          /* @__PURE__ */ p.jsx(Xe, { variant: "button", component: "span", children: t })
        ]
      }
    )
  }
), Cp = ({ title: e, icon: t, tags: n = [], onEdit: r, showEdit: s, onMembers: i, showMembers: o, "data-testid": a, editButtonTestId: u, membersButtonTestId: c }) => /* @__PURE__ */ p.jsxs(
  Ar,
  {
    sx: {
      position: "relative",
      minHeight: 120,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: 0,
      backgroundColor: (l) => l.palette.mode === "dark" ? l.palette.grey[900] : l.palette.background.paper
    },
    "data-testid": a,
    elevation: 1,
    children: [
      /* @__PURE__ */ p.jsx(Ur, { sx: { pb: 1 }, children: /* @__PURE__ */ p.jsxs(ye, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
        t && rn.cloneElement(t, { sx: { mr: 1.5, color: "text.secondary" } }),
        /* @__PURE__ */ p.jsx(Xe, { variant: "h6", component: "div", noWrap: !0, children: e })
      ] }) }),
      /* @__PURE__ */ p.jsx(Ur, { sx: { pt: 0, flexGrow: 1 }, children: /* @__PURE__ */ p.jsx(ln, { direction: "row", spacing: 1, children: n.map((l, d) => /* @__PURE__ */ p.jsx(
        ca,
        {
          label: l.label,
          color: l.color || "default",
          size: l.size || "small",
          variant: "outlined"
        },
        d
      )) }) }),
      /* @__PURE__ */ p.jsxs(ye, { sx: { position: "absolute", top: 8, right: 8, display: "flex", gap: 0.5 }, children: [
        o && /* @__PURE__ */ p.jsx(
          Lr,
          {
            "aria-label": `manage members for ${e}`,
            onClick: i,
            sx: {
              color: "text.secondary"
            },
            "data-testid": c,
            children: /* @__PURE__ */ p.jsx(xc, {})
          }
        ),
        s && /* @__PURE__ */ p.jsx(
          Lr,
          {
            "aria-label": `edit ${e}`,
            onClick: r,
            sx: {
              color: "text.secondary"
            },
            "data-testid": u,
            children: /* @__PURE__ */ p.jsx(Rc, {})
          }
        )
      ] })
    ]
  }
);
class Pn extends Error {
}
Pn.prototype.name = "InvalidTokenError";
function il(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, n) => {
    let r = n.charCodeAt(0).toString(16).toUpperCase();
    return r.length < 2 && (r = "0" + r), "%" + r;
  }));
}
function ol(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return il(t);
  } catch {
    return atob(t);
  }
}
function Ta(e, t) {
  if (typeof e != "string")
    throw new Pn("Invalid token specified: must be a string");
  t || (t = {});
  const n = t.header === !0 ? 0 : 1, r = e.split(".")[n];
  if (typeof r != "string")
    throw new Pn(`Invalid token specified: missing part #${n + 1}`);
  let s;
  try {
    s = ol(r);
  } catch (i) {
    throw new Pn(`Invalid token specified: invalid base64 for part #${n + 1} (${i.message})`);
  }
  try {
    return JSON.parse(s);
  } catch (i) {
    throw new Pn(`Invalid token specified: invalid json for part #${n + 1} (${i.message})`);
  }
}
const Us = "common-fe.activeOrgId", al = "426e8750-5b55-59f4-90c7-835b46d6a990", ul = (e) => {
  const t = e.filter((n) => n.id !== al);
  return t.length ? t : e;
}, cl = (e) => {
  if (!e) return !1;
  try {
    const t = Ta(e), n = t["custom:super"] ?? t.super;
    return n === "true" || n === !0;
  } catch {
    return !1;
  }
}, ja = Jn({
  orgs: [],
  activeOrgId: null,
  setActiveOrgId: () => {
  },
  loading: !1,
  error: null,
  isSuper: !1
}), ll = () => {
  try {
    return window.localStorage.getItem(Us) || null;
  } catch {
    return null;
  }
}, dl = (e) => {
  try {
    e ? window.localStorage.setItem(Us, e) : window.localStorage.removeItem(Us);
  } catch {
  }
}, Tp = ({ listOrgs: e, children: t }) => {
  var v;
  const r = (v = Jt().user) == null ? void 0 : v.access_token, s = cl(r), [i, o] = Z([]), [a, u] = Z(!0), [c, l] = Z(null), [d, f] = Z(() => ll()), h = Lt((m) => {
    f(m), dl(m);
  }, []);
  return Ie(() => {
    if (!e) {
      u(!1);
      return;
    }
    let m = !1;
    return (async () => {
      try {
        u(!0), l(null);
        const O = await e(s);
        if (m) return;
        o(ul(Array.isArray(O) ? O : []));
      } catch (O) {
        if (m) return;
        console.error("Failed to load orgs for switcher:", O), l(O), o([]);
      } finally {
        m || u(!1);
      }
    })(), () => {
      m = !0;
    };
  }, [e, s]), Ie(() => {
    if (!i.length) return;
    i.some((O) => O.id === d) || h(i[0].id);
  }, [i, d, h]), /* @__PURE__ */ p.jsx(
    ja.Provider,
    {
      value: { orgs: i, activeOrgId: d, setActiveOrgId: h, loading: a, error: c, isSuper: s },
      children: t
    }
  );
}, ri = () => Kn(ja), Ls = "common-fe.activeShowId", ka = Jn({
  shows: [],
  activeShowId: null,
  activeShow: null,
  setActiveShowId: () => {
  },
  loading: !1,
  error: null
}), fl = () => {
  try {
    return window.localStorage.getItem(Ls) || null;
  } catch {
    return null;
  }
}, hl = (e) => {
  try {
    e ? window.localStorage.setItem(Ls, e) : window.localStorage.removeItem(Ls);
  } catch {
  }
}, jp = ({ listShows: e, orgId: t, children: n }) => {
  const [r, s] = Z([]), [i, o] = Z(!0), [a, u] = Z(null), [c, l] = Z(() => fl()), d = Lt((v) => {
    l(v), hl(v);
  }, []);
  Ie(() => {
    if (!e) {
      o(!1);
      return;
    }
    let v = !1;
    return (async () => {
      try {
        o(!0), u(null);
        const m = await e();
        if (v) return;
        s(Array.isArray(m) ? m : []);
      } catch (m) {
        if (v) return;
        console.error("Failed to load shows for switcher:", m), u(m), s([]);
      } finally {
        v || o(!1);
      }
    })(), () => {
      v = !0;
    };
  }, [e, t]), Ie(() => {
    if (!r.length) return;
    r.some((m) => m.id === c) || d(r[0].id);
  }, [r, c, d]);
  const f = Fn(
    () => r.find((v) => v.id === c) || null,
    [r, c]
  ), h = Fn(
    () => ({ shows: r, activeShowId: c, activeShow: f, setActiveShowId: d, loading: i, error: a }),
    [r, c, f, d, i, a]
  );
  return /* @__PURE__ */ p.jsx(ka.Provider, { value: h, children: n });
}, pl = () => Kn(ka), kp = ({ onShowChange: e }) => {
  const { shows: t, activeShowId: n, setActiveShowId: r, loading: s } = pl();
  if (s && !t.length)
    return /* @__PURE__ */ p.jsx(
      Nr,
      {
        "data-testid": "show-switcher-loading",
        variant: "rounded",
        width: 140,
        height: 24,
        sx: { bgcolor: "rgba(255,255,255,0.18)" }
      }
    );
  if (!t || t.length === 0) return null;
  const i = (o) => {
    const a = o.target.value;
    r(a), e && e(a);
  };
  return /* @__PURE__ */ p.jsxs(
    Be,
    {
      "data-testid": "show-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        /* @__PURE__ */ p.jsx(Pc, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ p.jsx(
          va,
          {
            value: n || "",
            onChange: i,
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Show switcher" },
            renderValue: (o) => {
              const a = t.find((u) => u.id === o);
              return a ? a.name || a.id : "";
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 240,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: t.map((o) => /* @__PURE__ */ p.jsx(Ir, { value: o.id, children: o.name || o.id }, o.id))
          }
        )
      ]
    }
  );
}, Ia = Jn({
  appNamespace: null,
  isSuper: !1,
  permissions: /* @__PURE__ */ new Set()
}), ml = (e, t) => typeof t == "string" && t.includes(":") ? t : `${e}:${t}`, gl = (e) => {
  if (!e) return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  try {
    const t = Ta(e), n = t["custom:super"] ?? t.super, r = n === "true" || n === !0, s = new Set(
      Array.isArray(t.permissions) ? t.permissions : []
    );
    return { isSuper: r, permissions: s };
  } catch {
    return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  }
}, Ip = ({ appNamespace: e, children: t }) => {
  var i;
  const r = (i = Jt().user) == null ? void 0 : i.access_token, s = Fn(() => {
    const { isSuper: o, permissions: a } = gl(r);
    return { appNamespace: e, isSuper: o, permissions: a };
  }, [e, r]);
  return /* @__PURE__ */ p.jsx(Ia.Provider, { value: s, children: t });
}, Pp = (e) => {
  const { appNamespace: t, isSuper: n, permissions: r } = Kn(Ia);
  return n ? !0 : r.has(ml(t, e));
}, zn = (e) => typeof e == "string" ? e.trim() : "", Pa = (e) => zn(e == null ? void 0 : e.firstName) || zn(e == null ? void 0 : e.given_name), vl = (e) => zn(e == null ? void 0 : e.lastName) || zn(e == null ? void 0 : e.family_name), Aa = (e) => zn(e == null ? void 0 : e.email);
function bl(e) {
  return e ? [Pa(e), vl(e)].filter(Boolean).join(" ") || Aa(e) : "";
}
function Ap(e) {
  return e ? Pa(e) || Aa(e) : "";
}
const yl = (e, t) => e.length > t ? `${e.slice(0, Math.max(0, t - 1))}…` : e;
function wl({ maxEmailChars: e = 28 }) {
  var a;
  const n = ((a = Jt().user) == null ? void 0 : a.profile) || {}, r = (n.given_name || "").trim(), s = bl(n), i = (n.email || "").trim(), o = r || (i ? yl(i, e) : "");
  return o ? /* @__PURE__ */ p.jsx(Pr, { title: s || i, children: /* @__PURE__ */ p.jsx(
    Mn,
    {
      variant: "body2",
      noWrap: !0,
      "data-testid": "nav-user-name",
      sx: { color: "inherit", maxWidth: 220 },
      children: o
    }
  ) }) : null;
}
const Sl = () => {
  const { orgs: e, activeOrgId: t, setActiveOrgId: n, isSuper: r } = ri();
  return !e || e.length <= 1 ? null : /* @__PURE__ */ p.jsxs(
    Be,
    {
      "data-testid": "org-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        r && /* @__PURE__ */ p.jsx(
          ba,
          {
            size: "small",
            "data-testid": "super-badge",
            icon: /* @__PURE__ */ p.jsx(
              Uc,
              {
                fontSize: "small",
                sx: { color: "inherit !important" }
              }
            ),
            label: "All orgs",
            sx: {
              color: "inherit",
              bgcolor: "rgba(255, 255, 255, 0.18)",
              fontWeight: 600
            }
          }
        ),
        /* @__PURE__ */ p.jsx(Ac, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ p.jsx(
          va,
          {
            value: t || "",
            onChange: (s) => n(s.target.value),
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Organization switcher" },
            renderValue: (s) => {
              const i = e.find((o) => o.id === s);
              return i ? i.name : "";
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 220,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: e.map((s) => /* @__PURE__ */ p.jsx(Ir, { value: s.id, children: s.name }, s.id))
          }
        )
      ]
    }
  );
};
function Up({ onLogout: e, brandLogo: t = null }) {
  var u;
  const { mode: n, setMode: r } = ha(), { orgs: s, activeOrgId: i } = ri(), o = ((u = s.find((c) => c.id === i)) == null ? void 0 : u.name) || null, a = [
    {
      icon: n === "dark" ? /* @__PURE__ */ p.jsx(wa, {}) : /* @__PURE__ */ p.jsx(ya, {}),
      text: n === "dark" ? "Light mode" : "Dark mode",
      onClick: () => r(n === "dark" ? "light" : "dark")
    },
    {
      icon: /* @__PURE__ */ p.jsx(Sa, {}),
      text: "Sign out",
      onClick: e
    }
  ];
  return /* @__PURE__ */ p.jsx(
    zc,
    {
      sx: { backgroundColor: fa.darkGrey, color: "#fff" },
      brandLogo: t,
      rightContent: /* @__PURE__ */ p.jsxs(
        Be,
        {
          "data-testid": "gate-header",
          sx: { display: "flex", alignItems: "center", gap: 1.5 },
          children: [
            /* @__PURE__ */ p.jsx(Sl, {}),
            o && /* @__PURE__ */ p.jsx(
              Mn,
              {
                "data-testid": "gate-active-org-name",
                variant: "body2",
                sx: { color: "inherit", opacity: 0.9, whiteSpace: "nowrap" },
                children: o
              }
            ),
            /* @__PURE__ */ p.jsx(wl, {}),
            /* @__PURE__ */ p.jsx(Bc, { menuItems: a })
          ]
        }
      )
    }
  );
}
const Ua = "common-fe.mockAuth", La = Jn(null), xl = {
  email: "jaybill@foxvillage.com",
  displayName: "Jaybill"
};
function Rl() {
  try {
    const e = localStorage.getItem(Ua);
    return e ? JSON.parse(e) : { signedIn: !1, user: null };
  } catch {
    return { signedIn: !1, user: null };
  }
}
function Ol(e) {
  try {
    localStorage.setItem(Ua, JSON.stringify(e));
  } catch {
  }
}
function Lp({ children: e, defaultUser: t = xl }) {
  const [n, r] = Z(Rl);
  Ie(() => {
    Ol(n);
  }, [n]);
  const s = Lt(
    (a) => {
      r({ signedIn: !0, user: a ?? t });
    },
    [t]
  ), i = Lt(() => {
    r({ signedIn: !1, user: null });
  }, []), o = Fn(
    () => ({
      isAuthenticated: n.signedIn,
      user: n.user,
      signIn: s,
      signOut: i
    }),
    [n, s, i]
  );
  return /* @__PURE__ */ p.jsx(La.Provider, { value: o, children: e });
}
function Na() {
  const e = Kn(La);
  if (!e)
    throw new Error("useMockAuth must be used within a MockAuthProvider");
  return e;
}
function Np({ children: e, loginPath: t = "/login" }) {
  const { isAuthenticated: n } = Na(), r = Ic();
  return n ? e : /* @__PURE__ */ p.jsx(ga, { to: t, replace: !0, state: { from: r.pathname } });
}
const _l = "jaybill@foxvillage.com", El = "demo-password", Cl = {
  heading: "Sign in",
  subheading: "Sign in to your account.",
  emailLabel: "Email address",
  passwordLabel: "Password",
  showPassword: "Show password",
  forgotPassword: "Forgot your password?",
  submit: "Sign in",
  newUserPrompt: "New user?",
  createAccount: "Create an account"
};
function Dp({
  onSignIn: e,
  brandLogo: t,
  labels: n = {}
}) {
  const { signIn: r } = Na(), [s, i] = Z(_l), [o, a] = Z(El), [u, c] = Z(!1), l = { ...Cl, ...n }, d = (h) => {
    h.preventDefault();
    const v = { email: s, displayName: s.split("@")[0] };
    e ? e(v) : r(v);
  }, f = t ?? vc;
  return /* @__PURE__ */ p.jsx(
    ye,
    {
      sx: {
        minHeight: "100vh",
        width: "100%",
        bgcolor: (h) => h.palette.mode === "dark" ? "#2a2a2a" : "grey.100",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2
      },
      children: /* @__PURE__ */ p.jsxs(
        Ar,
        {
          elevation: 6,
          sx: {
            width: "100%",
            maxWidth: 480,
            p: { xs: 3, sm: 5 },
            bgcolor: (h) => h.palette.mode === "dark" ? "#000" : "background.paper",
            color: (h) => h.palette.mode === "dark" ? "#fff" : "text.primary",
            borderRadius: 3
          },
          children: [
            /* @__PURE__ */ p.jsx(
              ye,
              {
                sx: {
                  display: "flex",
                  justifyContent: "center",
                  mb: 4,
                  color: "inherit"
                },
                children: /* @__PURE__ */ p.jsx(f, { style: { width: 240, height: "auto" } })
              }
            ),
            /* @__PURE__ */ p.jsx(Xe, { variant: "h4", component: "h1", fontWeight: 700, gutterBottom: !0, children: l.heading }),
            /* @__PURE__ */ p.jsx(
              Xe,
              {
                variant: "body1",
                sx: { opacity: 0.7, mb: 4 },
                children: l.subheading
              }
            ),
            /* @__PURE__ */ p.jsx(ye, { component: "form", onSubmit: d, children: /* @__PURE__ */ p.jsxs(ln, { spacing: 3, children: [
              /* @__PURE__ */ p.jsx(
                $n,
                {
                  label: l.emailLabel,
                  type: "email",
                  fullWidth: !0,
                  value: s,
                  onChange: (h) => i(h.target.value),
                  InputLabelProps: {
                    sx: { fontWeight: 600 }
                  }
                }
              ),
              /* @__PURE__ */ p.jsxs(ye, { children: [
                /* @__PURE__ */ p.jsx(
                  $n,
                  {
                    label: l.passwordLabel,
                    type: u ? "text" : "password",
                    fullWidth: !0,
                    value: o,
                    onChange: (h) => a(h.target.value),
                    InputLabelProps: {
                      sx: { fontWeight: 600 }
                    }
                  }
                ),
                /* @__PURE__ */ p.jsxs(
                  ln,
                  {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: { mt: 1 },
                    children: [
                      /* @__PURE__ */ p.jsx(
                        la,
                        {
                          control: /* @__PURE__ */ p.jsx(
                            da,
                            {
                              size: "small",
                              checked: u,
                              onChange: (h) => c(h.target.checked),
                              sx: { color: "inherit" }
                            }
                          ),
                          label: l.showPassword
                        }
                      ),
                      /* @__PURE__ */ p.jsx(
                        Pi,
                        {
                          component: "button",
                          type: "button",
                          underline: "hover",
                          onClick: () => {
                          },
                          sx: { color: "primary.light" },
                          children: l.forgotPassword
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ p.jsx(
                Ge,
                {
                  type: "submit",
                  variant: "contained",
                  fullWidth: !0,
                  size: "large",
                  sx: { py: 1.5, fontWeight: 600 },
                  children: l.submit
                }
              ),
              /* @__PURE__ */ p.jsxs(
                Xe,
                {
                  variant: "body2",
                  align: "center",
                  sx: { opacity: 0.8 },
                  children: [
                    l.newUserPrompt,
                    " ",
                    /* @__PURE__ */ p.jsx(
                      Pi,
                      {
                        component: "button",
                        type: "button",
                        underline: "hover",
                        onClick: () => {
                        },
                        sx: { color: "primary.light" },
                        children: l.createAccount
                      }
                    )
                  ]
                }
              )
            ] }) })
          ]
        }
      )
    }
  );
}
var Fr = { d: (e, t) => {
  for (var n in t) Fr.o(t, n) && !Fr.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
}, o: (e, t) => Object.prototype.hasOwnProperty.call(e, t), r: (e) => {
  typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
} }, Ns = {};
function Da(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
Fr.r(Ns), Fr.d(Ns, { hasBrowserEnv: () => ii, hasStandardBrowserEnv: () => Wl, hasStandardBrowserWebWorkerEnv: () => Vl, navigator: () => Ds, origin: () => Jl });
const { toString: Tl } = Object.prototype, { getPrototypeOf: si } = Object, { iterator: vr, toStringTag: Fa } = Symbol, $r = (hs = /* @__PURE__ */ Object.create(null), (e) => {
  const t = Tl.call(e);
  return hs[t] || (hs[t] = t.slice(8, -1).toLowerCase());
});
var hs;
const gt = (e) => (e = e.toLowerCase(), (t) => $r(t) === e), ns = (e) => (t) => typeof t === e, { isArray: Qt } = Array, sn = ns("undefined");
function Ln(e) {
  return e !== null && !sn(e) && e.constructor !== null && !sn(e.constructor) && Je(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Ni = gt("ArrayBuffer"), jl = ns("string"), Je = ns("function"), Di = ns("number"), On = (e) => e !== null && typeof e == "object", nr = (e) => {
  if ($r(e) !== "object") return !1;
  const t = si(e);
  return !(t !== null && t !== Object.prototype && Object.getPrototypeOf(t) !== null || Fa in e || vr in e);
}, kl = gt("Date"), Il = gt("File"), Pl = gt("Blob"), Al = gt("FileList"), Ul = gt("URLSearchParams"), [Ll, Nl, Dl, Fl] = ["ReadableStream", "Request", "Response", "Headers"].map(gt);
function An(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e == null) return;
  let r, s;
  if (typeof e != "object" && (e = [e]), Qt(e)) for (r = 0, s = e.length; r < s; r++) t.call(null, e[r], r, e);
  else {
    if (Ln(e)) return;
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let a;
    for (r = 0; r < o; r++) a = i[r], t.call(null, e[a], a, e);
  }
}
function Fi(e, t) {
  if (Ln(e)) return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r, s = n.length;
  for (; s-- > 0; ) if (r = n[s], t === r.toLowerCase()) return r;
  return null;
}
const qt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, $i = (e) => !sn(e) && e !== qt, $l = (ps = typeof Uint8Array < "u" && si(Uint8Array), (e) => ps && e instanceof ps);
var ps;
const Bl = gt("HTMLFormElement"), Bi = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Ml = gt("RegExp"), Mi = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  An(n, (s, i) => {
    let o;
    (o = t(s, i, e)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(e, r);
}, zl = gt("AsyncFunction"), $a = (zi = typeof setImmediate == "function", qi = Je(qt.postMessage), zi ? setImmediate : qi ? (ms = `axios@${Math.random()}`, rr = [], qt.addEventListener("message", ({ source: e, data: t }) => {
  e === qt && t === ms && rr.length && rr.shift()();
}, !1), (e) => {
  rr.push(e), qt.postMessage(ms, "*");
}) : (e) => setTimeout(e));
var zi, qi, ms, rr;
const ql = typeof queueMicrotask < "u" ? queueMicrotask.bind(qt) : typeof process < "u" && process.nextTick || $a, b = { isArray: Qt, isArrayBuffer: Ni, isBuffer: Ln, isFormData: (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Je(e.append) && ((t = $r(e)) === "formdata" || t === "object" && Je(e.toString) && e.toString() === "[object FormData]"));
}, isArrayBufferView: function(e) {
  let t;
  return t = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && Ni(e.buffer), t;
}, isString: jl, isNumber: Di, isBoolean: (e) => e === !0 || e === !1, isObject: On, isPlainObject: nr, isEmptyObject: (e) => {
  if (!On(e) || Ln(e)) return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, isReadableStream: Ll, isRequest: Nl, isResponse: Dl, isHeaders: Fl, isUndefined: sn, isDate: kl, isFile: Il, isBlob: Pl, isRegExp: Ml, isFunction: Je, isStream: (e) => On(e) && Je(e.pipe), isURLSearchParams: Ul, isTypedArray: $l, isFileList: Al, forEach: An, merge: function e() {
  const { caseless: t, skipUndefined: n } = $i(this) && this || {}, r = {}, s = (i, o) => {
    const a = t && Fi(r, o) || o;
    nr(r[a]) && nr(i) ? r[a] = e(r[a], i) : nr(i) ? r[a] = e({}, i) : Qt(i) ? r[a] = i.slice() : n && sn(i) || (r[a] = i);
  };
  for (let i = 0, o = arguments.length; i < o; i++) arguments[i] && An(arguments[i], s);
  return r;
}, extend: (e, t, n, { allOwnKeys: r } = {}) => (An(t, (s, i) => {
  n && Je(s) ? e[i] = Da(s, n) : e[i] = s;
}, { allOwnKeys: r }), e), trim: (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), inherits: (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", { value: t.prototype }), n && Object.assign(e.prototype, n);
}, toFlatObject: (e, t, n, r) => {
  let s, i, o;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; ) o = s[i], r && !r(o, e, t) || a[o] || (t[o] = e[o], a[o] = !0);
    e = n !== !1 && si(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, kindOf: $r, kindOfTest: gt, endsWith: (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, toArray: (e) => {
  if (!e) return null;
  if (Qt(e)) return e;
  let t = e.length;
  if (!Di(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; ) n[t] = e[t];
  return n;
}, forEachEntry: (e, t) => {
  const n = (e && e[vr]).call(e);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const s = r.value;
    t.call(e, s[0], s[1]);
  }
}, matchAll: (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; ) r.push(n);
  return r;
}, isHTMLForm: Bl, hasOwnProperty: Bi, hasOwnProp: Bi, reduceDescriptors: Mi, freezeMethods: (e) => {
  Mi(e, (t, n) => {
    if (Je(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1) return !1;
    const r = e[n];
    Je(r) && (t.enumerable = !1, "writable" in t ? t.writable = !1 : t.set || (t.set = () => {
      throw Error("Can not rewrite read-only method '" + n + "'");
    }));
  });
}, toObjectSet: (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return Qt(e) ? r(e) : r(String(e).split(t)), n;
}, toCamelCase: (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, n, r) {
  return n.toUpperCase() + r;
}), noop: () => {
}, toFiniteNumber: (e, t) => e != null && Number.isFinite(e = +e) ? e : t, findKey: Fi, global: qt, isContextDefined: $i, isSpecCompliantForm: function(e) {
  return !!(e && Je(e.append) && e[Fa] === "FormData" && e[vr]);
}, toJSONObject: (e) => {
  const t = new Array(10), n = (r, s) => {
    if (On(r)) {
      if (t.indexOf(r) >= 0) return;
      if (Ln(r)) return r;
      if (!("toJSON" in r)) {
        t[s] = r;
        const i = Qt(r) ? [] : {};
        return An(r, (o, a) => {
          const u = n(o, s + 1);
          !sn(u) && (i[a] = u);
        }), t[s] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, isAsyncFn: zl, isThenable: (e) => e && (On(e) || Je(e)) && Je(e.then) && Je(e.catch), setImmediate: $a, asap: ql, isIterable: (e) => e != null && Je(e[vr]) };
function on(e, t, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
b.inherits(on, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: b.toJSONObject(this.config), code: this.code, status: this.status };
} });
const Hi = on.prototype, Zi = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((e) => {
  Zi[e] = { value: e };
}), Object.defineProperties(on, Zi), Object.defineProperty(Hi, "isAxiosError", { value: !0 }), on.from = (e, t, n, r, s, i) => {
  const o = Object.create(Hi);
  b.toFlatObject(e, o, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const a = e && e.message ? e.message : "Error", u = t == null && e ? e.code : t;
  return on.call(o, a, u, n, r, s), e && o.cause == null && Object.defineProperty(o, "cause", { value: e, configurable: !0 }), o.name = e && e.name || "Error", i && Object.assign(o, i), o;
};
const ee = on;
function gs(e) {
  return b.isPlainObject(e) || b.isArray(e);
}
function Ba(e) {
  return b.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Gi(e, t, n) {
  return e ? e.concat(t).map(function(r, s) {
    return r = Ba(r), !n && s ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
const Hl = b.toFlatObject(b, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
}), Br = function(e, t, n) {
  if (!b.isObject(e)) throw new TypeError("target must be an object");
  t = t || new FormData();
  const r = (n = b.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(f, h) {
    return !b.isUndefined(h[f]);
  })).metaTokens, s = n.visitor || c, i = n.dots, o = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && b.isSpecCompliantForm(t);
  if (!b.isFunction(s)) throw new TypeError("visitor must be a function");
  function u(f) {
    if (f === null) return "";
    if (b.isDate(f)) return f.toISOString();
    if (b.isBoolean(f)) return f.toString();
    if (!a && b.isBlob(f)) throw new ee("Blob is not supported. Use a Buffer instead.");
    return b.isArrayBuffer(f) || b.isTypedArray(f) ? a && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, h, v) {
    let m = f;
    if (f && !v && typeof f == "object") {
      if (b.endsWith(h, "{}")) h = r ? h : h.slice(0, -2), f = JSON.stringify(f);
      else if (b.isArray(f) && function(O) {
        return b.isArray(O) && !O.some(gs);
      }(f) || (b.isFileList(f) || b.endsWith(h, "[]")) && (m = b.toArray(f))) return h = Ba(h), m.forEach(function(O, K) {
        !b.isUndefined(O) && O !== null && t.append(o === !0 ? Gi([h], K, i) : o === null ? h : h + "[]", u(O));
      }), !1;
    }
    return !!gs(f) || (t.append(Gi(v, h, i), u(f)), !1);
  }
  const l = [], d = Object.assign(Hl, { defaultVisitor: c, convertValue: u, isVisitable: gs });
  if (!b.isObject(e)) throw new TypeError("data must be an object");
  return function f(h, v) {
    if (!b.isUndefined(h)) {
      if (l.indexOf(h) !== -1) throw Error("Circular reference detected in " + v.join("."));
      l.push(h), b.forEach(h, function(m, O) {
        (!(b.isUndefined(m) || m === null) && s.call(t, m, b.isString(O) ? O.trim() : O, v, d)) === !0 && f(m, v ? v.concat(O) : [O]);
      }), l.pop();
    }
  }(e), t;
};
function Wi(e) {
  const t = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Ma(e, t) {
  this._pairs = [], e && Br(e, this, t);
}
const Vi = Ma.prototype;
Vi.append = function(e, t) {
  this._pairs.push([e, t]);
}, Vi.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, Wi);
  } : Wi;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
const za = Ma;
function Zl(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function qa(e, t, n) {
  if (!t) return e;
  const r = n && n.encode || Zl;
  b.isFunction(n) && (n = { serialize: n });
  const s = n && n.serialize;
  let i;
  if (i = s ? s(t, n) : b.isURLSearchParams(t) ? t.toString() : new za(t, n).toString(r), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
const Ji = class {
  constructor() {
    this.handlers = [];
  }
  use(t, n, r) {
    return this.handlers.push({ fulfilled: t, rejected: n, synchronous: !!r && r.synchronous, runWhen: r ? r.runWhen : null }), this.handlers.length - 1;
  }
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(t) {
    b.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}, Ha = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, Gl = { isBrowser: !0, classes: { URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : za, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, protocols: ["http", "https", "file", "blob", "url", "data"] }, ii = typeof window < "u" && typeof document < "u", Ds = typeof navigator == "object" && navigator || void 0, Wl = ii && (!Ds || ["ReactNative", "NativeScript", "NS"].indexOf(Ds.product) < 0), Vl = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Jl = ii && window.location.href || "http://localhost", qe = { ...Ns, ...Gl }, Za = function(e) {
  function t(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), u = i >= n.length;
    return o = !o && b.isArray(s) ? s.length : o, u ? (b.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !a) : (s[o] && b.isObject(s[o]) || (s[o] = []), t(n, r, s[o], i) && b.isArray(s[o]) && (s[o] = function(c) {
      const l = {}, d = Object.keys(c);
      let f;
      const h = d.length;
      let v;
      for (f = 0; f < h; f++) v = d[f], l[v] = c[v];
      return l;
    }(s[o])), !a);
  }
  if (b.isFormData(e) && b.isFunction(e.entries)) {
    const n = {};
    return b.forEachEntry(e, (r, s) => {
      t(function(i) {
        return b.matchAll(/\w+|\[(\w*)]/g, i).map((o) => o[0] === "[]" ? "" : o[1] || o[0]);
      }(r), s, n, 0);
    }), n;
  }
  return null;
}, oi = { transitional: Ha, adapter: ["xhr", "http", "fetch"], transformRequest: [function(e, t) {
  const n = t.getContentType() || "", r = n.indexOf("application/json") > -1, s = b.isObject(e);
  if (s && b.isHTMLForm(e) && (e = new FormData(e)), b.isFormData(e)) return r ? JSON.stringify(Za(e)) : e;
  if (b.isArrayBuffer(e) || b.isBuffer(e) || b.isStream(e) || b.isFile(e) || b.isBlob(e) || b.isReadableStream(e)) return e;
  if (b.isArrayBufferView(e)) return e.buffer;
  if (b.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
  let i;
  if (s) {
    if (n.indexOf("application/x-www-form-urlencoded") > -1) return function(o, a) {
      return Br(o, new qe.classes.URLSearchParams(), { visitor: function(u, c, l, d) {
        return qe.isNode && b.isBuffer(u) ? (this.append(c, u.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
      }, ...a });
    }(e, this.formSerializer).toString();
    if ((i = b.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
      const o = this.env && this.env.FormData;
      return Br(i ? { "files[]": e } : e, o && new o(), this.formSerializer);
    }
  }
  return s || r ? (t.setContentType("application/json", !1), function(o) {
    if (b.isString(o)) try {
      return (0, JSON.parse)(o), b.trim(o);
    } catch (a) {
      if (a.name !== "SyntaxError") throw a;
    }
    return (0, JSON.stringify)(o);
  }(e)) : e;
}], transformResponse: [function(e) {
  const t = this.transitional || oi.transitional, n = t && t.forcedJSONParsing, r = this.responseType === "json";
  if (b.isResponse(e) || b.isReadableStream(e)) return e;
  if (e && b.isString(e) && (n && !this.responseType || r)) {
    const s = !(t && t.silentJSONParsing) && r;
    try {
      return JSON.parse(e, this.parseReviver);
    } catch (i) {
      if (s)
        throw i.name === "SyntaxError" ? ee.from(i, ee.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return e;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: qe.classes.FormData, Blob: qe.classes.Blob }, validateStatus: function(e) {
  return e >= 200 && e < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
b.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  oi.headers[e] = {};
});
const ai = oi, Kl = b.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), Ki = Symbol("internals");
function _n(e) {
  return e && String(e).trim().toLowerCase();
}
function br(e) {
  return e === !1 || e == null ? e : b.isArray(e) ? e.map(br) : String(e);
}
function vs(e, t, n, r, s) {
  return b.isFunction(r) ? r.call(this, t, n) : (s && (t = n), b.isString(t) ? b.isString(r) ? t.indexOf(r) !== -1 : b.isRegExp(r) ? r.test(t) : void 0 : void 0);
}
let yr = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function i(a, u, c) {
      const l = _n(u);
      if (!l) throw new Error("header name must be a non-empty string");
      const d = b.findKey(s, l);
      (!d || s[d] === void 0 || c === !0 || c === void 0 && s[d] !== !1) && (s[d || u] = br(a));
    }
    const o = (a, u) => b.forEach(a, (c, l) => i(c, l, u));
    if (b.isPlainObject(t) || t instanceof this.constructor) o(t, n);
    else if (b.isString(t) && (t = t.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim())) o(((a) => {
      const u = {};
      let c, l, d;
      return a && a.split(`
`).forEach(function(f) {
        d = f.indexOf(":"), c = f.substring(0, d).trim().toLowerCase(), l = f.substring(d + 1).trim(), !c || u[c] && Kl[c] || (c === "set-cookie" ? u[c] ? u[c].push(l) : u[c] = [l] : u[c] = u[c] ? u[c] + ", " + l : l);
      }), u;
    })(t), n);
    else if (b.isObject(t) && b.isIterable(t)) {
      let a, u, c = {};
      for (const l of t) {
        if (!b.isArray(l)) throw TypeError("Object iterator must return a key-value pair");
        c[u = l[0]] = (a = c[u]) ? b.isArray(a) ? [...a, l[1]] : [a, l[1]] : l[1];
      }
      o(c, n);
    } else t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = _n(t)) {
      const r = b.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n) return s;
        if (n === !0) return function(i) {
          const o = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
          let u;
          for (; u = a.exec(i); ) o[u[1]] = u[2];
          return o;
        }(s);
        if (b.isFunction(n)) return n.call(this, s, r);
        if (b.isRegExp(n)) return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = _n(t)) {
      const r = b.findKey(this, t);
      return !(!r || this[r] === void 0 || n && !vs(0, this[r], r, n));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = _n(o)) {
        const a = b.findKey(r, o);
        !a || n && !vs(0, r[a], a, n) || (delete r[a], s = !0);
      }
    }
    return b.isArray(t) ? t.forEach(i) : i(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      t && !vs(0, this[i], i, t, !0) || (delete this[i], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return b.forEach(this, (s, i) => {
      const o = b.findKey(r, i);
      if (o) return n[o] = br(s), void delete n[i];
      const a = t ? function(u) {
        return u.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (c, l, d) => l.toUpperCase() + d);
      }(i) : String(i).trim();
      a !== i && delete n[i], n[a] = br(s), r[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return b.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && b.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const n = (this[Ki] = this[Ki] = { accessors: {} }).accessors, r = this.prototype;
    function s(i) {
      const o = _n(i);
      n[o] || (function(a, u) {
        const c = b.toCamelCase(" " + u);
        ["get", "set", "has"].forEach((l) => {
          Object.defineProperty(a, l + c, { value: function(d, f, h) {
            return this[l].call(this, u, d, f, h);
          }, configurable: !0 });
        });
      }(r, i), n[o] = !0);
    }
    return b.isArray(t) ? t.forEach(s) : s(t), this;
  }
};
yr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), b.reduceDescriptors(yr.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return { get: () => e, set(r) {
    this[n] = r;
  } };
}), b.freezeMethods(yr);
const pt = yr;
function bs(e, t) {
  const n = this || ai, r = t || n, s = pt.from(r.headers);
  let i = r.data;
  return b.forEach(e, function(o) {
    i = o.call(n, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function Ga(e) {
  return !(!e || !e.__CANCEL__);
}
function Wa(e, t, n) {
  ee.call(this, e ?? "canceled", ee.ERR_CANCELED, t, n), this.name = "CanceledError";
}
b.inherits(Wa, ee, { __CANCEL__: !0 });
const Xn = Wa;
function Va(e, t, n) {
  const r = n.config.validateStatus;
  n.status && r && !r(n.status) ? t(new ee("Request failed with status code " + n.status, [ee.ERR_BAD_REQUEST, ee.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : e(n);
}
const Mr = (e, t, n = 3) => {
  let r = 0;
  const s = function(i, o) {
    i = i || 10;
    const a = new Array(i), u = new Array(i);
    let c, l = 0, d = 0;
    return o = o !== void 0 ? o : 1e3, function(f) {
      const h = Date.now(), v = u[d];
      c || (c = h), a[l] = f, u[l] = h;
      let m = d, O = 0;
      for (; m !== l; ) O += a[m++], m %= i;
      if (l = (l + 1) % i, l === d && (d = (d + 1) % i), h - c < o) return;
      const K = v && h - v;
      return K ? Math.round(1e3 * O / K) : void 0;
    };
  }(50, 250);
  return function(i, o) {
    let a, u, c = 0, l = 1e3 / o;
    const d = (f, h = Date.now()) => {
      c = h, a = null, u && (clearTimeout(u), u = null), i(...f);
    };
    return [(...f) => {
      const h = Date.now(), v = h - c;
      v >= l ? d(f, h) : (a = f, u || (u = setTimeout(() => {
        u = null, d(a);
      }, l - v)));
    }, () => a && d(a)];
  }((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, u = o - r, c = s(u);
    r = o, e({ loaded: o, total: a, progress: a ? o / a : void 0, bytes: u, rate: c || void 0, estimated: c && a && o <= a ? (a - o) / c : void 0, event: i, lengthComputable: a != null, [t ? "download" : "upload"]: !0 });
  }, n);
}, Yi = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({ lengthComputable: n, total: e, loaded: r }), t[1]];
}, Xi = (e) => (...t) => b.asap(() => e(...t)), Yl = qe.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, qe.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(qe.origin), qe.navigator && /(msie|trident)/i.test(qe.navigator.userAgent)) : () => !0, Xl = qe.hasStandardBrowserEnv ? { write(e, t, n, r, s, i, o) {
  if (typeof document > "u") return;
  const a = [`${e}=${encodeURIComponent(t)}`];
  b.isNumber(n) && a.push(`expires=${new Date(n).toUTCString()}`), b.isString(r) && a.push(`path=${r}`), b.isString(s) && a.push(`domain=${s}`), i === !0 && a.push("secure"), b.isString(o) && a.push(`SameSite=${o}`), document.cookie = a.join("; ");
}, read(e) {
  if (typeof document > "u") return null;
  const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
  return t ? decodeURIComponent(t[1]) : null;
}, remove(e) {
  this.write(e, "", Date.now() - 864e5, "/");
} } : { write() {
}, read: () => null, remove() {
} };
function Ja(e, t, n) {
  let r = !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
  return e && (r || n == 0) ? function(s, i) {
    return i ? s.replace(/\/?\/$/, "") + "/" + i.replace(/^\/+/, "") : s;
  }(e, t) : t;
}
const Qi = (e) => e instanceof pt ? { ...e } : e;
function Gt(e, t) {
  t = t || {};
  const n = {};
  function r(c, l, d, f) {
    return b.isPlainObject(c) && b.isPlainObject(l) ? b.merge.call({ caseless: f }, c, l) : b.isPlainObject(l) ? b.merge({}, l) : b.isArray(l) ? l.slice() : l;
  }
  function s(c, l, d, f) {
    return b.isUndefined(l) ? b.isUndefined(c) ? void 0 : r(void 0, c, 0, f) : r(c, l, 0, f);
  }
  function i(c, l) {
    if (!b.isUndefined(l)) return r(void 0, l);
  }
  function o(c, l) {
    return b.isUndefined(l) ? b.isUndefined(c) ? void 0 : r(void 0, c) : r(void 0, l);
  }
  function a(c, l, d) {
    return d in t ? r(c, l) : d in e ? r(void 0, c) : void 0;
  }
  const u = { url: i, method: i, data: i, baseURL: o, transformRequest: o, transformResponse: o, paramsSerializer: o, timeout: o, timeoutMessage: o, withCredentials: o, withXSRFToken: o, adapter: o, responseType: o, xsrfCookieName: o, xsrfHeaderName: o, onUploadProgress: o, onDownloadProgress: o, decompress: o, maxContentLength: o, maxBodyLength: o, beforeRedirect: o, transport: o, httpAgent: o, httpsAgent: o, cancelToken: o, socketPath: o, responseEncoding: o, validateStatus: a, headers: (c, l, d) => s(Qi(c), Qi(l), 0, !0) };
  return b.forEach(Object.keys({ ...e, ...t }), function(c) {
    const l = u[c] || s, d = l(e[c], t[c], c);
    b.isUndefined(d) && l !== a || (n[c] = d);
  }), n;
}
const Ka = (e) => {
  const t = Gt({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = t;
  if (t.headers = o = pt.from(o), t.url = qa(Ja(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && o.set("Authorization", "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))), b.isFormData(n)) {
    if (qe.hasStandardBrowserEnv || qe.hasStandardBrowserWebWorkerEnv) o.setContentType(void 0);
    else if (b.isFunction(n.getHeaders)) {
      const u = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(u).forEach(([l, d]) => {
        c.includes(l.toLowerCase()) && o.set(l, d);
      });
    }
  }
  if (qe.hasStandardBrowserEnv && (r && b.isFunction(r) && (r = r(t)), r || r !== !1 && Yl(t.url))) {
    const u = s && i && Xl.read(i);
    u && o.set(s, u);
  }
  return t;
}, Ql = typeof XMLHttpRequest < "u" && function(e) {
  return new Promise(function(t, n) {
    const r = Ka(e);
    let s = r.data;
    const i = pt.from(r.headers).normalize();
    let o, a, u, c, l, { responseType: d, onUploadProgress: f, onDownloadProgress: h } = r;
    function v() {
      c && c(), l && l(), r.cancelToken && r.cancelToken.unsubscribe(o), r.signal && r.signal.removeEventListener("abort", o);
    }
    let m = new XMLHttpRequest();
    function O() {
      if (!m) return;
      const C = pt.from("getAllResponseHeaders" in m && m.getAllResponseHeaders());
      Va(function(J) {
        t(J), v();
      }, function(J) {
        n(J), v();
      }, { data: d && d !== "text" && d !== "json" ? m.response : m.responseText, status: m.status, statusText: m.statusText, headers: C, config: e, request: m }), m = null;
    }
    m.open(r.method.toUpperCase(), r.url, !0), m.timeout = r.timeout, "onloadend" in m ? m.onloadend = O : m.onreadystatechange = function() {
      m && m.readyState === 4 && (m.status !== 0 || m.responseURL && m.responseURL.indexOf("file:") === 0) && setTimeout(O);
    }, m.onabort = function() {
      m && (n(new ee("Request aborted", ee.ECONNABORTED, e, m)), m = null);
    }, m.onerror = function(C) {
      const J = C && C.message ? C.message : "Network Error", H = new ee(J, ee.ERR_NETWORK, e, m);
      H.event = C || null, n(H), m = null;
    }, m.ontimeout = function() {
      let C = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const J = r.transitional || Ha;
      r.timeoutErrorMessage && (C = r.timeoutErrorMessage), n(new ee(C, J.clarifyTimeoutError ? ee.ETIMEDOUT : ee.ECONNABORTED, e, m)), m = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in m && b.forEach(i.toJSON(), function(C, J) {
      m.setRequestHeader(J, C);
    }), b.isUndefined(r.withCredentials) || (m.withCredentials = !!r.withCredentials), d && d !== "json" && (m.responseType = r.responseType), h && ([u, l] = Mr(h, !0), m.addEventListener("progress", u)), f && m.upload && ([a, c] = Mr(f), m.upload.addEventListener("progress", a), m.upload.addEventListener("loadend", c)), (r.cancelToken || r.signal) && (o = (C) => {
      m && (n(!C || C.type ? new Xn(null, e, m) : C), m.abort(), m = null);
    }, r.cancelToken && r.cancelToken.subscribe(o), r.signal && (r.signal.aborted ? o() : r.signal.addEventListener("abort", o)));
    const K = function(C) {
      const J = /^([-+\w]{1,25})(:?\/\/|:)/.exec(C);
      return J && J[1] || "";
    }(r.url);
    K && qe.protocols.indexOf(K) === -1 ? n(new ee("Unsupported protocol " + K + ":", ee.ERR_BAD_REQUEST, e)) : m.send(s || null);
  });
}, ed = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r, s = new AbortController();
    const i = function(c) {
      if (!r) {
        r = !0, a();
        const l = c instanceof Error ? c : this.reason;
        s.abort(l instanceof ee ? l : new Xn(l instanceof Error ? l.message : l));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new ee(`timeout ${t} of ms exceeded`, ee.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: u } = s;
    return u.unsubscribe = () => b.asap(a), u;
  }
}, td = function* (e, t) {
  let n = e.byteLength;
  if (n < t) return void (yield e);
  let r, s = 0;
  for (; s < n; ) r = s + t, yield e.slice(s, r), s = r;
}, eo = (e, t, n, r) => {
  const s = async function* (u, c) {
    for await (const l of async function* (d) {
      if (d[Symbol.asyncIterator]) return void (yield* d);
      const f = d.getReader();
      try {
        for (; ; ) {
          const { done: h, value: v } = await f.read();
          if (h) break;
          yield v;
        }
      } finally {
        await f.cancel();
      }
    }(u)) yield* td(l, c);
  }(e, t);
  let i, o = 0, a = (u) => {
    i || (i = !0, r && r(u));
  };
  return new ReadableStream({ async pull(u) {
    try {
      const { done: c, value: l } = await s.next();
      if (c) return a(), void u.close();
      let d = l.byteLength;
      if (n) {
        let f = o += d;
        n(f);
      }
      u.enqueue(new Uint8Array(l));
    } catch (c) {
      throw a(c), c;
    }
  }, cancel: (u) => (a(u), s.return()) }, { highWaterMark: 2 });
}, { isFunction: sr } = b, nd = (({ Request: e, Response: t }) => ({ Request: e, Response: t }))(b.global), { ReadableStream: to, TextEncoder: no } = b.global, ro = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, rd = (e) => {
  e = b.merge.call({ skipUndefined: !0 }, nd, e);
  const { fetch: t, Request: n, Response: r } = e, s = t ? sr(t) : typeof fetch == "function", i = sr(n), o = sr(r);
  if (!s) return !1;
  const a = s && sr(to), u = s && (typeof no == "function" ? (c = new no(), (h) => c.encode(h)) : async (h) => new Uint8Array(await new n(h).arrayBuffer()));
  var c;
  const l = i && a && ro(() => {
    let h = !1;
    const v = new n(qe.origin, { body: new to(), method: "POST", get duplex() {
      return h = !0, "half";
    } }).headers.has("Content-Type");
    return h && !v;
  }), d = o && a && ro(() => b.isReadableStream(new r("").body)), f = { stream: d && ((h) => h.body) };
  return s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((h) => {
    !f[h] && (f[h] = (v, m) => {
      let O = v && v[h];
      if (O) return O.call(v);
      throw new ee(`Response type '${h}' is not supported`, ee.ERR_NOT_SUPPORT, m);
    });
  }), async (h) => {
    let { url: v, method: m, data: O, signal: K, cancelToken: C, timeout: J, onDownloadProgress: H, onUploadProgress: ie, responseType: Q, headers: De, withCredentials: Te = "same-origin", fetchOptions: Ye } = Ka(h), at = t || fetch;
    Q = Q ? (Q + "").toLowerCase() : "text";
    let xe = ed([K, C && C.toAbortSignal()], J), Fe = null;
    const we = xe && xe.unsubscribe && (() => {
      xe.unsubscribe();
    });
    let ue;
    try {
      if (ie && l && m !== "get" && m !== "head" && (ue = await (async (Ee, Ce) => {
        const $e = b.toFiniteNumber(Ee.getContentLength());
        return $e ?? (async (Y) => Y == null ? 0 : b.isBlob(Y) ? Y.size : b.isSpecCompliantForm(Y) ? (await new n(qe.origin, { method: "POST", body: Y }).arrayBuffer()).byteLength : b.isArrayBufferView(Y) || b.isArrayBuffer(Y) ? Y.byteLength : (b.isURLSearchParams(Y) && (Y += ""), b.isString(Y) ? (await u(Y)).byteLength : void 0))(Ce);
      })(De, O)) !== 0) {
        let Ee, Ce = new n(v, { method: "POST", body: O, duplex: "half" });
        if (b.isFormData(O) && (Ee = Ce.headers.get("content-type")) && De.setContentType(Ee), Ce.body) {
          const [$e, Y] = Yi(ue, Mr(Xi(ie)));
          O = eo(Ce.body, 65536, $e, Y);
        }
      }
      b.isString(Te) || (Te = Te ? "include" : "omit");
      const le = i && "credentials" in n.prototype, st = { ...Ye, signal: xe, method: m.toUpperCase(), headers: De.normalize().toJSON(), body: O, duplex: "half", credentials: le ? Te : void 0 };
      Fe = i && new n(v, st);
      let ke = await (i ? at(Fe, Ye) : at(v, st));
      const bt = d && (Q === "stream" || Q === "response");
      if (d && (H || bt && we)) {
        const Ee = {};
        ["status", "statusText", "headers"].forEach((Re) => {
          Ee[Re] = ke[Re];
        });
        const Ce = b.toFiniteNumber(ke.headers.get("content-length")), [$e, Y] = H && Yi(Ce, Mr(Xi(H), !0)) || [];
        ke = new r(eo(ke.body, 65536, $e, () => {
          Y && Y(), we && we();
        }), Ee);
      }
      Q = Q || "text";
      let Tt = await f[b.findKey(f, Q) || "text"](ke, h);
      return !bt && we && we(), await new Promise((Ee, Ce) => {
        Va(Ee, Ce, { data: Tt, headers: pt.from(ke.headers), status: ke.status, statusText: ke.statusText, config: h, request: Fe });
      });
    } catch (le) {
      throw we && we(), le && le.name === "TypeError" && /Load failed|fetch/i.test(le.message) ? Object.assign(new ee("Network Error", ee.ERR_NETWORK, h, Fe), { cause: le.cause || le }) : ee.from(le, le && le.code, h, Fe);
    }
  };
}, sd = /* @__PURE__ */ new Map(), so = (e) => {
  let t = e && e.env || {};
  const { fetch: n, Request: r, Response: s } = t, i = [r, s, n];
  let o, a, u = i.length, c = sd;
  for (; u--; ) o = i[u], a = c.get(o), a === void 0 && c.set(o, a = u ? /* @__PURE__ */ new Map() : rd(t)), c = a;
  return a;
}, Ya = (so(), { http: null, xhr: Ql, fetch: { get: so } });
b.forEach(Ya, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const io = (e) => `- ${e}`, id = (e) => b.isFunction(e) || e === null || e === !1, Xa = function(e, t) {
  e = b.isArray(e) ? e : [e];
  const { length: n } = e;
  let r, s;
  const i = {};
  for (let o = 0; o < n; o++) {
    let a;
    if (r = e[o], s = r, !id(r) && (s = Ya[(a = String(r)).toLowerCase()], s === void 0)) throw new ee(`Unknown adapter '${a}'`);
    if (s && (b.isFunction(s) || (s = s.get(t)))) break;
    i[a || "#" + o] = s;
  }
  if (!s) {
    const o = Object.entries(i).map(([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build"));
    let a = n ? o.length > 1 ? `since :
` + o.map(io).join(`
`) : " " + io(o[0]) : "as no adapter specified";
    throw new ee("There is no suitable adapter to dispatch the request " + a, "ERR_NOT_SUPPORT");
  }
  return s;
};
function ys(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new Xn(null, e);
}
function oo(e) {
  return ys(e), e.headers = pt.from(e.headers), e.data = bs.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Xa(e.adapter || ai.adapter, e)(e).then(function(t) {
    return ys(e), t.data = bs.call(e, e.transformResponse, t), t.headers = pt.from(t.headers), t;
  }, function(t) {
    return Ga(t) || (ys(e), t && t.response && (t.response.data = bs.call(e, e.transformResponse, t.response), t.response.headers = pt.from(t.response.headers))), Promise.reject(t);
  });
}
const Qa = "1.13.2", zr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  zr[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ao = {};
zr.transitional = function(e, t, n) {
  function r(s, i) {
    return "[Axios v" + Qa + "] Transitional option '" + s + "'" + i + (n ? ". " + n : "");
  }
  return (s, i, o) => {
    if (e === !1) throw new ee(r(i, " has been removed" + (t ? " in " + t : "")), ee.ERR_DEPRECATED);
    return t && !ao[i] && (ao[i] = !0, console.warn(r(i, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(s, i, o);
  };
}, zr.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
const wr = { assertOptions: function(e, t, n) {
  if (typeof e != "object") throw new ee("options must be an object", ee.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = t[i];
    if (o) {
      const a = e[i], u = a === void 0 || o(a, i, e);
      if (u !== !0) throw new ee("option " + i + " must be " + u, ee.ERR_BAD_OPTION_VALUE);
    } else if (n !== !0) throw new ee("Unknown option " + i, ee.ERR_BAD_OPTION);
  }
}, validators: zr }, yt = wr.validators;
let Sr = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = { request: new Ji(), response: new Ji() };
  }
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}).url = t : n = t || {}, n = Gt(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && wr.assertOptions(r, { silentJSONParsing: yt.transitional(yt.boolean), forcedJSONParsing: yt.transitional(yt.boolean), clarifyTimeoutError: yt.transitional(yt.boolean) }, !1), s != null && (b.isFunction(s) ? n.paramsSerializer = { serialize: s } : wr.assertOptions(s, { encode: yt.function, serialize: yt.function }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), wr.assertOptions(n, { baseUrl: yt.spelling("baseURL"), withXsrfToken: yt.spelling("withXSRFToken") }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && b.merge(i.common, i[n.method]);
    i && b.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (v) => {
      delete i[v];
    }), n.headers = pt.concat(o, i);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(v) {
      typeof v.runWhen == "function" && v.runWhen(n) === !1 || (u = u && v.synchronous, a.unshift(v.fulfilled, v.rejected));
    });
    const c = [];
    let l;
    this.interceptors.response.forEach(function(v) {
      c.push(v.fulfilled, v.rejected);
    });
    let d, f = 0;
    if (!u) {
      const v = [oo.bind(this), void 0];
      for (v.unshift(...a), v.push(...c), d = v.length, l = Promise.resolve(n); f < d; ) l = l.then(v[f++], v[f++]);
      return l;
    }
    d = a.length;
    let h = n;
    for (; f < d; ) {
      const v = a[f++], m = a[f++];
      try {
        h = v(h);
      } catch (O) {
        m.call(this, O);
        break;
      }
    }
    try {
      l = oo.call(this, h);
    } catch (v) {
      return Promise.reject(v);
    }
    for (f = 0, d = c.length; f < d; ) l = l.then(c[f++], c[f++]);
    return l;
  }
  getUri(t) {
    return qa(Ja((t = Gt(this.defaults, t)).baseURL, t.url, t.allowAbsoluteUrls), t.params, t.paramsSerializer);
  }
};
b.forEach(["delete", "get", "head", "options"], function(e) {
  Sr.prototype[e] = function(t, n) {
    return this.request(Gt(n || {}, { method: e, url: t, data: (n || {}).data }));
  };
}), b.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(r, s, i) {
      return this.request(Gt(i || {}, { method: e, headers: n ? { "Content-Type": "multipart/form-data" } : {}, url: r, data: s }));
    };
  }
  Sr.prototype[e] = t(), Sr.prototype[e + "Form"] = t(!0);
});
const xr = Sr;
let od = class eu {
  constructor(t) {
    if (typeof t != "function") throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; ) r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, t(function(s, i, o) {
      r.reason || (r.reason = new Xn(s, i, o), n(r.reason));
    });
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(t) {
    this.reason ? t(this.reason) : this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  unsubscribe(t) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  static source() {
    let t;
    return { token: new eu(function(n) {
      t = n;
    }), cancel: t };
  }
};
const ad = od, Fs = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511, WebServerIsDown: 521, ConnectionTimedOut: 522, OriginIsUnreachable: 523, TimeoutOccurred: 524, SslHandshakeFailed: 525, InvalidSslCertificate: 526 };
Object.entries(Fs).forEach(([e, t]) => {
  Fs[t] = e;
});
const ud = Fs, Ue = function e(t) {
  const n = new xr(t), r = Da(xr.prototype.request, n);
  return b.extend(r, xr.prototype, n, { allOwnKeys: !0 }), b.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(s) {
    return e(Gt(t, s));
  }, r;
}(ai);
Ue.Axios = xr, Ue.CanceledError = Xn, Ue.CancelToken = ad, Ue.isCancel = Ga, Ue.VERSION = Qa, Ue.toFormData = Br, Ue.AxiosError = ee, Ue.Cancel = Ue.CanceledError, Ue.all = function(e) {
  return Promise.all(e);
}, Ue.spread = function(e) {
  return function(t) {
    return e.apply(null, t);
  };
}, Ue.isAxiosError = function(e) {
  return b.isObject(e) && e.isAxiosError === !0;
}, Ue.mergeConfig = Gt, Ue.AxiosHeaders = pt, Ue.formToJSON = (e) => Za(b.isHTMLForm(e) ? new FormData(e) : e), Ue.getAdapter = Xa, Ue.HttpStatusCode = ud, Ue.default = Ue;
const de = Ue;
function tu(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $s(e, t, n) {
  return $s = ui() ? Reflect.construct : function(r, s, i) {
    var o = [null];
    o.push.apply(o, s);
    var a = new (Function.bind.apply(r, o))();
    return i && Hn(a, i.prototype), a;
  }, $s.apply(null, arguments);
}
function Rr(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qn(e) {
  return qn = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, qn(e);
}
function Hn(e, t) {
  return Hn = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, Hn(e, t);
}
function Bs(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Bs = function(n) {
    if (n === null || (r = n, Function.toString.call(r).indexOf("[native code]") === -1)) return n;
    var r;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n)) return t.get(n);
      t.set(n, s);
    }
    function s() {
      return $s(n, arguments, qn(this).constructor);
    }
    return s.prototype = Object.create(n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), Hn(s, n);
  }, Bs(e);
}
function ui() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ui = function() {
    return !!e;
  })();
}
var fe = "http://localhost".replace(/\/+$/, ""), gn = function e(t) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fe, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : de;
  tu(this, e), Rr(this, "basePath", void 0), Rr(this, "axios", void 0), Rr(this, "configuration", void 0), this.basePath = r, this.axios = s, t && (this.configuration = t, this.basePath = (n = t.basePath) !== null && n !== void 0 ? n : r);
}, cd = function() {
  function e(t, n) {
    var r;
    return tu(this, e), Rr(r = function(s, i, o) {
      return i = qn(i), function(a, u) {
        return !u || ((c = u) && typeof Symbol < "u" && c.constructor === Symbol ? "symbol" : typeof c) != "object" && typeof u != "function" ? function(l) {
          if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return l;
        }(a) : u;
        var c;
      }(s, ui() ? Reflect.construct(i, o || [], qn(s).constructor) : i.apply(s, o));
    }(this, e, [n]), "field", void 0), r.field = t, r.name = "RequiredError", r;
  }
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(n && n.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), n && Hn(t, n);
  }(e, Bs(Error)), e;
}(), pe = {};
function uo(e, t, n, r, s, i, o) {
  try {
    var a = e[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? t(u) : Promise.resolve(u).then(r, s);
}
function ld(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var me = "https://example.com", ae = function(e, t, n) {
  if (n == null) throw new cd(t, "Required parameter ".concat(t, " was null or undefined when calling ").concat(e, "."));
}, _e = function(e, t) {
  return (n = function() {
    var r, s;
    return function(i, o) {
      var a, u, c, l = { label: 0, sent: function() {
        if (1 & c[0]) throw c[1];
        return c[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = f(0), d.throw = f(1), d.return = f(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function f(h) {
        return function(v) {
          return function(m) {
            if (a) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, m[0] && (l = 0)), l; ) try {
              if (a = 1, u && (c = 2 & m[0] ? u.return : m[0] ? u.throw || ((c = u.return) && c.call(u), 0) : u.next) && !(c = c.call(u, m[1])).done) return c;
              switch (u = 0, c && (m = [2 & m[0], c.value]), m[0]) {
                case 0:
                case 1:
                  c = m;
                  break;
                case 4:
                  return l.label++, { value: m[1], done: !1 };
                case 5:
                  l.label++, u = m[1], m = [0];
                  continue;
                case 7:
                  m = l.ops.pop(), l.trys.pop();
                  continue;
                default:
                  if (!((c = (c = l.trys).length > 0 && c[c.length - 1]) || m[0] !== 6 && m[0] !== 2)) {
                    l = 0;
                    continue;
                  }
                  if (m[0] === 3 && (!c || m[1] > c[0] && m[1] < c[3])) {
                    l.label = m[1];
                    break;
                  }
                  if (m[0] === 6 && l.label < c[1]) {
                    l.label = c[1], c = m;
                    break;
                  }
                  if (c && l.label < c[2]) {
                    l.label = c[2], l.ops.push(m);
                    break;
                  }
                  c[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }
              m = o.call(i, l);
            } catch (O) {
              m = [6, O], u = 0;
            } finally {
              a = c = 0;
            }
            if (5 & m[0]) throw m[1];
            return { value: m[0] ? m[1] : void 0, done: !0 };
          }([h, v]);
        };
      }
    }(this, function(i) {
      switch (i.label) {
        case 0:
          return t && t.accessToken ? typeof t.accessToken != "function" ? [3, 2] : [4, t.accessToken()] : [3, 5];
        case 1:
          return s = i.sent(), [3, 4];
        case 2:
          return [4, t.accessToken];
        case 3:
          s = i.sent(), i.label = 4;
        case 4:
          r = s, e.Authorization = "Bearer " + r, i.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var r = this, s = arguments;
    return new Promise(function(i, o) {
      var a = n.apply(r, s);
      function u(l) {
        uo(a, i, o, u, c, "next", l);
      }
      function c(l) {
        uo(a, i, o, u, c, "throw", l);
      }
      u(void 0);
    });
  })();
  var n;
};
function Ms(e, t) {
  var n, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  t != null && ((t === void 0 ? "undefined" : (n = t) && typeof Symbol < "u" && n.constructor === Symbol ? "symbol" : typeof n) == "object" ? Array.isArray(t) ? t.forEach(function(s) {
    return Ms(e, s, r);
  }) : Object.keys(t).forEach(function(s) {
    return Ms(e, t[s], "".concat(r).concat(r !== "" ? "." : "").concat(s));
  }) : e.has(r) ? e.append(r, t) : e.set(r, t));
}
var ge = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  var s = new URLSearchParams(e.search);
  Ms(s, n), e.search = s.toString();
}, ht = function(e, t, n) {
  var r = typeof e != "string";
  return (r && n && n.isJsonMime ? n.isJsonMime(t.headers["Content-Type"]) : r) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, ve = function(e) {
  return e.pathname + e.search + e.hash;
}, be = function(e, t, n, r) {
  return function() {
    var s, i, o, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n, c = (i = function(l) {
      for (var d = 1; d < arguments.length; d++) {
        var f = arguments[d] != null ? arguments[d] : {}, h = Object.keys(f);
        typeof Object.getOwnPropertySymbols == "function" && (h = h.concat(Object.getOwnPropertySymbols(f).filter(function(v) {
          return Object.getOwnPropertyDescriptor(f, v).enumerable;
        }))), h.forEach(function(v) {
          ld(l, v, f[v]);
        });
      }
      return l;
    }({}, e.options), o = (o = { url: (a.defaults.baseURL ? "" : (s = r == null ? void 0 : r.basePath) !== null && s !== void 0 ? s : u) + e.url }) != null ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : function(l) {
      var d = Object.keys(l);
      if (Object.getOwnPropertySymbols) {
        var f = Object.getOwnPropertySymbols(l);
        d.push.apply(d, f);
      }
      return d;
    }(Object(o)).forEach(function(l) {
      Object.defineProperty(i, l, Object.getOwnPropertyDescriptor(o, l));
    }), i);
    return a.request(c);
  };
};
function co(e, t, n, r, s, i, o) {
  try {
    var a = e[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? t(u) : Promise.resolve(u).then(r, s);
}
function U(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, s) {
      var i = e.apply(t, n);
      function o(u) {
        co(i, r, s, o, a, "next", u);
      }
      function a(u) {
        co(i, r, s, o, a, "throw", u);
      }
      o(void 0);
    });
  };
}
function vn(e, t, n) {
  return t = qr(t), function(r, s) {
    return !s || ((i = s) && typeof Symbol < "u" && i.constructor === Symbol ? "symbol" : typeof i) != "object" && typeof s != "function" ? function(o) {
      if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return o;
    }(r) : s;
    var i;
  }(e, nu() ? Reflect.construct(t, n || [], qr(e).constructor) : t.apply(e, n));
}
function bn(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function dd(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function yn(e, t, n) {
  return t && dd(e.prototype, t), e;
}
function fd(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qr(e) {
  return qr = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, qr(e);
}
function wn(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && zs(e, t);
}
function P(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      fd(e, s, n[s]);
    });
  }
  return e;
}
function zs(e, t) {
  return zs = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, zs(e, t);
}
function nu() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (nu = function() {
    return !!e;
  })();
}
function L(e, t) {
  var n, r, s, i = { label: 0, sent: function() {
    if (1 & s[0]) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return function(l) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, l[0] && (i = 0)), i; ) try {
          if (n = 1, r && (s = 2 & l[0] ? r.return : l[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, l[1])).done) return s;
          switch (r = 0, s && (l = [2 & l[0], s.value]), l[0]) {
            case 0:
            case 1:
              s = l;
              break;
            case 4:
              return i.label++, { value: l[1], done: !1 };
            case 5:
              i.label++, r = l[1], l = [0];
              continue;
            case 7:
              l = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!((s = (s = i.trys).length > 0 && s[s.length - 1]) || l[0] !== 6 && l[0] !== 2)) {
                i = 0;
                continue;
              }
              if (l[0] === 3 && (!s || l[1] > s[0] && l[1] < s[3])) {
                i.label = l[1];
                break;
              }
              if (l[0] === 6 && i.label < s[1]) {
                i.label = s[1], s = l;
                break;
              }
              if (s && i.label < s[2]) {
                i.label = s[2], i.ops.push(l);
                break;
              }
              s[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          l = t.call(e, i);
        } catch (d) {
          l = [6, d], r = 0;
        } finally {
          n = s = 0;
        }
        if (5 & l[0]) throw l[1];
        return { value: l[0] ? l[1] : void 0, done: !0 };
      }([u, c]);
    };
  }
}
var hd = function(e) {
  return { publicScoreSheetsConfigGet: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return U(function() {
      var n, r, s, i, o;
      return L(this, function(a) {
        return n = new URL("/public/score-sheets/config", me), e && (r = e.baseOptions), s = P({ method: "GET" }, r, t), i = {}, ge(n, {}), o = r && r.headers ? r.headers : {}, s.headers = P({}, i, o, t.headers), [2, { url: ve(n), options: s }];
      });
    })();
  }, publicScoreSheetsRequestPost: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u;
      return L(this, function(c) {
        return ae("publicScoreSheetsRequestPost", "publicScoreSheetsRequestPostRequest", t), r = new URL("/public/score-sheets/request", me), e && (s = e.baseOptions), i = P({ method: "POST" }, s, n), a = {}, (o = {})["Content-Type"] = "application/json", ge(r, a), u = s && s.headers ? s.headers : {}, i.headers = P({}, o, u, n.headers), i.data = ht(t, i, e), [2, { url: ve(r), options: i }];
      });
    })();
  }, publicScoreSheetsTokenGet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u;
      return L(this, function(c) {
        return ae("publicScoreSheetsTokenGet", "token", t), r = "/public/score-sheets/{token}".replace("{token}", encodeURIComponent(String(t))), s = new URL(r, me), e && (i = e.baseOptions), o = P({ method: "GET" }, i, n), a = {}, ge(s, {}), u = i && i.headers ? i.headers : {}, o.headers = P({}, a, u, n.headers), [2, { url: ve(s), options: o }];
      });
    })();
  }, publicSheetsRequestIdRideIdVariantUrlGet: function(t, n, r) {
    var s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return U(function() {
      var i, o, a, u, c, l;
      return L(this, function(d) {
        return ae("publicSheetsRequestIdRideIdVariantUrlGet", "requestId", t), ae("publicSheetsRequestIdRideIdVariantUrlGet", "rideId", n), ae("publicSheetsRequestIdRideIdVariantUrlGet", "variant", r), i = "/public/sheets/{requestId}/{rideId}/{variant}/url".replace("{requestId}", encodeURIComponent(String(t))).replace("{rideId}", encodeURIComponent(String(n))).replace("{variant}", encodeURIComponent(String(r))), o = new URL(i, me), e && (a = e.baseOptions), u = P({ method: "GET" }, a, s), c = {}, ge(o, {}), l = a && a.headers ? a.headers : {}, u.headers = P({}, c, l, s.headers), [2, { url: ve(o), options: u }];
      });
    })();
  } };
}, ir = function(e) {
  var t = hd(e);
  return { publicScoreSheetsConfigGet: function(n) {
    return U(function() {
      var r, s, i, o, a, u;
      return L(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.publicScoreSheetsConfigGet(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = pe["DefaultApi.publicScoreSheetsConfigGet"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return be(i, de, fe, e)(l, u || d);
            }];
        }
      });
    })();
  }, publicScoreSheetsRequestPost: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.publicScoreSheetsRequestPost(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["DefaultApi.publicScoreSheetsRequestPost"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, publicScoreSheetsTokenGet: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.publicScoreSheetsTokenGet(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["DefaultApi.publicScoreSheetsTokenGet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, publicSheetsRequestIdRideIdVariantUrlGet: function(n, r, s, i) {
    return U(function() {
      var o, a, u, c, l, d;
      return L(this, function(f) {
        switch (f.label) {
          case 0:
            return [4, t.publicSheetsRequestIdRideIdVariantUrlGet(n, r, s, i)];
          case 1:
            return u = f.sent(), l = (c = e == null ? void 0 : e.serverIndex) !== null && c !== void 0 ? c : 0, d = (a = pe["DefaultApi.publicSheetsRequestIdRideIdVariantUrlGet"]) === null || a === void 0 || (o = a[l]) === null || o === void 0 ? void 0 : o.url, [2, function(h, v) {
              return be(u, de, fe, e)(h, d || v);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return bn(this, t), vn(this, t, arguments);
  }
  return wn(t, e), yn(t, [{ key: "publicScoreSheetsConfigGet", value: function(n) {
    var r = this;
    return ir(this.configuration).publicScoreSheetsConfigGet(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }, { key: "publicScoreSheetsRequestPost", value: function(n, r) {
    var s = this;
    return ir(this.configuration).publicScoreSheetsRequestPost(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "publicScoreSheetsTokenGet", value: function(n, r) {
    var s = this;
    return ir(this.configuration).publicScoreSheetsTokenGet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "publicSheetsRequestIdRideIdVariantUrlGet", value: function(n, r, s, i) {
    var o = this;
    return ir(this.configuration).publicSheetsRequestIdRideIdVariantUrlGet(n, r, s, i).then(function(a) {
      return a(o.axios, o.basePath);
    });
  } }]), t;
})(gn);
var pd = function(e) {
  return { correctUsefClass: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return U(function() {
      var s, i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return ae("correctUsefClass", "classId", t), ae("correctUsefClass", "uploadUsefClassRequest", n), s = "/federation/usef/classes/{classId}/correct".replace("{classId}", encodeURIComponent(String(t))), i = new URL(s, me), e && (o = e.baseOptions), a = P({ method: "POST" }, o, r), c = {}, [4, _e(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ge(i, c), l = o && o.headers ? o.headers : {}, a.headers = P({}, u, l, r.headers), a.data = ht(n, a, e), [2, { url: ve(i), options: a }];
        }
      });
    })();
  }, deleteUsefClass: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return U(function() {
      var s, i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return ae("deleteUsefClass", "classId", t), ae("deleteUsefClass", "deleteUsefClassRequest", n), s = "/federation/usef/classes/{classId}/delete".replace("{classId}", encodeURIComponent(String(t))), i = new URL(s, me), e && (o = e.baseOptions), a = P({ method: "POST" }, o, r), c = {}, [4, _e(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ge(i, c), l = o && o.headers ? o.headers : {}, a.headers = P({}, u, l, r.headers), a.data = ht(n, a, e), [2, { url: ve(i), options: a }];
        }
      });
    })();
  }, finalizeUsefClass: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return U(function() {
      var s, i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return ae("finalizeUsefClass", "classId", t), ae("finalizeUsefClass", "deleteUsefClassRequest", n), s = "/federation/usef/classes/{classId}/finalize".replace("{classId}", encodeURIComponent(String(t))), i = new URL(s, me), e && (o = e.baseOptions), a = P({ method: "POST" }, o, r), c = {}, [4, _e(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ge(i, c), l = o && o.headers ? o.headers : {}, a.headers = P({}, u, l, r.headers), a.data = ht(n, a, e), [2, { url: ve(i), options: a }];
        }
      });
    })();
  }, getFederationClassAudit: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return ae("getFederationClassAudit", "classId", t), r = "/federation/classes/{classId}/audit".replace("{classId}", encodeURIComponent(String(t))), s = new URL(r, me), e && (i = e.baseOptions), o = P({ method: "GET" }, i, n), u = {}, [4, _e(a = {}, e)];
          case 1:
            return l.sent(), ge(s, u), c = i && i.headers ? i.headers : {}, o.headers = P({}, a, c, n.headers), [2, { url: ve(s), options: o }];
        }
      });
    })();
  }, getFederationShowAudit: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return ae("getFederationShowAudit", "showId", t), r = "/federation/shows/{showId}/audit".replace("{showId}", encodeURIComponent(String(t))), s = new URL(r, me), e && (i = e.baseOptions), o = P({ method: "GET" }, i, n), u = {}, [4, _e(a = {}, e)];
          case 1:
            return l.sent(), ge(s, u), c = i && i.headers ? i.headers : {}, o.headers = P({}, a, c, n.headers), [2, { url: ve(s), options: o }];
        }
      });
    })();
  }, getFederationShowState: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return ae("getFederationShowState", "showId", t), r = "/federation/shows/{showId}/state".replace("{showId}", encodeURIComponent(String(t))), s = new URL(r, me), e && (i = e.baseOptions), o = P({ method: "GET" }, i, n), u = {}, [4, _e(a = {}, e)];
          case 1:
            return l.sent(), ge(s, u), c = i && i.headers ? i.headers : {}, o.headers = P({}, a, c, n.headers), [2, { url: ve(s), options: o }];
        }
      });
    })();
  }, getUsefDeadlineStatus: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return ae("getUsefDeadlineStatus", "competitionEndDate", t), s = new URL("/federation/usef/deadline", me), e && (i = e.baseOptions), o = P({ method: "GET" }, i, r), u = {}, [4, _e(a = {}, e)];
          case 1:
            return l.sent(), t !== void 0 && (u.competitionEndDate = t), n !== void 0 && (u.showId = n), ge(s, u), c = i && i.headers ? i.headers : {}, o.headers = P({}, a, c, r.headers), [2, { url: ve(s), options: o }];
        }
      });
    })();
  }, listUsefDressageSections: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u;
      return L(this, function(c) {
        switch (c.label) {
          case 0:
            return ae("listUsefDressageSections", "compYear", t), r = new URL("/federation/usef/sections", me), e && (s = e.baseOptions), i = P({ method: "GET" }, s, n), a = {}, [4, _e(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.compYear = t), ge(r, a), u = s && s.headers ? s.headers : {}, i.headers = P({}, o, u, n.headers), [2, { url: ve(r), options: i }];
        }
      });
    })();
  }, listUsefDressageTests: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u;
      return L(this, function(c) {
        switch (c.label) {
          case 0:
            return ae("listUsefDressageTests", "testYear", t), r = new URL("/federation/usef/tests", me), e && (s = e.baseOptions), i = P({ method: "GET" }, s, n), a = {}, [4, _e(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.testYear = t), ge(r, a), u = s && s.headers ? s.headers : {}, i.headers = P({}, o, u, n.headers), [2, { url: ve(r), options: i }];
        }
      });
    })();
  }, markClassForRepublish: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return U(function() {
      var s, i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return ae("markClassForRepublish", "classId", t), ae("markClassForRepublish", "markClassForRepublishRequest", n), s = "/federation/usef/classes/{classId}/mark-for-republish".replace("{classId}", encodeURIComponent(String(t))), i = new URL(s, me), e && (o = e.baseOptions), a = P({ method: "POST" }, o, r), c = {}, [4, _e(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ge(i, c), l = o && o.headers ? o.headers : {}, a.headers = P({}, u, l, r.headers), a.data = ht(n, a, e), [2, { url: ve(i), options: a }];
        }
      });
    })();
  }, previewClassResult: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return ae("previewClassResult", "classId", t), r = "/federation/classes/{classId}/preview".replace("{classId}", encodeURIComponent(String(t))), s = new URL(r, me), e && (i = e.baseOptions), o = P({ method: "GET" }, i, n), u = {}, [4, _e(a = {}, e)];
          case 1:
            return l.sent(), ge(s, u), c = i && i.headers ? i.headers : {}, o.headers = P({}, a, c, n.headers), [2, { url: ve(s), options: o }];
        }
      });
    })();
  }, previewShowResults: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return ae("previewShowResults", "showId", t), r = "/federation/shows/{showId}/preview".replace("{showId}", encodeURIComponent(String(t))), s = new URL(r, me), e && (i = e.baseOptions), o = P({ method: "GET" }, i, n), u = {}, [4, _e(a = {}, e)];
          case 1:
            return l.sent(), ge(s, u), c = i && i.headers ? i.headers : {}, o.headers = P({}, a, c, n.headers), [2, { url: ve(s), options: o }];
        }
      });
    })();
  }, publishUsdfShow: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return U(function() {
      var s, i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return ae("publishUsdfShow", "showId", t), s = "/federation/usdf/shows/{showId}/publish".replace("{showId}", encodeURIComponent(String(t))), i = new URL(s, me), e && (o = e.baseOptions), a = P({ method: "POST" }, o, r), c = {}, [4, _e(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ge(i, c), l = o && o.headers ? o.headers : {}, a.headers = P({}, u, l, r.headers), a.data = ht(n, a, e), [2, { url: ve(i), options: a }];
        }
      });
    })();
  }, publishUsefShow: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return U(function() {
      var s, i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return ae("publishUsefShow", "showId", t), ae("publishUsefShow", "publishUsefShowRequest", n), s = "/federation/usef/shows/{showId}/publish".replace("{showId}", encodeURIComponent(String(t))), i = new URL(s, me), e && (o = e.baseOptions), a = P({ method: "POST" }, o, r), c = {}, [4, _e(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ge(i, c), l = o && o.headers ? o.headers : {}, a.headers = P({}, u, l, r.headers), a.data = ht(n, a, e), [2, { url: ve(i), options: a }];
        }
      });
    })();
  }, submitUsefShow: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return U(function() {
      var s, i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return ae("submitUsefShow", "showId", t), ae("submitUsefShow", "submitUsefShowRequest", n), s = "/federation/usef/shows/{showId}/submit".replace("{showId}", encodeURIComponent(String(t))), i = new URL(s, me), e && (o = e.baseOptions), a = P({ method: "POST" }, o, r), c = {}, [4, _e(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ge(i, c), l = o && o.headers ? o.headers : {}, a.headers = P({}, u, l, r.headers), a.data = ht(n, a, e), [2, { url: ve(i), options: a }];
        }
      });
    })();
  }, uploadUsefClass: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return U(function() {
      var s, i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return ae("uploadUsefClass", "classId", t), ae("uploadUsefClass", "uploadUsefClassRequest", n), s = "/federation/usef/classes/{classId}/upload".replace("{classId}", encodeURIComponent(String(t))), i = new URL(s, me), e && (o = e.baseOptions), a = P({ method: "POST" }, o, r), c = {}, [4, _e(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ge(i, c), l = o && o.headers ? o.headers : {}, a.headers = P({}, u, l, r.headers), a.data = ht(n, a, e), [2, { url: ve(i), options: a }];
        }
      });
    })();
  } };
}, ze = function(e) {
  var t = pd(e);
  return { correctUsefClass: function(n, r, s) {
    return U(function() {
      var i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.correctUsefClass(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = pe["FederationApi.correctUsefClass"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return be(a, de, fe, e)(f, l || h);
            }];
        }
      });
    })();
  }, deleteUsefClass: function(n, r, s) {
    return U(function() {
      var i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.deleteUsefClass(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = pe["FederationApi.deleteUsefClass"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return be(a, de, fe, e)(f, l || h);
            }];
        }
      });
    })();
  }, finalizeUsefClass: function(n, r, s) {
    return U(function() {
      var i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.finalizeUsefClass(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = pe["FederationApi.finalizeUsefClass"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return be(a, de, fe, e)(f, l || h);
            }];
        }
      });
    })();
  }, getFederationClassAudit: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getFederationClassAudit(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["FederationApi.getFederationClassAudit"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, getFederationShowAudit: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getFederationShowAudit(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["FederationApi.getFederationShowAudit"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, getFederationShowState: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getFederationShowState(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["FederationApi.getFederationShowState"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, getUsefDeadlineStatus: function(n, r, s) {
    return U(function() {
      var i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.getUsefDeadlineStatus(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = pe["FederationApi.getUsefDeadlineStatus"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return be(a, de, fe, e)(f, l || h);
            }];
        }
      });
    })();
  }, listUsefDressageSections: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listUsefDressageSections(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["FederationApi.listUsefDressageSections"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, listUsefDressageTests: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listUsefDressageTests(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["FederationApi.listUsefDressageTests"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, markClassForRepublish: function(n, r, s) {
    return U(function() {
      var i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.markClassForRepublish(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = pe["FederationApi.markClassForRepublish"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return be(a, de, fe, e)(f, l || h);
            }];
        }
      });
    })();
  }, previewClassResult: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.previewClassResult(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["FederationApi.previewClassResult"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, previewShowResults: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.previewShowResults(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["FederationApi.previewShowResults"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, publishUsdfShow: function(n, r, s) {
    return U(function() {
      var i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.publishUsdfShow(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = pe["FederationApi.publishUsdfShow"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return be(a, de, fe, e)(f, l || h);
            }];
        }
      });
    })();
  }, publishUsefShow: function(n, r, s) {
    return U(function() {
      var i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.publishUsefShow(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = pe["FederationApi.publishUsefShow"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return be(a, de, fe, e)(f, l || h);
            }];
        }
      });
    })();
  }, submitUsefShow: function(n, r, s) {
    return U(function() {
      var i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.submitUsefShow(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = pe["FederationApi.submitUsefShow"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return be(a, de, fe, e)(f, l || h);
            }];
        }
      });
    })();
  }, uploadUsefClass: function(n, r, s) {
    return U(function() {
      var i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.uploadUsefClass(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = pe["FederationApi.uploadUsefClass"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return be(a, de, fe, e)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return bn(this, t), vn(this, t, arguments);
  }
  return wn(t, e), yn(t, [{ key: "correctUsefClass", value: function(n, r, s) {
    var i = this;
    return ze(this.configuration).correctUsefClass(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "deleteUsefClass", value: function(n, r, s) {
    var i = this;
    return ze(this.configuration).deleteUsefClass(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "finalizeUsefClass", value: function(n, r, s) {
    var i = this;
    return ze(this.configuration).finalizeUsefClass(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getFederationClassAudit", value: function(n, r) {
    var s = this;
    return ze(this.configuration).getFederationClassAudit(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getFederationShowAudit", value: function(n, r) {
    var s = this;
    return ze(this.configuration).getFederationShowAudit(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getFederationShowState", value: function(n, r) {
    var s = this;
    return ze(this.configuration).getFederationShowState(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getUsefDeadlineStatus", value: function(n, r, s) {
    var i = this;
    return ze(this.configuration).getUsefDeadlineStatus(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "listUsefDressageSections", value: function(n, r) {
    var s = this;
    return ze(this.configuration).listUsefDressageSections(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listUsefDressageTests", value: function(n, r) {
    var s = this;
    return ze(this.configuration).listUsefDressageTests(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "markClassForRepublish", value: function(n, r, s) {
    var i = this;
    return ze(this.configuration).markClassForRepublish(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "previewClassResult", value: function(n, r) {
    var s = this;
    return ze(this.configuration).previewClassResult(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "previewShowResults", value: function(n, r) {
    var s = this;
    return ze(this.configuration).previewShowResults(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "publishUsdfShow", value: function(n, r, s) {
    var i = this;
    return ze(this.configuration).publishUsdfShow(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "publishUsefShow", value: function(n, r, s) {
    var i = this;
    return ze(this.configuration).publishUsefShow(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "submitUsefShow", value: function(n, r, s) {
    var i = this;
    return ze(this.configuration).submitUsefShow(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "uploadUsefClass", value: function(n, r, s) {
    var i = this;
    return ze(this.configuration).uploadUsefClass(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(gn);
var md = function(e) {
  return { getHealth: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return U(function() {
      var n, r, s, i, o;
      return L(this, function(a) {
        return n = new URL("/health", me), e && (r = e.baseOptions), s = P({ method: "GET" }, r, t), i = {}, ge(n, {}), o = r && r.headers ? r.headers : {}, s.headers = P({}, i, o, t.headers), [2, { url: ve(n), options: s }];
      });
    })();
  } };
}, gd = function(e) {
  var t = md(e);
  return { getHealth: function(n) {
    return U(function() {
      var r, s, i, o, a, u;
      return L(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.getHealth(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = pe["HealthApi.getHealth"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return be(i, de, fe, e)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return bn(this, t), vn(this, t, arguments);
  }
  return wn(t, e), yn(t, [{ key: "getHealth", value: function(n) {
    var r = this;
    return gd(this.configuration).getHealth(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), t;
})(gn);
var vd = function(e) {
  return { createReportRun: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return U(function() {
      var s, i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return ae("createReportRun", "id", t), s = "/reports/{id}/runs".replace("{id}", encodeURIComponent(String(t))), i = new URL(s, me), e && (o = e.baseOptions), a = P({ method: "POST" }, o, r), c = {}, [4, _e(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ge(i, c), l = o && o.headers ? o.headers : {}, a.headers = P({}, u, l, r.headers), a.data = ht(n, a, e), [2, { url: ve(i), options: a }];
        }
      });
    })();
  }, listReports: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u;
      return L(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/reports", me), e && (s = e.baseOptions), i = P({ method: "GET" }, s, n), a = {}, [4, _e(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.domain = t), ge(r, a), u = s && s.headers ? s.headers : {}, i.headers = P({}, o, u, n.headers), [2, { url: ve(r), options: i }];
        }
      });
    })();
  } };
}, lo = function(e) {
  var t = vd(e);
  return { createReportRun: function(n, r, s) {
    return U(function() {
      var i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.createReportRun(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = pe["ReportsApi.createReportRun"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return be(a, de, fe, e)(f, l || h);
            }];
        }
      });
    })();
  }, listReports: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listReports(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["ReportsApi.listReports"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  } };
}, bd = function(e) {
  function t() {
    return bn(this, t), vn(this, t, arguments);
  }
  return wn(t, e), yn(t, [{ key: "createReportRun", value: function(n, r, s) {
    var i = this;
    return lo(this.configuration).createReportRun(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "listReports", value: function(n, r) {
    var s = this;
    return lo(this.configuration).listReports(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), t;
}(gn), yd = function(e) {
  return { getScorePageLink: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return ae("getScorePageLink", "rideId", t), r = "/score-sheets/rides/{rideId}/link".replace("{rideId}", encodeURIComponent(String(t))), s = new URL(r, me), e && (i = e.baseOptions), o = P({ method: "GET" }, i, n), u = {}, [4, _e(a = {}, e)];
          case 1:
            return l.sent(), ge(s, u), c = i && i.headers ? i.headers : {}, o.headers = P({}, a, c, n.headers), [2, { url: ve(s), options: o }];
        }
      });
    })();
  }, getScoreSheetStatus: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return ae("getScoreSheetStatus", "rideId", t), r = "/score-sheets/rides/{rideId}/status".replace("{rideId}", encodeURIComponent(String(t))), s = new URL(r, me), e && (i = e.baseOptions), o = P({ method: "GET" }, i, n), u = {}, [4, _e(a = {}, e)];
          case 1:
            return l.sent(), ge(s, u), c = i && i.headers ? i.headers : {}, o.headers = P({}, a, c, n.headers), [2, { url: ve(s), options: o }];
        }
      });
    })();
  }, resendScoreSheet: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return U(function() {
      var s, i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return ae("resendScoreSheet", "rideId", t), s = "/score-sheets/rides/{rideId}/resend".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(s, me), e && (o = e.baseOptions), a = P({ method: "POST" }, o, r), c = {}, [4, _e(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ge(i, c), l = o && o.headers ? o.headers : {}, a.headers = P({}, u, l, r.headers), a.data = ht(n, a, e), [2, { url: ve(i), options: a }];
        }
      });
    })();
  } };
}, ws = function(e) {
  var t = yd(e);
  return { getScorePageLink: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getScorePageLink(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["RiderSheetsApi.getScorePageLink"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheetStatus: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getScoreSheetStatus(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["RiderSheetsApi.getScoreSheetStatus"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, resendScoreSheet: function(n, r, s) {
    return U(function() {
      var i, o, a, u, c, l;
      return L(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.resendScoreSheet(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = pe["RiderSheetsApi.resendScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return be(a, de, fe, e)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return bn(this, t), vn(this, t, arguments);
  }
  return wn(t, e), yn(t, [{ key: "getScorePageLink", value: function(n, r) {
    var s = this;
    return ws(this.configuration).getScorePageLink(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheetStatus", value: function(n, r) {
    var s = this;
    return ws(this.configuration).getScoreSheetStatus(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "resendScoreSheet", value: function(n, r, s) {
    var i = this;
    return ws(this.configuration).resendScoreSheet(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(gn);
var wd = function(e) {
  return { clearRuns: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u;
      return L(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/runs", me), e && (s = e.baseOptions), i = P({ method: "DELETE" }, s, n), a = {}, [4, _e(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.reportId = t), ge(r, a), u = s && s.headers ? s.headers : {}, i.headers = P({}, o, u, n.headers), [2, { url: ve(r), options: i }];
        }
      });
    })();
  }, deleteRun: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return ae("deleteRun", "id", t), r = "/runs/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, me), e && (i = e.baseOptions), o = P({ method: "DELETE" }, i, n), u = {}, [4, _e(a = {}, e)];
          case 1:
            return l.sent(), ge(s, u), c = i && i.headers ? i.headers : {}, o.headers = P({}, a, c, n.headers), [2, { url: ve(s), options: o }];
        }
      });
    })();
  }, getRun: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return ae("getRun", "id", t), r = "/runs/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, me), e && (i = e.baseOptions), o = P({ method: "GET" }, i, n), u = {}, [4, _e(a = {}, e)];
          case 1:
            return l.sent(), ge(s, u), c = i && i.headers ? i.headers : {}, o.headers = P({}, a, c, n.headers), [2, { url: ve(s), options: o }];
        }
      });
    })();
  }, listRuns: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return U(function() {
      var r, s, i, o, a, u;
      return L(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/runs", me), e && (s = e.baseOptions), i = P({ method: "GET" }, s, n), a = {}, [4, _e(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.reportId = t), ge(r, a), u = s && s.headers ? s.headers : {}, i.headers = P({}, o, u, n.headers), [2, { url: ve(r), options: i }];
        }
      });
    })();
  } };
}, or = function(e) {
  var t = wd(e);
  return { clearRuns: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.clearRuns(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["RunsApi.clearRuns"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, deleteRun: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deleteRun(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["RunsApi.deleteRun"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, getRun: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getRun(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["RunsApi.getRun"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  }, listRuns: function(n, r) {
    return U(function() {
      var s, i, o, a, u, c;
      return L(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listRuns(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = pe["RunsApi.listRuns"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return be(o, de, fe, e)(d, c || f);
            }];
        }
      });
    })();
  } };
}, Sd = function(e) {
  function t() {
    return bn(this, t), vn(this, t, arguments);
  }
  return wn(t, e), yn(t, [{ key: "clearRuns", value: function(n, r) {
    var s = this;
    return or(this.configuration).clearRuns(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "deleteRun", value: function(n, r) {
    var s = this;
    return or(this.configuration).deleteRun(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getRun", value: function(n, r) {
    var s = this;
    return or(this.configuration).getRun(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listRuns", value: function(n, r) {
    var s = this;
    return or(this.configuration).listRuns(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), t;
}(gn);
function xd(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Pt(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function fo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      Pt(e, s, n[s]);
    });
  }
  return e;
}
var Rd = function() {
  function e() {
    var r, s, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(a, u) {
      if (!(a instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, e), Pt(this, "apiKey", void 0), Pt(this, "username", void 0), Pt(this, "password", void 0), Pt(this, "accessToken", void 0), Pt(this, "basePath", void 0), Pt(this, "serverIndex", void 0), Pt(this, "baseOptions", void 0), Pt(this, "formDataCtor", void 0), this.apiKey = o.apiKey, this.username = o.username, this.password = o.password, this.accessToken = o.accessToken, this.basePath = o.basePath, this.serverIndex = o.serverIndex, this.baseOptions = (s = fo({}, o.baseOptions), i = (i = { headers: fo({}, (r = o.baseOptions) === null || r === void 0 ? void 0 : r.headers) }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(i)) : function(a) {
      var u = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(a);
        u.push.apply(u, c);
      }
      return u;
    }(Object(i)).forEach(function(a) {
      Object.defineProperty(s, a, Object.getOwnPropertyDescriptor(i, a));
    }), s), this.formDataCtor = o.formDataCtor;
  }
  var t, n;
  return t = e, (n = [{ key: "isJsonMime", value: function(r) {
    var s = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return r !== null && (s.test(r) || r.toLowerCase() === "application/json-patch+json");
  } }]) && xd(t.prototype, n), e;
}();
function Od() {
  var r;
  const e = Jt(), { activeOrgId: t } = ri(), n = (r = e.user) == null ? void 0 : r.access_token;
  return Lt(
    (s) => ({
      basePath: s,
      accessToken: n,
      baseOptions: t ? { headers: { "X-Org-Id": t } } : void 0
    }),
    [n, t]
  );
}
function _d(e) {
  const t = Od();
  return Fn(() => {
    const n = new Rd(t(e));
    return {
      reports: new bd(n),
      runs: new Sd(n)
    };
  }, [t, e]);
}
function an(e) {
  var n;
  const t = e == null ? void 0 : e.data;
  if (!t || t.status !== "success") {
    const r = ((n = t == null ? void 0 : t.data) == null ? void 0 : n.message) || (t == null ? void 0 : t.code) || "Request failed";
    throw new Error(r);
  }
  return t.data;
}
const Ed = {
  empty: "No reports available.",
  error: "Failed to load reports"
}, Cd = (e) => (e == null ? void 0 : e.name) ?? "";
function Td({
  api: e,
  domain: t,
  onSelect: n,
  selectedId: r,
  // #579 — when set, auto-select this def once (deep-link from another page).
  autoSelectId: s,
  labels: i = {},
  resolveReportName: o = Cd
}) {
  const a = { ...Ed, ...i }, [u, c] = Z([]), [l, d] = Z(!0), [f, h] = Z(null), v = Zt(!1);
  return Ie(() => {
    if (v.current || !s || u.length === 0) return;
    const m = u.find((O) => O.id === s);
    m && (v.current = !0, n == null || n(m));
  }, [u, s, n]), Ie(() => {
    let m = !1;
    return d(!0), h(null), e.reports.listReports(t).then((O) => {
      m || c(an(O) || []);
    }).catch((O) => {
      m || h(O.message || a.error);
    }).finally(() => {
      m || d(!1);
    }), () => {
      m = !0;
    };
  }, [e, t, a.error]), l ? /* @__PURE__ */ p.jsx(ye, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ p.jsx(Yn, { "data-testid": "report-list-loading" }) }) : f ? /* @__PURE__ */ p.jsx(Bn, { severity: "error", children: f }) : u.length === 0 ? /* @__PURE__ */ p.jsx(Xe, { color: "text.secondary", sx: { p: 2 }, children: a.empty }) : /* @__PURE__ */ p.jsx(uc, { "data-testid": "report-list", children: u.map((m) => /* @__PURE__ */ p.jsx(
    cc,
    {
      selected: m.id === r,
      onClick: () => n == null ? void 0 : n(m),
      children: /* @__PURE__ */ p.jsx(
        lc,
        {
          primary: o(m),
          primaryTypographyProps: { color: "text.primary" }
        }
      )
    },
    m.id
  )) });
}
function jd(e) {
  return e.default !== void 0 ? e.default : e.type === "boolean" ? !1 : "";
}
const En = (e) => e !== "" && e !== void 0 && e !== null, kd = {
  submit: "Run report",
  required: "Required"
}, Id = (e, t, n) => (n == null ? void 0 : n.title) || t;
function Pd({
  def: e,
  onSubmit: t,
  submitting: n = !1,
  labels: r = {},
  // #551 — `context` supplies values for fields the surface knows (e.g. showId
  // from the active show); those fields are auto-filled + hidden, not typed.
  // `fieldRenderers` overrides how a specific field renders (e.g. day/ring as
  // dropdowns, classId/rideId as a lookup) — keyed by the param name; each gets
  // { value, onChange, label, required, error, disabled }.
  context: s = {},
  fieldRenderers: i = {},
  resolveParamLabel: o = Id
}) {
  var C, J;
  const a = { ...kd, ...r }, u = ((C = e == null ? void 0 : e.paramsSchema) == null ? void 0 : C.properties) || {}, c = ((J = e == null ? void 0 : e.paramsSchema) == null ? void 0 : J.required) || [], l = Object.entries(u).filter(([H]) => !En(s[H])), [d, f] = Z(() => {
    const H = {};
    for (const [ie, Q] of Object.entries(u))
      En(s[ie]) || (H[ie] = jd(Q));
    return H;
  }), [h, v] = Z(!1), m = (H, ie) => f((Q) => ({ ...Q, [H]: ie })), O = c.filter((H) => En(s[H]) ? !1 : !En(d[H])), K = (H) => {
    if (H.preventDefault(), v(!0), O.length > 0) return;
    const ie = {};
    for (const [Q, De] of Object.entries(u)) {
      if (En(s[Q])) {
        ie[Q] = s[Q];
        continue;
      }
      const Te = d[Q];
      Te === "" && !c.includes(Q) || (ie[Q] = De.type === "number" || De.type === "integer" ? Number(Te) : Te);
    }
    t(ie);
  };
  return /* @__PURE__ */ p.jsx(ye, { component: "form", onSubmit: K, noValidate: !0, children: /* @__PURE__ */ p.jsxs(ln, { spacing: 2, children: [
    l.map(([H, ie]) => {
      const Q = o(e, H, ie), De = c.includes(H), Te = h && De && O.includes(H), Ye = i[H];
      if (Ye)
        return /* @__PURE__ */ p.jsx(Qu, { children: Ye({
          value: d[H],
          onChange: (xe) => m(H, xe),
          label: Q,
          required: De,
          error: Te,
          disabled: n
        }) }, H);
      if (ie.type === "boolean")
        return /* @__PURE__ */ p.jsx(
          la,
          {
            control: /* @__PURE__ */ p.jsx(
              da,
              {
                color: "default",
                checked: !!d[H],
                onChange: (xe) => m(H, xe.target.checked)
              }
            ),
            label: Q
          },
          H
        );
      if (Array.isArray(ie.enum))
        return /* @__PURE__ */ p.jsx(
          $n,
          {
            select: !0,
            label: Q,
            required: De,
            error: Te,
            helperText: Te ? a.required : ie.description,
            value: d[H] ?? "",
            onChange: (xe) => m(H, xe.target.value),
            fullWidth: !0,
            children: ie.enum.map((xe) => /* @__PURE__ */ p.jsx(dc, { value: xe, children: String(xe) }, String(xe)))
          },
          H
        );
      const at = ie.type === "number" || ie.type === "integer";
      return /* @__PURE__ */ p.jsx(
        $n,
        {
          label: Q,
          type: at ? "number" : "text",
          required: De,
          error: Te,
          helperText: Te ? a.required : ie.description,
          value: d[H] ?? "",
          onChange: (xe) => m(H, xe.target.value),
          fullWidth: !0
        },
        H
      );
    }),
    /* @__PURE__ */ p.jsx(ye, { children: /* @__PURE__ */ p.jsx(Ge, { type: "submit", variant: "contained", loading: n, children: a.submit }) })
  ] }) });
}
const Ad = /* @__PURE__ */ new Set(["PENDING", "RUNNING"]), Ud = {
  COMPLETE: "success",
  FAILED: "error",
  RUNNING: "info",
  PENDING: "warning"
};
function Ld(e) {
  if (!e) return "";
  const t = new Date(e);
  return isNaN(t.getTime()) ? e : t.toLocaleString();
}
const Nd = {
  empty: "No runs yet.",
  error: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  delete: "Delete"
}, Dd = (e) => e;
function Fd({
  api: e,
  onView: t,
  onDelete: n,
  refreshKey: r = 0,
  labels: s = {},
  resolveReportName: i = Dd
}) {
  const o = { ...Nd, ...s }, [a, u] = Z([]), [c, l] = Z(!0), [d, f] = Z(null), h = Zt(null), v = Lt(async () => {
    try {
      const m = await e.runs.listRuns();
      u(an(m) || []), f(null);
    } catch (m) {
      f(m.message || o.error);
    } finally {
      l(!1);
    }
  }, [e, o.error]);
  return Ie(() => {
    v();
  }, [v, r]), Ie(() => {
    if (!a.some((O) => Ad.has(O.status))) {
      h.current && clearInterval(h.current), h.current = null;
      return;
    }
    return h.current || (h.current = setInterval(v, 4e3)), () => {
      h.current && (clearInterval(h.current), h.current = null);
    };
  }, [a, v]), c ? /* @__PURE__ */ p.jsx(ye, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ p.jsx(Yn, { "data-testid": "run-history-loading" }) }) : d ? /* @__PURE__ */ p.jsx(Bn, { severity: "error", children: d }) : a.length === 0 ? /* @__PURE__ */ p.jsx(Xe, { color: "text.secondary", sx: { p: 2 }, children: o.empty }) : /* @__PURE__ */ p.jsxs(fc, { size: "small", "data-testid": "run-history", children: [
    /* @__PURE__ */ p.jsx(hc, { children: /* @__PURE__ */ p.jsxs(Ai, { children: [
      /* @__PURE__ */ p.jsx(Dt, { children: o.colReport }),
      /* @__PURE__ */ p.jsx(Dt, { children: o.colRequested }),
      /* @__PURE__ */ p.jsx(Dt, { children: o.colStatus }),
      /* @__PURE__ */ p.jsx(Dt, { align: "right", children: o.colActions })
    ] }) }),
    /* @__PURE__ */ p.jsx(pc, { children: a.map((m) => /* @__PURE__ */ p.jsxs(Ai, { "data-testid": `run-row-${m.id}`, children: [
      /* @__PURE__ */ p.jsx(Dt, { sx: { color: "text.primary" }, children: i(m.reportId) }),
      /* @__PURE__ */ p.jsx(Dt, { sx: { color: "text.primary" }, children: Ld(m.createdAt) }),
      /* @__PURE__ */ p.jsx(Dt, { children: /* @__PURE__ */ p.jsx(
        ca,
        {
          size: "small",
          label: m.status,
          color: Ud[m.status] || "default"
        }
      ) }),
      /* @__PURE__ */ p.jsxs(Dt, { align: "right", children: [
        /* @__PURE__ */ p.jsx(
          Ge,
          {
            size: "small",
            variant: "outlined",
            color: "inherit",
            disabled: m.status !== "COMPLETE",
            onClick: () => t == null ? void 0 : t(m),
            children: o.view
          }
        ),
        n && /* @__PURE__ */ p.jsx(
          Lr,
          {
            size: "small",
            color: "inherit",
            "aria-label": o.delete,
            title: o.delete,
            sx: { ml: 1 },
            onClick: () => n(m),
            children: /* @__PURE__ */ p.jsx(Lc, { fontSize: "small" })
          }
        )
      ] })
    ] }, m.id)) })
  ] });
}
const $d = {
  failed: "This run failed to render.",
  notReady: "Report is not ready yet.",
  error: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  preview: "Report preview"
};
function Bd({ api: e, runId: t, height: n = 600, labels: r = {} }) {
  const s = { ...$d, ...r }, [i, o] = Z(null), [a, u] = Z(!0), [c, l] = Z(null);
  return Ie(() => {
    if (!t) return;
    let d = !1;
    return u(!0), l(null), e.runs.getRun(t).then((f) => {
      if (d) return;
      const h = an(f);
      if (h.status !== "COMPLETE" || !h.artifactUrls) {
        l(h.status === "FAILED" ? s.failed : s.notReady);
        return;
      }
      o(h.artifactUrls);
    }).catch((f) => {
      d || l(f.message || s.error);
    }).finally(() => {
      d || u(!1);
    }), () => {
      d = !0;
    };
  }, [e, t, s.error, s.failed, s.notReady]), t ? a ? /* @__PURE__ */ p.jsx(ye, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ p.jsx(Yn, { "data-testid": "report-viewer-loading" }) }) : c ? /* @__PURE__ */ p.jsx(Bn, { severity: "error", children: c }) : i ? /* @__PURE__ */ p.jsxs(ln, { spacing: 1, "data-testid": "report-viewer", children: [
    /* @__PURE__ */ p.jsxs(ln, { direction: "row", spacing: 1, children: [
      i.pdf && /* @__PURE__ */ p.jsx(Ge, { variant: "outlined", href: i.pdf, target: "_blank", rel: "noopener", children: s.openPdf }),
      i.html && /* @__PURE__ */ p.jsx(Ge, { variant: "text", href: i.html, target: "_blank", rel: "noopener", children: s.openHtml })
    ] }),
    i.html && /* @__PURE__ */ p.jsx(
      ye,
      {
        component: "iframe",
        "data-testid": "report-viewer-frame",
        title: s.preview,
        src: i.html,
        sx: { width: "100%", height: n, border: 1, borderColor: "divider", borderRadius: 1, bgcolor: "#fff" }
      }
    )
  ] }) : null : null;
}
const Md = {
  title: "Reports",
  availableReports: "Available reports",
  runHistory: "Run history",
  reportDialogTitle: "Report",
  reportStarted: "Report started — open Run history to view it when ready.",
  failedToStart: "Failed to start report",
  // #609 — run-progress modal
  runningTitle: "Running report…",
  runningMessage: "Your report is being generated. It will download automatically when it's ready — or close this and find it in Run history.",
  runningDoneTitle: "Report ready",
  runningDoneMessage: "Your report has downloaded. It's also in Run history.",
  runningFailedTitle: "Report failed",
  download: "Download",
  close: "Close",
  // #606 — clear old runs
  clearHistory: "Clear history",
  clearConfirm: "Delete all report runs for this organization? This removes the generated files too and can't be undone.",
  delete: "Delete",
  // ReportList
  noReports: "No reports available.",
  failedToLoadReports: "Failed to load reports",
  // ReportParamsForm
  runReport: "Run report",
  required: "Required",
  // RunHistory
  noRuns: "No runs yet.",
  failedToLoadRuns: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  // ReportViewer
  runFailed: "This run failed to render.",
  runNotReady: "Report is not ready yet.",
  failedToLoadReport: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  reportPreview: "Report preview"
}, zd = (e) => (e == null ? void 0 : e.name) ?? (e == null ? void 0 : e.id) ?? "", qd = (e, t, n) => (n == null ? void 0 : n.title) || t;
function ho(e) {
  const t = document.createElement("a");
  t.href = e, t.target = "_blank", t.rel = "noopener", t.download = "", document.body.appendChild(t), t.click(), t.remove();
}
function Mp({
  basePath: e,
  domain: t,
  // Back-compat: an explicit `title` still wins; otherwise labels.title is used.
  title: n,
  // #602 — translated chrome strings from the mounting app (see DEFAULT_LABELS).
  labels: r = {},
  // #551 — a surface can supply context values (e.g. showId from the active
  // show) and custom field renderers (day/ring dropdowns, class/ride lookups)
  // forwarded to the params form. `paramsFieldRenderers` may be a plain map or
  // a function of the selected def (so renderers can depend on the def).
  paramsContext: s = {},
  paramsFieldRenderers: i = {},
  // #579 — a surface can deep-link to a specific report (e.g. from a ride page);
  // the matching def is auto-selected once the list loads.
  initialSelectedId: o,
  // #649 — see defaultResolveReportName/defaultResolveParamLabel above.
  resolveReportName: a = zd,
  resolveParamLabel: u = qd
}) {
  var $e, Y;
  const c = { ...Md, ...r }, l = _d(e), [d, f] = Z(null), [h, v] = Z(!1), [m, O] = Z(null), [K, C] = Z(0), [J, H] = Z(""), [ie, Q] = Z(null), [De, Te] = Z({});
  Ie(() => {
    let Re = !1;
    return l.reports.listReports(t).then((Me) => {
      if (Re) return;
      const ut = {};
      for (const jt of an(Me) || []) ut[jt.id] = jt;
      Te(ut);
    }).catch(() => {
    }), () => {
      Re = !0;
    };
  }, [l, t]);
  const Ye = (Re) => {
    var Me;
    return a({ id: Re, name: (Me = De[Re]) == null ? void 0 : Me.name });
  }, [at, xe] = Z(!1), [Fe, we] = Z(null), [ue, le] = Z(null), st = Zt(!1), ke = async (Re) => {
    if (d) {
      v(!0), O(null);
      try {
        const Me = an(await l.reports.createReportRun(d.id, { params: Re }));
        C((ut) => ut + 1), f(null), st.current = !1, le(Me), we(Me.id);
      } catch (Me) {
        O(Me.message || c.failedToStart);
      } finally {
        v(!1);
      }
    }
  };
  Ie(() => {
    if (!Fe) return;
    let Re = !1, Me;
    const ut = async () => {
      var jt, Mt;
      try {
        const ct = an(await l.runs.getRun(Fe));
        if (Re) return;
        if (le(ct), ct.status === "COMPLETE") {
          C((ss) => ss + 1);
          const kt = ((jt = ct.artifactUrls) == null ? void 0 : jt.pdf) || ((Mt = ct.artifactUrls) == null ? void 0 : Mt.html);
          kt && !st.current && (st.current = !0, ho(kt));
          return;
        }
        if (ct.status === "FAILED") {
          C((kt) => kt + 1);
          return;
        }
        Me = setTimeout(ut, 3e3);
      } catch {
        Re || le((ct) => ({ ...ct || {}, status: "FAILED" }));
      }
    };
    return Me = setTimeout(ut, 1200), () => {
      Re = !0, clearTimeout(Me);
    };
  }, [Fe, l]);
  const [bt, Tt] = Z(!1), Ee = async () => {
    if (!(typeof window < "u" && !window.confirm(c.clearConfirm))) {
      Tt(!0);
      try {
        await l.runs.clearRuns(), C((Re) => Re + 1);
      } finally {
        Tt(!1);
      }
    }
  }, Ce = async (Re) => {
    await l.runs.deleteRun(Re.id), C((Me) => Me + 1);
  };
  return /* @__PURE__ */ p.jsxs(ye, { children: [
    /* @__PURE__ */ p.jsx(Xe, { variant: "h5", sx: { mb: 2, color: "text.primary" }, children: n ?? c.title }),
    /* @__PURE__ */ p.jsxs(ye, { sx: { display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, alignItems: "flex-start" }, children: [
      /* @__PURE__ */ p.jsx(ye, { sx: { width: { xs: "100%", md: 340 }, flexShrink: 0 }, children: /* @__PURE__ */ p.jsx(Ar, { variant: "outlined", children: /* @__PURE__ */ p.jsxs(Ur, { children: [
        /* @__PURE__ */ p.jsx(Xe, { variant: "subtitle1", sx: { color: "text.primary" }, children: c.availableReports }),
        /* @__PURE__ */ p.jsx(
          Td,
          {
            api: l,
            domain: t,
            selectedId: d == null ? void 0 : d.id,
            autoSelectId: o,
            onSelect: f,
            labels: { empty: c.noReports, error: c.failedToLoadReports },
            resolveReportName: a
          }
        ),
        /* @__PURE__ */ p.jsx(
          Ge,
          {
            fullWidth: !0,
            variant: "text",
            sx: { mt: 1, justifyContent: "flex-start" },
            onClick: () => xe(!0),
            children: c.runHistory
          }
        )
      ] }) }) }),
      /* @__PURE__ */ p.jsx(ye, { sx: { flex: 1, minWidth: 0, width: "100%" }, children: d && /* @__PURE__ */ p.jsx(Ar, { variant: "outlined", sx: { mb: 2 }, children: /* @__PURE__ */ p.jsxs(Ur, { children: [
        /* @__PURE__ */ p.jsx(Xe, { variant: "subtitle1", sx: { color: "text.primary" }, children: a(d) }),
        /* @__PURE__ */ p.jsx(mc, { sx: { my: 1 } }),
        m && /* @__PURE__ */ p.jsx(Bn, { severity: "error", sx: { mb: 2 }, children: m }),
        /* @__PURE__ */ p.jsx(
          Pd,
          {
            def: d,
            onSubmit: ke,
            submitting: h,
            labels: { submit: c.runReport, required: c.required },
            context: s,
            fieldRenderers: typeof i == "function" ? i(d) : i,
            resolveParamLabel: u
          }
        )
      ] }) }) })
    ] }),
    /* @__PURE__ */ p.jsxs(pr, { open: at, onClose: () => xe(!1), maxWidth: "md", fullWidth: !0, children: [
      /* @__PURE__ */ p.jsx(ds, { children: c.runHistory }),
      /* @__PURE__ */ p.jsx(mr, { children: /* @__PURE__ */ p.jsx(
        Fd,
        {
          api: l,
          refreshKey: K,
          onView: (Re) => Q(Re.id),
          onDelete: Ce,
          labels: {
            empty: c.noRuns,
            error: c.failedToLoadRuns,
            colReport: c.colReport,
            colRequested: c.colRequested,
            colStatus: c.colStatus,
            colActions: c.colActions,
            view: c.view,
            delete: c.delete
          },
          resolveReportName: Ye
        }
      ) }),
      /* @__PURE__ */ p.jsxs(Ps, { children: [
        /* @__PURE__ */ p.jsx(Ge, { color: "error", onClick: Ee, disabled: bt, children: c.clearHistory }),
        /* @__PURE__ */ p.jsx(Ge, { color: "inherit", onClick: () => xe(!1), children: c.close })
      ] })
    ] }),
    /* @__PURE__ */ p.jsxs(pr, { open: !!ie, onClose: () => Q(null), maxWidth: "lg", fullWidth: !0, children: [
      /* @__PURE__ */ p.jsx(ds, { children: c.reportDialogTitle }),
      /* @__PURE__ */ p.jsx(mr, { children: /* @__PURE__ */ p.jsx(
        Bd,
        {
          api: l,
          runId: ie,
          labels: {
            failed: c.runFailed,
            notReady: c.runNotReady,
            error: c.failedToLoadReport,
            openPdf: c.openPdf,
            openHtml: c.openHtml,
            preview: c.reportPreview
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ p.jsxs(pr, { open: !!Fe, onClose: () => we(null), maxWidth: "xs", fullWidth: !0, children: [
      /* @__PURE__ */ p.jsx(ds, { children: (ue == null ? void 0 : ue.status) === "COMPLETE" ? c.runningDoneTitle : (ue == null ? void 0 : ue.status) === "FAILED" ? c.runningFailedTitle : c.runningTitle }),
      /* @__PURE__ */ p.jsx(mr, { children: (ue == null ? void 0 : ue.status) === "FAILED" ? /* @__PURE__ */ p.jsx(Bn, { severity: "error", children: c.runFailed }) : (ue == null ? void 0 : ue.status) === "COMPLETE" ? /* @__PURE__ */ p.jsx(Xe, { sx: { color: "text.primary" }, children: c.runningDoneMessage }) : /* @__PURE__ */ p.jsxs(ye, { sx: { display: "flex", alignItems: "center", gap: 2, py: 1 }, children: [
        /* @__PURE__ */ p.jsx(Yn, { size: 26, color: "inherit" }),
        /* @__PURE__ */ p.jsx(Xe, { sx: { color: "text.primary" }, children: c.runningMessage })
      ] }) }),
      /* @__PURE__ */ p.jsxs(Ps, { children: [
        (ue == null ? void 0 : ue.status) === "COMPLETE" && ((($e = ue.artifactUrls) == null ? void 0 : $e.pdf) || ((Y = ue.artifactUrls) == null ? void 0 : Y.html)) && // #609 — brand primary is darkGrey (invisible as a text button on
        // dark); a contained button + inherit-colored Close stay legible
        // in both light and dark.
        /* @__PURE__ */ p.jsx(
          Ge,
          {
            variant: "contained",
            onClick: () => ho(ue.artifactUrls.pdf || ue.artifactUrls.html),
            children: c.download
          }
        ),
        /* @__PURE__ */ p.jsx(Ge, { color: "inherit", onClick: () => we(null), children: c.close })
      ] })
    ] }),
    /* @__PURE__ */ p.jsx(
      gc,
      {
        open: !!J,
        autoHideDuration: 5e3,
        onClose: () => H(""),
        message: J
      }
    )
  ] });
}
var Hr = { d: (e, t) => {
  for (var n in t) Hr.o(t, n) && !Hr.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
}, o: (e, t) => Object.prototype.hasOwnProperty.call(e, t), r: (e) => {
  typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
} }, qs = {};
Hr.r(qs), Hr.d(qs, { hasBrowserEnv: () => fi, hasStandardBrowserEnv: () => $f, hasStandardBrowserWebWorkerEnv: () => Bf, navigator: () => Ys, origin: () => Mf });
var ru = ["C", "E", "M", "B", "H"], ar = { PENDING: "PENDING", IN_PROGRESS: "IN_PROGRESS", COMPLETED: "COMPLETED", SCRATCHED: "SCRATCHED" }, su = { BLOOD: "BLOOD", LAMENESS: "LAMENESS" }, Nn = { POINTS: "POINTS", PERCENT_SENIOR: "PERCENT_SENIOR", PERCENT_YOUTH: "PERCENT_YOUTH" }, Hd = 10;
function Ss(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var ur;
Ss(ur = {}, Nn.POINTS, [{ points: 2 }, { points: 4 }, { eliminate: !0 }]), Ss(ur, Nn.PERCENT_SENIOR, [{ percent: 2 }, { eliminate: !0 }]), Ss(ur, Nn.PERCENT_YOUTH, [{ percent: 0.5 }, { percent: 1 }, { eliminate: !0 }]);
function wt(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var dt, St = { PERCENTAGE: "PERCENTAGE", COLLECTIVE_MARKS: "COLLECTIVE_MARKS", YOUNG_HORSE_AVERAGE: "YOUNG_HORSE_AVERAGE", YOUNG_HORSE_SUBMISSION: "YOUNG_HORSE_SUBMISSION", FEI_CHILDREN_TECHNICAL: "FEI_CHILDREN_TECHNICAL", FEI_CHILDREN_MEDIAN: "FEI_CHILDREN_MEDIAN", FREESTYLE_ARTISTIC: "FREESTYLE_ARTISTIC", FREESTYLE_HARMONY: "FREESTYLE_HARMONY", FREESTYLE_CHOREOGRAPHY: "FREESTYLE_CHOREOGRAPHY", UNRESOLVED: "UNRESOLVED" };
wt(dt = {}, St.PERCENTAGE, "DR123.3"), wt(dt, St.COLLECTIVE_MARKS, "DR123.3"), wt(dt, St.YOUNG_HORSE_AVERAGE, "DR123.3 (Young Horse exception)"), wt(dt, St.YOUNG_HORSE_SUBMISSION, "DR123.3 (Young Horse exception)"), wt(dt, St.FEI_CHILDREN_TECHNICAL, "DR123.3 (FEI Children exception)"), wt(dt, St.FEI_CHILDREN_MEDIAN, "DR123.3 (FEI Children exception)"), wt(dt, St.FREESTYLE_ARTISTIC, "DR129.5"), wt(dt, St.FREESTYLE_HARMONY, "DR129.5"), wt(dt, St.FREESTYLE_CHOREOGRAPHY, "DR129.5"), wt(dt, St.UNRESOLVED, "DR123.3");
var Xt = { PENDING: ar.PENDING, IN_PROGRESS: ar.IN_PROGRESS, CONFIRMED: "CONFIRMED", COMPLETED: ar.COMPLETED, FINAL: "FINAL", SCRATCHED: ar.SCRATCHED }, ce, po;
(function(e) {
  e.assertEqual = (t) => {
  }, e.assertIs = function(t) {
  }, e.assertNever = function(t) {
    throw new Error();
  }, e.arrayToEnum = (t) => {
    const n = {};
    for (const r of t) n[r] = r;
    return n;
  }, e.getValidEnumValues = (t) => {
    const n = e.objectKeys(t).filter((s) => typeof t[t[s]] != "number"), r = {};
    for (const s of n) r[s] = t[s];
    return e.objectValues(r);
  }, e.objectValues = (t) => e.objectKeys(t).map(function(n) {
    return t[n];
  }), e.objectKeys = typeof Object.keys == "function" ? (t) => Object.keys(t) : (t) => {
    const n = [];
    for (const r in t) Object.prototype.hasOwnProperty.call(t, r) && n.push(r);
    return n;
  }, e.find = (t, n) => {
    for (const r of t) if (n(r)) return r;
  }, e.isInteger = typeof Number.isInteger == "function" ? (t) => Number.isInteger(t) : (t) => typeof t == "number" && Number.isFinite(t) && Math.floor(t) === t, e.joinValues = function(t, n = " | ") {
    return t.map((r) => typeof r == "string" ? `'${r}'` : r).join(n);
  }, e.jsonStringifyReplacer = (t, n) => typeof n == "bigint" ? n.toString() : n;
})(ce || (ce = {})), function(e) {
  e.mergeShapes = (t, n) => ({ ...t, ...n });
}(po || (po = {}));
const k = ce.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]), Ft = (e) => {
  switch (typeof e) {
    case "undefined":
      return k.undefined;
    case "string":
      return k.string;
    case "number":
      return Number.isNaN(e) ? k.nan : k.number;
    case "boolean":
      return k.boolean;
    case "function":
      return k.function;
    case "bigint":
      return k.bigint;
    case "symbol":
      return k.symbol;
    case "object":
      return Array.isArray(e) ? k.array : e === null ? k.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? k.promise : typeof Map < "u" && e instanceof Map ? k.map : typeof Set < "u" && e instanceof Set ? k.set : typeof Date < "u" && e instanceof Date ? k.date : k.object;
    default:
      return k.unknown;
  }
}, E = ce.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]);
class Nt extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const n = t || function(i) {
      return i.message;
    }, r = { _errors: [] }, s = (i) => {
      for (const o of i.issues) if (o.code === "invalid_union") o.unionErrors.map(s);
      else if (o.code === "invalid_return_type") s(o.returnTypeError);
      else if (o.code === "invalid_arguments") s(o.argumentsError);
      else if (o.path.length === 0) r._errors.push(n(o));
      else {
        let a = r, u = 0;
        for (; u < o.path.length; ) {
          const c = o.path[u];
          u === o.path.length - 1 ? (a[c] = a[c] || { _errors: [] }, a[c]._errors.push(n(o))) : a[c] = a[c] || { _errors: [] }, a = a[c], u++;
        }
      }
    };
    return s(this), r;
  }
  static assert(t) {
    if (!(t instanceof Nt)) throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, ce.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, r = [];
    for (const s of this.issues) if (s.path.length > 0) {
      const i = s.path[0];
      n[i] = n[i] || [], n[i].push(t(s));
    } else r.push(t(s));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Nt.create = (e) => new Nt(e);
const Hs = (e, t) => {
  let n;
  switch (e.code) {
    case E.invalid_type:
      n = e.received === k.undefined ? "Required" : `Expected ${e.expected}, received ${e.received}`;
      break;
    case E.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, ce.jsonStringifyReplacer)}`;
      break;
    case E.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${ce.joinValues(e.keys, ", ")}`;
      break;
    case E.invalid_union:
      n = "Invalid input";
      break;
    case E.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${ce.joinValues(e.options)}`;
      break;
    case E.invalid_enum_value:
      n = `Invalid enum value. Expected ${ce.joinValues(e.options)}, received '${e.received}'`;
      break;
    case E.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case E.invalid_return_type:
      n = "Invalid function return type";
      break;
    case E.invalid_date:
      n = "Invalid date";
      break;
    case E.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : ce.assertNever(e.validation) : n = e.validation !== "regex" ? `Invalid ${e.validation}` : "Invalid";
      break;
    case E.too_small:
      n = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" || e.type === "bigint" ? `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : "Invalid input";
      break;
    case E.too_big:
      n = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : "Invalid input";
      break;
    case E.custom:
      n = "Invalid input";
      break;
    case E.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case E.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case E.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, ce.assertNever(e);
  }
  return { message: n };
};
let Zd = Hs;
var A;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(A || (A = {}));
function T(e, t) {
  const n = Zd, r = ((s) => {
    const { data: i, path: o, errorMaps: a, issueData: u } = s, c = [...o, ...u.path || []], l = { ...u, path: c };
    if (u.message !== void 0) return { ...u, path: c, message: u.message };
    let d = "";
    const f = a.filter((h) => !!h).slice().reverse();
    for (const h of f) d = h(l, { data: i, defaultError: d }).message;
    return { ...u, path: c, message: d };
  })({ issueData: t, data: e.data, path: e.path, errorMaps: [e.common.contextualErrorMap, e.schemaErrorMap, n, n === Hs ? void 0 : Hs].filter((s) => !!s) });
  e.common.issues.push(r);
}
class We {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const r = [];
    for (const s of n) {
      if (s.status === "aborted") return V;
      s.status === "dirty" && t.dirty(), r.push(s.value);
    }
    return { status: t.value, value: r };
  }
  static async mergeObjectAsync(t, n) {
    const r = [];
    for (const s of n) {
      const i = await s.key, o = await s.value;
      r.push({ key: i, value: o });
    }
    return We.mergeObjectSync(t, r);
  }
  static mergeObjectSync(t, n) {
    const r = {};
    for (const s of n) {
      const { key: i, value: o } = s;
      if (i.status === "aborted" || o.status === "aborted") return V;
      i.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), i.value === "__proto__" || o.value === void 0 && !s.alwaysSet || (r[i.value] = o.value);
    }
    return { status: t.value, value: r };
  }
}
const V = Object.freeze({ status: "aborted" }), Zs = (e) => ({ status: "dirty", value: e }), ot = (e) => ({ status: "valid", value: e }), mo = (e) => e.status === "aborted", go = (e) => e.status === "dirty", dn = (e) => e.status === "valid", Zr = (e) => typeof Promise < "u" && e instanceof Promise;
class Ct {
  constructor(t, n, r, s) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = r, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const vo = (e, t) => {
  if (dn(t)) return { success: !0, data: t.value };
  if (!e.common.issues.length) throw new Error("Validation failed but no issues detected.");
  return { success: !1, get error() {
    if (this._error) return this._error;
    const n = new Nt(e.common.issues);
    return this._error = n, this._error;
  } };
};
function X(e) {
  if (!e) return {};
  const { errorMap: t, invalid_type_error: n, required_error: r, description: s } = e;
  if (t && (n || r)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: s } : { errorMap: (i, o) => {
    const { message: a } = e;
    return i.code === "invalid_enum_value" ? { message: a ?? o.defaultError } : o.data === void 0 ? { message: a ?? r ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: a ?? n ?? o.defaultError };
  }, description: s };
}
class se {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Ft(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || { common: t.parent.common, data: t.data, parsedType: Ft(t.data), schemaErrorMap: this._def.errorMap, path: t.path, parent: t.parent };
  }
  _processInputParams(t) {
    return { status: new We(), ctx: { common: t.parent.common, data: t.data, parsedType: Ft(t.data), schemaErrorMap: this._def.errorMap, path: t.path, parent: t.parent } };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (Zr(n)) throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const r = this.safeParse(t, n);
    if (r.success) return r.data;
    throw r.error;
  }
  safeParse(t, n) {
    const r = { common: { issues: [], async: (n == null ? void 0 : n.async) ?? !1, contextualErrorMap: n == null ? void 0 : n.errorMap }, path: (n == null ? void 0 : n.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: t, parsedType: Ft(t) }, s = this._parseSync({ data: t, path: r.path, parent: r });
    return vo(r, s);
  }
  "~validate"(t) {
    var r, s;
    const n = { common: { issues: [], async: !!this["~standard"].async }, path: [], schemaErrorMap: this._def.errorMap, parent: null, data: t, parsedType: Ft(t) };
    if (!this["~standard"].async) try {
      const i = this._parseSync({ data: t, path: [], parent: n });
      return dn(i) ? { value: i.value } : { issues: n.common.issues };
    } catch (i) {
      (s = (r = i == null ? void 0 : i.message) == null ? void 0 : r.toLowerCase()) != null && s.includes("encountered") && (this["~standard"].async = !0), n.common = { issues: [], async: !0 };
    }
    return this._parseAsync({ data: t, path: [], parent: n }).then((i) => dn(i) ? { value: i.value } : { issues: n.common.issues });
  }
  async parseAsync(t, n) {
    const r = await this.safeParseAsync(t, n);
    if (r.success) return r.data;
    throw r.error;
  }
  async safeParseAsync(t, n) {
    const r = { common: { issues: [], contextualErrorMap: n == null ? void 0 : n.errorMap, async: !0 }, path: (n == null ? void 0 : n.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: t, parsedType: Ft(t) }, s = this._parse({ data: t, path: r.path, parent: r }), i = await (Zr(s) ? s : Promise.resolve(s));
    return vo(r, i);
  }
  refine(t, n) {
    const r = (s) => typeof n == "string" || n === void 0 ? { message: n } : typeof n == "function" ? n(s) : n;
    return this._refinement((s, i) => {
      const o = t(s), a = () => i.addIssue({ code: E.custom, ...r(s) });
      return typeof Promise < "u" && o instanceof Promise ? o.then((u) => !!u || (a(), !1)) : !!o || (a(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((r, s) => !!t(r) || (s.addIssue(typeof n == "function" ? n(r, s) : n), !1));
  }
  _refinement(t) {
    return new nn({ schema: this, typeName: W.ZodEffects, effect: { type: "refinement", refinement: t } });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = { version: 1, vendor: "zod", validate: (n) => this["~validate"](n) };
  }
  optional() {
    return Bt.create(this, this._def);
  }
  nullable() {
    return pn.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Ot.create(this);
  }
  promise() {
    return Jr.create(this, this._def);
  }
  or(t) {
    return Wr.create([this, t], this._def);
  }
  and(t) {
    return Vr.create(this, t, this._def);
  }
  transform(t) {
    return new nn({ ...X(this._def), schema: this, typeName: W.ZodEffects, effect: { type: "transform", transform: t } });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Vs({ ...X(this._def), innerType: this, defaultValue: n, typeName: W.ZodDefault });
  }
  brand() {
    return new ff({ typeName: W.ZodBranded, type: this, ...X(this._def) });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Js({ ...X(this._def), innerType: this, catchValue: n, typeName: W.ZodCatch });
  }
  describe(t) {
    return new this.constructor({ ...this._def, description: t });
  }
  pipe(t) {
    return li.create(this, t);
  }
  readonly() {
    return Ks.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Gd = /^c[^\s-]{8,}$/i, Wd = /^[0-9a-z]+$/, Vd = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Jd = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Kd = /^[a-z0-9_-]{21}$/i, Yd = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Xd = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Qd = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
let xs;
const ef = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, tf = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, nf = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, rf = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, sf = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, of = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, iu = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", af = new RegExp(`^${iu}$`);
function ou(e) {
  let t = "[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), `([01]\\d|2[0-3]):[0-5]\\d(:${t})${e.precision ? "+" : "?"}`;
}
function uf(e) {
  let t = `${iu}T${ou(e)}`;
  const n = [];
  return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, new RegExp(`^${t}$`);
}
function cf(e, t) {
  if (!Yd.test(e)) return !1;
  try {
    const [n] = e.split(".");
    if (!n) return !1;
    const r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), s = JSON.parse(atob(r));
    return !(typeof s != "object" || s === null || "typ" in s && (s == null ? void 0 : s.typ) !== "JWT" || !s.alg || t && s.alg !== t);
  } catch {
    return !1;
  }
}
function lf(e, t) {
  return !(t !== "v4" && t || !tf.test(e)) || !(t !== "v6" && t || !rf.test(e));
}
class Ut extends se {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== k.string) {
      const o = this._getOrReturnCtx(t);
      return T(o, { code: E.invalid_type, expected: k.string, received: o.parsedType }), V;
    }
    const n = new We();
    let r;
    for (const o of this._def.checks) if (o.kind === "min") t.data.length < o.value && (r = this._getOrReturnCtx(t, r), T(r, { code: E.too_small, minimum: o.value, type: "string", inclusive: !0, exact: !1, message: o.message }), n.dirty());
    else if (o.kind === "max") t.data.length > o.value && (r = this._getOrReturnCtx(t, r), T(r, { code: E.too_big, maximum: o.value, type: "string", inclusive: !0, exact: !1, message: o.message }), n.dirty());
    else if (o.kind === "length") {
      const a = t.data.length > o.value, u = t.data.length < o.value;
      (a || u) && (r = this._getOrReturnCtx(t, r), a ? T(r, { code: E.too_big, maximum: o.value, type: "string", inclusive: !0, exact: !0, message: o.message }) : u && T(r, { code: E.too_small, minimum: o.value, type: "string", inclusive: !0, exact: !0, message: o.message }), n.dirty());
    } else if (o.kind === "email") Qd.test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "email", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "emoji") xs || (xs = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u")), xs.test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "emoji", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "uuid") Jd.test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "uuid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "nanoid") Kd.test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "nanoid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "cuid") Gd.test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "cuid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "cuid2") Wd.test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "cuid2", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "ulid") Vd.test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "ulid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "url") try {
      new URL(t.data);
    } catch {
      r = this._getOrReturnCtx(t, r), T(r, { validation: "url", code: E.invalid_string, message: o.message }), n.dirty();
    }
    else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "regex", code: E.invalid_string, message: o.message }), n.dirty())) : o.kind === "trim" ? t.data = t.data.trim() : o.kind === "includes" ? t.data.includes(o.value, o.position) || (r = this._getOrReturnCtx(t, r), T(r, { code: E.invalid_string, validation: { includes: o.value, position: o.position }, message: o.message }), n.dirty()) : o.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : o.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : o.kind === "startsWith" ? t.data.startsWith(o.value) || (r = this._getOrReturnCtx(t, r), T(r, { code: E.invalid_string, validation: { startsWith: o.value }, message: o.message }), n.dirty()) : o.kind === "endsWith" ? t.data.endsWith(o.value) || (r = this._getOrReturnCtx(t, r), T(r, { code: E.invalid_string, validation: { endsWith: o.value }, message: o.message }), n.dirty()) : o.kind === "datetime" ? uf(o).test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { code: E.invalid_string, validation: "datetime", message: o.message }), n.dirty()) : o.kind === "date" ? af.test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { code: E.invalid_string, validation: "date", message: o.message }), n.dirty()) : o.kind === "time" ? new RegExp(`^${ou(o)}$`).test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { code: E.invalid_string, validation: "time", message: o.message }), n.dirty()) : o.kind === "duration" ? Xd.test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "duration", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "ip" ? (s = t.data, ((i = o.version) !== "v4" && i || !ef.test(s)) && (i !== "v6" && i || !nf.test(s)) && (r = this._getOrReturnCtx(t, r), T(r, { validation: "ip", code: E.invalid_string, message: o.message }), n.dirty())) : o.kind === "jwt" ? cf(t.data, o.alg) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "jwt", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "cidr" ? lf(t.data, o.version) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "cidr", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "base64" ? sf.test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "base64", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "base64url" ? of.test(t.data) || (r = this._getOrReturnCtx(t, r), T(r, { validation: "base64url", code: E.invalid_string, message: o.message }), n.dirty()) : ce.assertNever(o);
    var s, i;
    return { status: n.value, value: t.data };
  }
  _regex(t, n, r) {
    return this.refinement((s) => t.test(s), { validation: n, code: E.invalid_string, ...A.errToObj(r) });
  }
  _addCheck(t) {
    return new Ut({ ...this._def, checks: [...this._def.checks, t] });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...A.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...A.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...A.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...A.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...A.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...A.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...A.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...A.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...A.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({ kind: "base64url", ...A.errToObj(t) });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...A.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...A.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...A.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({ kind: "datetime", precision: null, offset: !1, local: !1, message: t }) : this._addCheck({ kind: "datetime", precision: (t == null ? void 0 : t.precision) === void 0 ? null : t == null ? void 0 : t.precision, offset: (t == null ? void 0 : t.offset) ?? !1, local: (t == null ? void 0 : t.local) ?? !1, ...A.errToObj(t == null ? void 0 : t.message) });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({ kind: "time", precision: null, message: t }) : this._addCheck({ kind: "time", precision: (t == null ? void 0 : t.precision) === void 0 ? null : t == null ? void 0 : t.precision, ...A.errToObj(t == null ? void 0 : t.message) });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...A.errToObj(t) });
  }
  regex(t, n) {
    return this._addCheck({ kind: "regex", regex: t, ...A.errToObj(n) });
  }
  includes(t, n) {
    return this._addCheck({ kind: "includes", value: t, position: n == null ? void 0 : n.position, ...A.errToObj(n == null ? void 0 : n.message) });
  }
  startsWith(t, n) {
    return this._addCheck({ kind: "startsWith", value: t, ...A.errToObj(n) });
  }
  endsWith(t, n) {
    return this._addCheck({ kind: "endsWith", value: t, ...A.errToObj(n) });
  }
  min(t, n) {
    return this._addCheck({ kind: "min", value: t, ...A.errToObj(n) });
  }
  max(t, n) {
    return this._addCheck({ kind: "max", value: t, ...A.errToObj(n) });
  }
  length(t, n) {
    return this._addCheck({ kind: "length", value: t, ...A.errToObj(n) });
  }
  nonempty(t) {
    return this.min(1, A.errToObj(t));
  }
  trim() {
    return new Ut({ ...this._def, checks: [...this._def.checks, { kind: "trim" }] });
  }
  toLowerCase() {
    return new Ut({ ...this._def, checks: [...this._def.checks, { kind: "toLowerCase" }] });
  }
  toUpperCase() {
    return new Ut({ ...this._def, checks: [...this._def.checks, { kind: "toUpperCase" }] });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks) n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks) n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
function df(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, s = n > r ? n : r;
  return Number.parseInt(e.toFixed(s).replace(".", "")) % Number.parseInt(t.toFixed(s).replace(".", "")) / 10 ** s;
}
Ut.create = (e) => new Ut({ checks: [], typeName: W.ZodString, coerce: (e == null ? void 0 : e.coerce) ?? !1, ...X(e) });
class fn extends se {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== k.number) {
      const s = this._getOrReturnCtx(t);
      return T(s, { code: E.invalid_type, expected: k.number, received: s.parsedType }), V;
    }
    let n;
    const r = new We();
    for (const s of this._def.checks) s.kind === "int" ? ce.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), T(n, { code: E.invalid_type, expected: "integer", received: "float", message: s.message }), r.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), T(n, { code: E.too_small, minimum: s.value, type: "number", inclusive: s.inclusive, exact: !1, message: s.message }), r.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), T(n, { code: E.too_big, maximum: s.value, type: "number", inclusive: s.inclusive, exact: !1, message: s.message }), r.dirty()) : s.kind === "multipleOf" ? df(t.data, s.value) !== 0 && (n = this._getOrReturnCtx(t, n), T(n, { code: E.not_multiple_of, multipleOf: s.value, message: s.message }), r.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), T(n, { code: E.not_finite, message: s.message }), r.dirty()) : ce.assertNever(s);
    return { status: r.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, A.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, A.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, A.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, A.toString(n));
  }
  setLimit(t, n, r, s) {
    return new fn({ ...this._def, checks: [...this._def.checks, { kind: t, value: n, inclusive: r, message: A.toString(s) }] });
  }
  _addCheck(t) {
    return new fn({ ...this._def, checks: [...this._def.checks, t] });
  }
  int(t) {
    return this._addCheck({ kind: "int", message: A.toString(t) });
  }
  positive(t) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !1, message: A.toString(t) });
  }
  negative(t) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !1, message: A.toString(t) });
  }
  nonpositive(t) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !0, message: A.toString(t) });
  }
  nonnegative(t) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !0, message: A.toString(t) });
  }
  multipleOf(t, n) {
    return this._addCheck({ kind: "multipleOf", value: t, message: A.toString(n) });
  }
  finite(t) {
    return this._addCheck({ kind: "finite", message: A.toString(t) });
  }
  safe(t) {
    return this._addCheck({ kind: "min", inclusive: !0, value: Number.MIN_SAFE_INTEGER, message: A.toString(t) })._addCheck({ kind: "max", inclusive: !0, value: Number.MAX_SAFE_INTEGER, message: A.toString(t) });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks) n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks) n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && ce.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf") return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
fn.create = (e) => new fn({ checks: [], typeName: W.ZodNumber, coerce: (e == null ? void 0 : e.coerce) || !1, ...X(e) });
class Zn extends se {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce) try {
      t.data = BigInt(t.data);
    } catch {
      return this._getInvalidInput(t);
    }
    if (this._getType(t) !== k.bigint) return this._getInvalidInput(t);
    let n;
    const r = new We();
    for (const s of this._def.checks) s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), T(n, { code: E.too_small, type: "bigint", minimum: s.value, inclusive: s.inclusive, message: s.message }), r.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), T(n, { code: E.too_big, type: "bigint", maximum: s.value, inclusive: s.inclusive, message: s.message }), r.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), T(n, { code: E.not_multiple_of, multipleOf: s.value, message: s.message }), r.dirty()) : ce.assertNever(s);
    return { status: r.value, value: t.data };
  }
  _getInvalidInput(t) {
    const n = this._getOrReturnCtx(t);
    return T(n, { code: E.invalid_type, expected: k.bigint, received: n.parsedType }), V;
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, A.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, A.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, A.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, A.toString(n));
  }
  setLimit(t, n, r, s) {
    return new Zn({ ...this._def, checks: [...this._def.checks, { kind: t, value: n, inclusive: r, message: A.toString(s) }] });
  }
  _addCheck(t) {
    return new Zn({ ...this._def, checks: [...this._def.checks, t] });
  }
  positive(t) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !1, message: A.toString(t) });
  }
  negative(t) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !1, message: A.toString(t) });
  }
  nonpositive(t) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !0, message: A.toString(t) });
  }
  nonnegative(t) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !0, message: A.toString(t) });
  }
  multipleOf(t, n) {
    return this._addCheck({ kind: "multipleOf", value: t, message: A.toString(n) });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks) n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks) n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Zn.create = (e) => new Zn({ checks: [], typeName: W.ZodBigInt, coerce: (e == null ? void 0 : e.coerce) ?? !1, ...X(e) });
class Gs extends se {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== k.boolean) {
      const n = this._getOrReturnCtx(t);
      return T(n, { code: E.invalid_type, expected: k.boolean, received: n.parsedType }), V;
    }
    return ot(t.data);
  }
}
Gs.create = (e) => new Gs({ typeName: W.ZodBoolean, coerce: (e == null ? void 0 : e.coerce) || !1, ...X(e) });
class Gr extends se {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== k.date) {
      const s = this._getOrReturnCtx(t);
      return T(s, { code: E.invalid_type, expected: k.date, received: s.parsedType }), V;
    }
    if (Number.isNaN(t.data.getTime())) return T(this._getOrReturnCtx(t), { code: E.invalid_date }), V;
    const n = new We();
    let r;
    for (const s of this._def.checks) s.kind === "min" ? t.data.getTime() < s.value && (r = this._getOrReturnCtx(t, r), T(r, { code: E.too_small, message: s.message, inclusive: !0, exact: !1, minimum: s.value, type: "date" }), n.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (r = this._getOrReturnCtx(t, r), T(r, { code: E.too_big, message: s.message, inclusive: !0, exact: !1, maximum: s.value, type: "date" }), n.dirty()) : ce.assertNever(s);
    return { status: n.value, value: new Date(t.data.getTime()) };
  }
  _addCheck(t) {
    return new Gr({ ...this._def, checks: [...this._def.checks, t] });
  }
  min(t, n) {
    return this._addCheck({ kind: "min", value: t.getTime(), message: A.toString(n) });
  }
  max(t, n) {
    return this._addCheck({ kind: "max", value: t.getTime(), message: A.toString(n) });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks) n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks) n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
Gr.create = (e) => new Gr({ checks: [], coerce: (e == null ? void 0 : e.coerce) || !1, typeName: W.ZodDate, ...X(e) });
class bo extends se {
  _parse(t) {
    if (this._getType(t) !== k.symbol) {
      const n = this._getOrReturnCtx(t);
      return T(n, { code: E.invalid_type, expected: k.symbol, received: n.parsedType }), V;
    }
    return ot(t.data);
  }
}
bo.create = (e) => new bo({ typeName: W.ZodSymbol, ...X(e) });
class yo extends se {
  _parse(t) {
    if (this._getType(t) !== k.undefined) {
      const n = this._getOrReturnCtx(t);
      return T(n, { code: E.invalid_type, expected: k.undefined, received: n.parsedType }), V;
    }
    return ot(t.data);
  }
}
yo.create = (e) => new yo({ typeName: W.ZodUndefined, ...X(e) });
class wo extends se {
  _parse(t) {
    if (this._getType(t) !== k.null) {
      const n = this._getOrReturnCtx(t);
      return T(n, { code: E.invalid_type, expected: k.null, received: n.parsedType }), V;
    }
    return ot(t.data);
  }
}
wo.create = (e) => new wo({ typeName: W.ZodNull, ...X(e) });
class So extends se {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return ot(t.data);
  }
}
So.create = (e) => new So({ typeName: W.ZodAny, ...X(e) });
class xo extends se {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return ot(t.data);
  }
}
xo.create = (e) => new xo({ typeName: W.ZodUnknown, ...X(e) });
class $t extends se {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return T(n, { code: E.invalid_type, expected: k.never, received: n.parsedType }), V;
  }
}
$t.create = (e) => new $t({ typeName: W.ZodNever, ...X(e) });
class Ro extends se {
  _parse(t) {
    if (this._getType(t) !== k.undefined) {
      const n = this._getOrReturnCtx(t);
      return T(n, { code: E.invalid_type, expected: k.void, received: n.parsedType }), V;
    }
    return ot(t.data);
  }
}
Ro.create = (e) => new Ro({ typeName: W.ZodVoid, ...X(e) });
class Ot extends se {
  _parse(t) {
    const { ctx: n, status: r } = this._processInputParams(t), s = this._def;
    if (n.parsedType !== k.array) return T(n, { code: E.invalid_type, expected: k.array, received: n.parsedType }), V;
    if (s.exactLength !== null) {
      const o = n.data.length > s.exactLength.value, a = n.data.length < s.exactLength.value;
      (o || a) && (T(n, { code: o ? E.too_big : E.too_small, minimum: a ? s.exactLength.value : void 0, maximum: o ? s.exactLength.value : void 0, type: "array", inclusive: !0, exact: !0, message: s.exactLength.message }), r.dirty());
    }
    if (s.minLength !== null && n.data.length < s.minLength.value && (T(n, { code: E.too_small, minimum: s.minLength.value, type: "array", inclusive: !0, exact: !1, message: s.minLength.message }), r.dirty()), s.maxLength !== null && n.data.length > s.maxLength.value && (T(n, { code: E.too_big, maximum: s.maxLength.value, type: "array", inclusive: !0, exact: !1, message: s.maxLength.message }), r.dirty()), n.common.async) return Promise.all([...n.data].map((o, a) => s.type._parseAsync(new Ct(n, o, n.path, a)))).then((o) => We.mergeArray(r, o));
    const i = [...n.data].map((o, a) => s.type._parseSync(new Ct(n, o, n.path, a)));
    return We.mergeArray(r, i);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new Ot({ ...this._def, minLength: { value: t, message: A.toString(n) } });
  }
  max(t, n) {
    return new Ot({ ...this._def, maxLength: { value: t, message: A.toString(n) } });
  }
  length(t, n) {
    return new Ot({ ...this._def, exactLength: { value: t, message: A.toString(n) } });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
function en(e) {
  if (e instanceof Ne) {
    const t = {};
    for (const n in e.shape) {
      const r = e.shape[n];
      t[n] = Bt.create(en(r));
    }
    return new Ne({ ...e._def, shape: () => t });
  }
  return e instanceof Ot ? new Ot({ ...e._def, type: en(e.element) }) : e instanceof Bt ? Bt.create(en(e.unwrap())) : e instanceof pn ? pn.create(en(e.unwrap())) : e instanceof Wt ? Wt.create(e.items.map((t) => en(t))) : e;
}
Ot.create = (e, t) => new Ot({ type: e, minLength: null, maxLength: null, exactLength: null, typeName: W.ZodArray, ...X(t) });
class Ne extends se {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null) return this._cached;
    const t = this._def.shape(), n = ce.objectKeys(t);
    return this._cached = { shape: t, keys: n }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== k.object) {
      const u = this._getOrReturnCtx(t);
      return T(u, { code: E.invalid_type, expected: k.object, received: u.parsedType }), V;
    }
    const { status: n, ctx: r } = this._processInputParams(t), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof $t && this._def.unknownKeys === "strip")) for (const u in r.data) i.includes(u) || o.push(u);
    const a = [];
    for (const u of i) {
      const c = s[u], l = r.data[u];
      a.push({ key: { status: "valid", value: u }, value: c._parse(new Ct(r, l, r.path, u)), alwaysSet: u in r.data });
    }
    if (this._def.catchall instanceof $t) {
      const u = this._def.unknownKeys;
      if (u === "passthrough") for (const c of o) a.push({ key: { status: "valid", value: c }, value: { status: "valid", value: r.data[c] } });
      else if (u === "strict") o.length > 0 && (T(r, { code: E.unrecognized_keys, keys: o }), n.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const c of o) {
        const l = r.data[c];
        a.push({ key: { status: "valid", value: c }, value: u._parse(new Ct(r, l, r.path, c)), alwaysSet: c in r.data });
      }
    }
    return r.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const c of a) {
        const l = await c.key, d = await c.value;
        u.push({ key: l, value: d, alwaysSet: c.alwaysSet });
      }
      return u;
    }).then((u) => We.mergeObjectSync(n, u)) : We.mergeObjectSync(n, a);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return A.errToObj, new Ne({ ...this._def, unknownKeys: "strict", ...t !== void 0 ? { errorMap: (n, r) => {
      var i, o;
      const s = ((o = (i = this._def).errorMap) == null ? void 0 : o.call(i, n, r).message) ?? r.defaultError;
      return n.code === "unrecognized_keys" ? { message: A.errToObj(t).message ?? s } : { message: s };
    } } : {} });
  }
  strip() {
    return new Ne({ ...this._def, unknownKeys: "strip" });
  }
  passthrough() {
    return new Ne({ ...this._def, unknownKeys: "passthrough" });
  }
  extend(t) {
    return new Ne({ ...this._def, shape: () => ({ ...this._def.shape(), ...t }) });
  }
  merge(t) {
    return new Ne({ unknownKeys: t._def.unknownKeys, catchall: t._def.catchall, shape: () => ({ ...this._def.shape(), ...t._def.shape() }), typeName: W.ZodObject });
  }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  catchall(t) {
    return new Ne({ ...this._def, catchall: t });
  }
  pick(t) {
    const n = {};
    for (const r of ce.objectKeys(t)) t[r] && this.shape[r] && (n[r] = this.shape[r]);
    return new Ne({ ...this._def, shape: () => n });
  }
  omit(t) {
    const n = {};
    for (const r of ce.objectKeys(this.shape)) t[r] || (n[r] = this.shape[r]);
    return new Ne({ ...this._def, shape: () => n });
  }
  deepPartial() {
    return en(this);
  }
  partial(t) {
    const n = {};
    for (const r of ce.objectKeys(this.shape)) {
      const s = this.shape[r];
      t && !t[r] ? n[r] = s : n[r] = s.optional();
    }
    return new Ne({ ...this._def, shape: () => n });
  }
  required(t) {
    const n = {};
    for (const r of ce.objectKeys(this.shape)) if (t && !t[r]) n[r] = this.shape[r];
    else {
      let s = this.shape[r];
      for (; s instanceof Bt; ) s = s._def.innerType;
      n[r] = s;
    }
    return new Ne({ ...this._def, shape: () => n });
  }
  keyof() {
    return au(ce.objectKeys(this.shape));
  }
}
Ne.create = (e, t) => new Ne({ shape: () => e, unknownKeys: "strip", catchall: $t.create(), typeName: W.ZodObject, ...X(t) }), Ne.strictCreate = (e, t) => new Ne({ shape: () => e, unknownKeys: "strict", catchall: $t.create(), typeName: W.ZodObject, ...X(t) }), Ne.lazycreate = (e, t) => new Ne({ shape: e, unknownKeys: "strip", catchall: $t.create(), typeName: W.ZodObject, ...X(t) });
class Wr extends se {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = this._def.options;
    if (n.common.async) return Promise.all(r.map(async (s) => {
      const i = { ...n, common: { ...n.common, issues: [] }, parent: null };
      return { result: await s._parseAsync({ data: n.data, path: n.path, parent: i }), ctx: i };
    })).then(function(s) {
      for (const o of s) if (o.result.status === "valid") return o.result;
      for (const o of s) if (o.result.status === "dirty") return n.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new Nt(o.ctx.common.issues));
      return T(n, { code: E.invalid_union, unionErrors: i }), V;
    });
    {
      let s;
      const i = [];
      for (const a of r) {
        const u = { ...n, common: { ...n.common, issues: [] }, parent: null }, c = a._parseSync({ data: n.data, path: n.path, parent: u });
        if (c.status === "valid") return c;
        c.status !== "dirty" || s || (s = { result: c, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (s) return n.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((a) => new Nt(a));
      return T(n, { code: E.invalid_union, unionErrors: o }), V;
    }
  }
  get options() {
    return this._def.options;
  }
}
function Ws(e, t) {
  const n = Ft(e), r = Ft(t);
  if (e === t) return { valid: !0, data: e };
  if (n === k.object && r === k.object) {
    const s = ce.objectKeys(t), i = ce.objectKeys(e).filter((a) => s.indexOf(a) !== -1), o = { ...e, ...t };
    for (const a of i) {
      const u = Ws(e[a], t[a]);
      if (!u.valid) return { valid: !1 };
      o[a] = u.data;
    }
    return { valid: !0, data: o };
  }
  if (n === k.array && r === k.array) {
    if (e.length !== t.length) return { valid: !1 };
    const s = [];
    for (let i = 0; i < e.length; i++) {
      const o = Ws(e[i], t[i]);
      if (!o.valid) return { valid: !1 };
      s.push(o.data);
    }
    return { valid: !0, data: s };
  }
  return n === k.date && r === k.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
Wr.create = (e, t) => new Wr({ options: e, typeName: W.ZodUnion, ...X(t) });
class Vr extends se {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), s = (i, o) => {
      if (mo(i) || mo(o)) return V;
      const a = Ws(i.value, o.value);
      return a.valid ? ((go(i) || go(o)) && n.dirty(), { status: n.value, value: a.data }) : (T(r, { code: E.invalid_intersection_types }), V);
    };
    return r.common.async ? Promise.all([this._def.left._parseAsync({ data: r.data, path: r.path, parent: r }), this._def.right._parseAsync({ data: r.data, path: r.path, parent: r })]).then(([i, o]) => s(i, o)) : s(this._def.left._parseSync({ data: r.data, path: r.path, parent: r }), this._def.right._parseSync({ data: r.data, path: r.path, parent: r }));
  }
}
Vr.create = (e, t, n) => new Vr({ left: e, right: t, typeName: W.ZodIntersection, ...X(n) });
class Wt extends se {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== k.array) return T(r, { code: E.invalid_type, expected: k.array, received: r.parsedType }), V;
    if (r.data.length < this._def.items.length) return T(r, { code: E.too_small, minimum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), V;
    !this._def.rest && r.data.length > this._def.items.length && (T(r, { code: E.too_big, maximum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), n.dirty());
    const s = [...r.data].map((i, o) => {
      const a = this._def.items[o] || this._def.rest;
      return a ? a._parse(new Ct(r, i, r.path, o)) : null;
    }).filter((i) => !!i);
    return r.common.async ? Promise.all(s).then((i) => We.mergeArray(n, i)) : We.mergeArray(n, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Wt({ ...this._def, rest: t });
  }
}
Wt.create = (e, t) => {
  if (!Array.isArray(e)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Wt({ items: e, typeName: W.ZodTuple, rest: null, ...X(t) });
};
class ci extends se {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== k.object) return T(r, { code: E.invalid_type, expected: k.object, received: r.parsedType }), V;
    const s = [], i = this._def.keyType, o = this._def.valueType;
    for (const a in r.data) s.push({ key: i._parse(new Ct(r, a, r.path, a)), value: o._parse(new Ct(r, r.data[a], r.path, a)), alwaysSet: a in r.data });
    return r.common.async ? We.mergeObjectAsync(n, s) : We.mergeObjectSync(n, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, r) {
    return new ci(n instanceof se ? { keyType: t, valueType: n, typeName: W.ZodRecord, ...X(r) } : { keyType: Ut.create(), valueType: t, typeName: W.ZodRecord, ...X(n) });
  }
}
class Oo extends se {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== k.map) return T(r, { code: E.invalid_type, expected: k.map, received: r.parsedType }), V;
    const s = this._def.keyType, i = this._def.valueType, o = [...r.data.entries()].map(([a, u], c) => ({ key: s._parse(new Ct(r, a, r.path, [c, "key"])), value: i._parse(new Ct(r, u, r.path, [c, "value"])) }));
    if (r.common.async) {
      const a = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of o) {
          const c = await u.key, l = await u.value;
          if (c.status === "aborted" || l.status === "aborted") return V;
          c.status !== "dirty" && l.status !== "dirty" || n.dirty(), a.set(c.value, l.value);
        }
        return { status: n.value, value: a };
      });
    }
    {
      const a = /* @__PURE__ */ new Map();
      for (const u of o) {
        const c = u.key, l = u.value;
        if (c.status === "aborted" || l.status === "aborted") return V;
        c.status !== "dirty" && l.status !== "dirty" || n.dirty(), a.set(c.value, l.value);
      }
      return { status: n.value, value: a };
    }
  }
}
Oo.create = (e, t, n) => new Oo({ valueType: t, keyType: e, typeName: W.ZodMap, ...X(n) });
class Gn extends se {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== k.set) return T(r, { code: E.invalid_type, expected: k.set, received: r.parsedType }), V;
    const s = this._def;
    s.minSize !== null && r.data.size < s.minSize.value && (T(r, { code: E.too_small, minimum: s.minSize.value, type: "set", inclusive: !0, exact: !1, message: s.minSize.message }), n.dirty()), s.maxSize !== null && r.data.size > s.maxSize.value && (T(r, { code: E.too_big, maximum: s.maxSize.value, type: "set", inclusive: !0, exact: !1, message: s.maxSize.message }), n.dirty());
    const i = this._def.valueType;
    function o(u) {
      const c = /* @__PURE__ */ new Set();
      for (const l of u) {
        if (l.status === "aborted") return V;
        l.status === "dirty" && n.dirty(), c.add(l.value);
      }
      return { status: n.value, value: c };
    }
    const a = [...r.data.values()].map((u, c) => i._parse(new Ct(r, u, r.path, c)));
    return r.common.async ? Promise.all(a).then((u) => o(u)) : o(a);
  }
  min(t, n) {
    return new Gn({ ...this._def, minSize: { value: t, message: A.toString(n) } });
  }
  max(t, n) {
    return new Gn({ ...this._def, maxSize: { value: t, message: A.toString(n) } });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Gn.create = (e, t) => new Gn({ valueType: e, minSize: null, maxSize: null, typeName: W.ZodSet, ...X(t) });
class _o extends se {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
_o.create = (e, t) => new _o({ getter: e, typeName: W.ZodLazy, ...X(t) });
class Eo extends se {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return T(n, { received: n.data, code: E.invalid_literal, expected: this._def.value }), V;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
function au(e, t) {
  return new hn({ values: e, typeName: W.ZodEnum, ...X(t) });
}
Eo.create = (e, t) => new Eo({ value: e, typeName: W.ZodLiteral, ...X(t) });
class hn extends se {
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return T(n, { expected: ce.joinValues(r), received: n.parsedType, code: E.invalid_type }), V;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(t.data)) {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return T(n, { received: n.data, code: E.invalid_enum_value, options: r }), V;
    }
    return ot(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values) t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values) t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values) t[n] = n;
    return t;
  }
  extract(t, n = this._def) {
    return hn.create(t, { ...this._def, ...n });
  }
  exclude(t, n = this._def) {
    return hn.create(this.options.filter((r) => !t.includes(r)), { ...this._def, ...n });
  }
}
hn.create = au;
class Co extends se {
  _parse(t) {
    const n = ce.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(t);
    if (r.parsedType !== k.string && r.parsedType !== k.number) {
      const s = ce.objectValues(n);
      return T(r, { expected: ce.joinValues(s), received: r.parsedType, code: E.invalid_type }), V;
    }
    if (this._cache || (this._cache = new Set(ce.getValidEnumValues(this._def.values))), !this._cache.has(t.data)) {
      const s = ce.objectValues(n);
      return T(r, { received: r.data, code: E.invalid_enum_value, options: s }), V;
    }
    return ot(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Co.create = (e, t) => new Co({ values: e, typeName: W.ZodNativeEnum, ...X(t) });
class Jr extends se {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== k.promise && n.common.async === !1) return T(n, { code: E.invalid_type, expected: k.promise, received: n.parsedType }), V;
    const r = n.parsedType === k.promise ? n.data : Promise.resolve(n.data);
    return ot(r.then((s) => this._def.type.parseAsync(s, { path: n.path, errorMap: n.common.contextualErrorMap })));
  }
}
Jr.create = (e, t) => new Jr({ type: e, typeName: W.ZodPromise, ...X(t) });
class nn extends se {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === W.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), s = this._def.effect || null, i = { addIssue: (o) => {
      T(r, o), o.fatal ? n.abort() : n.dirty();
    }, get path() {
      return r.path;
    } };
    if (i.addIssue = i.addIssue.bind(i), s.type === "preprocess") {
      const o = s.transform(r.data, i);
      if (r.common.async) return Promise.resolve(o).then(async (a) => {
        if (n.value === "aborted") return V;
        const u = await this._def.schema._parseAsync({ data: a, path: r.path, parent: r });
        return u.status === "aborted" ? V : u.status === "dirty" || n.value === "dirty" ? Zs(u.value) : u;
      });
      {
        if (n.value === "aborted") return V;
        const a = this._def.schema._parseSync({ data: o, path: r.path, parent: r });
        return a.status === "aborted" ? V : a.status === "dirty" || n.value === "dirty" ? Zs(a.value) : a;
      }
    }
    if (s.type === "refinement") {
      const o = (a) => {
        const u = s.refinement(a, i);
        if (r.common.async) return Promise.resolve(u);
        if (u instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return a;
      };
      if (r.common.async === !1) {
        const a = this._def.schema._parseSync({ data: r.data, path: r.path, parent: r });
        return a.status === "aborted" ? V : (a.status === "dirty" && n.dirty(), o(a.value), { status: n.value, value: a.value });
      }
      return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((a) => a.status === "aborted" ? V : (a.status === "dirty" && n.dirty(), o(a.value).then(() => ({ status: n.value, value: a.value }))));
    }
    if (s.type === "transform") {
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({ data: r.data, path: r.path, parent: r });
        if (!dn(o)) return V;
        const a = s.transform(o.value, i);
        if (a instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: a };
      }
      return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => dn(o) ? Promise.resolve(s.transform(o.value, i)).then((a) => ({ status: n.value, value: a })) : V);
    }
    ce.assertNever(s);
  }
}
nn.create = (e, t, n) => new nn({ schema: e, typeName: W.ZodEffects, effect: t, ...X(n) }), nn.createWithPreprocess = (e, t, n) => new nn({ schema: t, effect: { type: "preprocess", transform: e }, typeName: W.ZodEffects, ...X(n) });
class Bt extends se {
  _parse(t) {
    return this._getType(t) === k.undefined ? ot(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Bt.create = (e, t) => new Bt({ innerType: e, typeName: W.ZodOptional, ...X(t) });
class pn extends se {
  _parse(t) {
    return this._getType(t) === k.null ? ot(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
pn.create = (e, t) => new pn({ innerType: e, typeName: W.ZodNullable, ...X(t) });
class Vs extends se {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let r = n.data;
    return n.parsedType === k.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({ data: r, path: n.path, parent: n });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Vs.create = (e, t) => new Vs({ innerType: e, typeName: W.ZodDefault, defaultValue: typeof t.default == "function" ? t.default : () => t.default, ...X(t) });
class Js extends se {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = { ...n, common: { ...n.common, issues: [] } }, s = this._def.innerType._parse({ data: r.data, path: r.path, parent: { ...r } });
    return Zr(s) ? s.then((i) => ({ status: "valid", value: i.status === "valid" ? i.value : this._def.catchValue({ get error() {
      return new Nt(r.common.issues);
    }, input: r.data }) })) : { status: "valid", value: s.status === "valid" ? s.value : this._def.catchValue({ get error() {
      return new Nt(r.common.issues);
    }, input: r.data }) };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Js.create = (e, t) => new Js({ innerType: e, typeName: W.ZodCatch, catchValue: typeof t.catch == "function" ? t.catch : () => t.catch, ...X(t) });
class To extends se {
  _parse(t) {
    if (this._getType(t) !== k.nan) {
      const n = this._getOrReturnCtx(t);
      return T(n, { code: E.invalid_type, expected: k.nan, received: n.parsedType }), V;
    }
    return { status: "valid", value: t.data };
  }
}
To.create = (e) => new To({ typeName: W.ZodNaN, ...X(e) });
class ff extends se {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = n.data;
    return this._def.type._parse({ data: r, path: n.path, parent: n });
  }
  unwrap() {
    return this._def.type;
  }
}
class li extends se {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.common.async) return (async () => {
      const s = await this._def.in._parseAsync({ data: r.data, path: r.path, parent: r });
      return s.status === "aborted" ? V : s.status === "dirty" ? (n.dirty(), Zs(s.value)) : this._def.out._parseAsync({ data: s.value, path: r.path, parent: r });
    })();
    {
      const s = this._def.in._parseSync({ data: r.data, path: r.path, parent: r });
      return s.status === "aborted" ? V : s.status === "dirty" ? (n.dirty(), { status: "dirty", value: s.value }) : this._def.out._parseSync({ data: s.value, path: r.path, parent: r });
    }
  }
  static create(t, n) {
    return new li({ in: t, out: n, typeName: W.ZodPipeline });
  }
}
class Ks extends se {
  _parse(t) {
    const n = this._def.innerType._parse(t), r = (s) => (dn(s) && (s.value = Object.freeze(s.value)), s);
    return Zr(n) ? n.then((s) => r(s)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
var W;
Ks.create = (e, t) => new Ks({ innerType: e, typeName: W.ZodReadonly, ...X(t) }), function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
}(W || (W = {}));
const R = Ut.create, re = fn.create, mn = Gs.create, _t = ($t.create, Ot.create), je = Ne.create, cr = Wr.create, hf = (Vr.create, Wt.create, ci.create), Et = hn.create;
Jr.create, Bt.create, pn.create;
var uu = re().min(0).max(Hd).refine(function(e) {
  return Math.abs(Math.round(10 * e) - 10 * e) < 1e-6;
}, { message: "score must be a multiple of 0.1" }), cu = Et(["N", "C"]), pf = je({ id: R().optional(), type: cu.default("N"), movementNumber: re().int().positive(), description: R(), directive: R().optional(), location: R().optional(), coefficient: re().int().min(1).max(10), section: Et(["technical", "artistic", "quality"]).optional() }), mf = je({ id: R().optional(), type: cu.default("C"), movementNumber: re().int().positive(), name: R(), directive: R().optional(), coefficient: re().int().min(1).max(2) });
je({ id: R(), fvdId: cr([re(), R()]).nullable().optional(), source: Et(["catalog", "custom"]).optional(), testCode: R(), organization: R().optional(), level: R().optional(), testNumber: re().int().optional(), movements: _t(pf), collectives: _t(mf), purpose: R().optional(), introduce: R().optional(), errorRule: je({ first: cr([re(), R()]).nullable().optional(), second: cr([re(), R()]).nullable().optional(), third: cr([re(), R()]).nullable().optional() }).nullable().optional(), collectivesLabel: R().default("Collective Marks") });
var gf = je({ movementNumber: re().int().positive(), score: uu.optional().nullable(), remarks: R().max(500).optional(), flagged: mn().default(!1), annotatedDirective: R().optional(), annotatedDescription: R().optional(), deductions: _t(je({ id: R(), reason: R(), points: re().positive() })).optional() }), vf = je({ score: uu.optional(), remarks: R().max(500).optional(), flagged: mn().optional(), annotatedName: R().optional(), annotatedDirective: R().optional() }), bf = hf(R().regex(/^\d+$/), vf);
je({ id: R().optional(), rideId: R(), judgeId: R(), testId: R(), movementScores: _t(gf).default([]), collectives: bf.default({}), annotatedPurpose: R().optional(), annotatedIntroduce: R().optional(), generalRemarks: R().max(2e3).optional(), entryTimeSeconds: re().nonnegative().optional(), totalPoints: re().optional(), maxPoints: re().optional(), percentage: re().optional(), technicalPoints: re().optional(), technicalMaxPoints: re().optional(), artisticPoints: re().optional(), artisticMaxPoints: re().optional(), qualityPoints: re().optional(), qualityMaxPoints: re().optional(), judgeSignature: R().optional(), signature: je({ judgeId: R(), signatureHash: R(), signedAt: R() }).optional(), eliminations: _t(je({ id: R(), reason: R(), movementNumber: re().int().positive().nullable().optional(), fromError: mn().optional() })).optional(), errors: _t(je({ id: R(), label: R(), points: re().nonnegative().optional(), percent: re().nonnegative().optional(), movementNumber: re().int().positive().nullable().optional() })).optional(), marksConfirmedAt: R().optional(), marksConfirmedBy: R().optional(), timeFault: je({ exceeded: mn(), elapsedSeconds: re(), limitSeconds: re(), recordedAt: R() }).optional(), completedAt: R().optional() });
Et(ru);
var jo = je(Object.fromEntries(ru.map(function(e) {
  return [e, _t(R()).optional()];
})));
je({ id: R(), showId: R(), testId: R().optional(), className: R(), scheduledTime: R(), ring: R().optional(), judgeAssignments: jo.optional(), judgeIds: _t(R()).optional(), scribeAssignments: jo.optional(), qualityJudging: je({ topology: Et(["two-judge", "technical-only"]), qualityPosition: Et(["E", "B"]).nullable().optional(), qualityJudge: R().nullable().optional() }).optional(), faultTimeLimitSeconds: re().int().positive().default(45), errorDeductionScheme: Et(Object.values(Nn)).default(Nn.POINTS), sectionJudgeAssignments: je({ technical: R().nullable().optional(), quality: R().nullable().optional() }).optional(), status: R().optional(), order: re().optional() });
var yf = je({ id: R(), type: Et(Object.values(su)), raisedByScribeId: R().nullable(), raisedAt: R(), acknowledged: je({ byScribeId: R().nullable(), at: R() }).nullable().optional() });
je({ type: Et(Object.values(su)) });
je({ id: R(), classId: R(), testId: R().optional(), horseId: R(), riderId: R(), rideNumber: re().int().positive(), scheduledTime: R().optional(), status: R().optional(), percentage: re().optional(), allSheetsCompletedAt: R().nullable().optional(), adminConfirmedAt: R().nullable().optional(), adminConfirmedBy: R().nullable().optional(), compositePercentage: re().nullable().optional(), placing: re().int().positive().nullable().optional(), isManual: mn().optional(), needsReview: mn().optional(), judgeIds: _t(R()).optional(), competitorNumber: R().optional(), horseName: R().optional(), riderName: R().optional(), trainerId: R().optional(), resolvedIntoRideId: R().nullable().optional(), utilityEvents: _t(yf).optional() });
je({ classId: R(), testId: R().optional(), competitorNumber: R().optional(), horseName: R().optional(), riderName: R().optional() });
je({ id: R(), personType: Et(["RIDER", "JUDGE", "SCRIBE"]), firstName: R(), lastName: R(), usefId: R().optional(), usdfId: R().optional(), email: R().optional(), unlockCode: R().regex(/^\d{4,6}$/, "unlockCode must be 4–6 digits").optional(), userId: R().optional() });
je({ id: R(), name: R(), breed: R().optional(), foalYear: re().int().optional(), usefId: R().optional(), usdfId: R().optional() });
function lu(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: wf } = Object.prototype, { getPrototypeOf: di } = Object, { iterator: Or, toStringTag: du } = Symbol, Kr = (Rs = /* @__PURE__ */ Object.create(null), (e) => {
  const t = wf.call(e);
  return Rs[t] || (Rs[t] = t.slice(8, -1).toLowerCase());
});
var Rs;
const vt = (e) => (e = e.toLowerCase(), (t) => Kr(t) === e), rs = (e) => (t) => typeof t === e, { isArray: tn } = Array, un = rs("undefined");
function Dn(e) {
  return e !== null && !un(e) && e.constructor !== null && !un(e.constructor) && Ke(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const ko = vt("ArrayBuffer"), Sf = rs("string"), Ke = rs("function"), Io = rs("number"), Cn = (e) => e !== null && typeof e == "object", lr = (e) => {
  if (Kr(e) !== "object") return !1;
  const t = di(e);
  return !(t !== null && t !== Object.prototype && Object.getPrototypeOf(t) !== null || du in e || Or in e);
}, xf = vt("Date"), Rf = vt("File"), Of = vt("Blob"), _f = vt("FileList"), Ef = vt("URLSearchParams"), [Cf, Tf, jf, kf] = ["ReadableStream", "Request", "Response", "Headers"].map(vt);
function Un(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e == null) return;
  let r, s;
  if (typeof e != "object" && (e = [e]), tn(e)) for (r = 0, s = e.length; r < s; r++) t.call(null, e[r], r, e);
  else {
    if (Dn(e)) return;
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let a;
    for (r = 0; r < o; r++) a = i[r], t.call(null, e[a], a, e);
  }
}
function Po(e, t) {
  if (Dn(e)) return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r, s = n.length;
  for (; s-- > 0; ) if (r = n[s], t === r.toLowerCase()) return r;
  return null;
}
const Ht = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Ao = (e) => !un(e) && e !== Ht, If = (Os = typeof Uint8Array < "u" && di(Uint8Array), (e) => Os && e instanceof Os);
var Os;
const Pf = vt("HTMLFormElement"), Uo = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Af = vt("RegExp"), Lo = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Un(n, (s, i) => {
    let o;
    (o = t(s, i, e)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(e, r);
}, Uf = vt("AsyncFunction"), fu = (No = typeof setImmediate == "function", Do = Ke(Ht.postMessage), No ? setImmediate : Do ? (_s = `axios@${Math.random()}`, dr = [], Ht.addEventListener("message", ({ source: e, data: t }) => {
  e === Ht && t === _s && dr.length && dr.shift()();
}, !1), (e) => {
  dr.push(e), Ht.postMessage(_s, "*");
}) : (e) => setTimeout(e));
var No, Do, _s, dr;
const Lf = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ht) : typeof process < "u" && process.nextTick || fu, y = { isArray: tn, isArrayBuffer: ko, isBuffer: Dn, isFormData: (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Ke(e.append) && ((t = Kr(e)) === "formdata" || t === "object" && Ke(e.toString) && e.toString() === "[object FormData]"));
}, isArrayBufferView: function(e) {
  let t;
  return t = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && ko(e.buffer), t;
}, isString: Sf, isNumber: Io, isBoolean: (e) => e === !0 || e === !1, isObject: Cn, isPlainObject: lr, isEmptyObject: (e) => {
  if (!Cn(e) || Dn(e)) return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, isReadableStream: Cf, isRequest: Tf, isResponse: jf, isHeaders: kf, isUndefined: un, isDate: xf, isFile: Rf, isBlob: Of, isRegExp: Af, isFunction: Ke, isStream: (e) => Cn(e) && Ke(e.pipe), isURLSearchParams: Ef, isTypedArray: If, isFileList: _f, forEach: Un, merge: function e() {
  const { caseless: t, skipUndefined: n } = Ao(this) && this || {}, r = {}, s = (i, o) => {
    const a = t && Po(r, o) || o;
    lr(r[a]) && lr(i) ? r[a] = e(r[a], i) : lr(i) ? r[a] = e({}, i) : tn(i) ? r[a] = i.slice() : n && un(i) || (r[a] = i);
  };
  for (let i = 0, o = arguments.length; i < o; i++) arguments[i] && Un(arguments[i], s);
  return r;
}, extend: (e, t, n, { allOwnKeys: r } = {}) => (Un(t, (s, i) => {
  n && Ke(s) ? e[i] = lu(s, n) : e[i] = s;
}, { allOwnKeys: r }), e), trim: (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), inherits: (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", { value: t.prototype }), n && Object.assign(e.prototype, n);
}, toFlatObject: (e, t, n, r) => {
  let s, i, o;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; ) o = s[i], r && !r(o, e, t) || a[o] || (t[o] = e[o], a[o] = !0);
    e = n !== !1 && di(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, kindOf: Kr, kindOfTest: vt, endsWith: (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, toArray: (e) => {
  if (!e) return null;
  if (tn(e)) return e;
  let t = e.length;
  if (!Io(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; ) n[t] = e[t];
  return n;
}, forEachEntry: (e, t) => {
  const n = (e && e[Or]).call(e);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const s = r.value;
    t.call(e, s[0], s[1]);
  }
}, matchAll: (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; ) r.push(n);
  return r;
}, isHTMLForm: Pf, hasOwnProperty: Uo, hasOwnProp: Uo, reduceDescriptors: Lo, freezeMethods: (e) => {
  Lo(e, (t, n) => {
    if (Ke(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1) return !1;
    const r = e[n];
    Ke(r) && (t.enumerable = !1, "writable" in t ? t.writable = !1 : t.set || (t.set = () => {
      throw Error("Can not rewrite read-only method '" + n + "'");
    }));
  });
}, toObjectSet: (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return tn(e) ? r(e) : r(String(e).split(t)), n;
}, toCamelCase: (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, n, r) {
  return n.toUpperCase() + r;
}), noop: () => {
}, toFiniteNumber: (e, t) => e != null && Number.isFinite(e = +e) ? e : t, findKey: Po, global: Ht, isContextDefined: Ao, isSpecCompliantForm: function(e) {
  return !!(e && Ke(e.append) && e[du] === "FormData" && e[Or]);
}, toJSONObject: (e) => {
  const t = new Array(10), n = (r, s) => {
    if (Cn(r)) {
      if (t.indexOf(r) >= 0) return;
      if (Dn(r)) return r;
      if (!("toJSON" in r)) {
        t[s] = r;
        const i = tn(r) ? [] : {};
        return Un(r, (o, a) => {
          const u = n(o, s + 1);
          !un(u) && (i[a] = u);
        }), t[s] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, isAsyncFn: Uf, isThenable: (e) => e && (Cn(e) || Ke(e)) && Ke(e.then) && Ke(e.catch), setImmediate: fu, asap: Lf, isIterable: (e) => e != null && Ke(e[Or]) };
function cn(e, t, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
y.inherits(cn, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: y.toJSONObject(this.config), code: this.code, status: this.status };
} });
const Fo = cn.prototype, $o = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((e) => {
  $o[e] = { value: e };
}), Object.defineProperties(cn, $o), Object.defineProperty(Fo, "isAxiosError", { value: !0 }), cn.from = (e, t, n, r, s, i) => {
  const o = Object.create(Fo);
  y.toFlatObject(e, o, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const a = e && e.message ? e.message : "Error", u = t == null && e ? e.code : t;
  return cn.call(o, a, u, n, r, s), e && o.cause == null && Object.defineProperty(o, "cause", { value: e, configurable: !0 }), o.name = e && e.name || "Error", i && Object.assign(o, i), o;
};
const te = cn;
function Es(e) {
  return y.isPlainObject(e) || y.isArray(e);
}
function hu(e) {
  return y.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Bo(e, t, n) {
  return e ? e.concat(t).map(function(r, s) {
    return r = hu(r), !n && s ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
const Nf = y.toFlatObject(y, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
}), Yr = function(e, t, n) {
  if (!y.isObject(e)) throw new TypeError("target must be an object");
  t = t || new FormData();
  const r = (n = y.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(f, h) {
    return !y.isUndefined(h[f]);
  })).metaTokens, s = n.visitor || c, i = n.dots, o = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && y.isSpecCompliantForm(t);
  if (!y.isFunction(s)) throw new TypeError("visitor must be a function");
  function u(f) {
    if (f === null) return "";
    if (y.isDate(f)) return f.toISOString();
    if (y.isBoolean(f)) return f.toString();
    if (!a && y.isBlob(f)) throw new te("Blob is not supported. Use a Buffer instead.");
    return y.isArrayBuffer(f) || y.isTypedArray(f) ? a && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, h, v) {
    let m = f;
    if (f && !v && typeof f == "object") {
      if (y.endsWith(h, "{}")) h = r ? h : h.slice(0, -2), f = JSON.stringify(f);
      else if (y.isArray(f) && function(O) {
        return y.isArray(O) && !O.some(Es);
      }(f) || (y.isFileList(f) || y.endsWith(h, "[]")) && (m = y.toArray(f))) return h = hu(h), m.forEach(function(O, K) {
        !y.isUndefined(O) && O !== null && t.append(o === !0 ? Bo([h], K, i) : o === null ? h : h + "[]", u(O));
      }), !1;
    }
    return !!Es(f) || (t.append(Bo(v, h, i), u(f)), !1);
  }
  const l = [], d = Object.assign(Nf, { defaultVisitor: c, convertValue: u, isVisitable: Es });
  if (!y.isObject(e)) throw new TypeError("data must be an object");
  return function f(h, v) {
    if (!y.isUndefined(h)) {
      if (l.indexOf(h) !== -1) throw Error("Circular reference detected in " + v.join("."));
      l.push(h), y.forEach(h, function(m, O) {
        (!(y.isUndefined(m) || m === null) && s.call(t, m, y.isString(O) ? O.trim() : O, v, d)) === !0 && f(m, v ? v.concat(O) : [O]);
      }), l.pop();
    }
  }(e), t;
};
function Mo(e) {
  const t = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function pu(e, t) {
  this._pairs = [], e && Yr(e, this, t);
}
const zo = pu.prototype;
zo.append = function(e, t) {
  this._pairs.push([e, t]);
}, zo.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, Mo);
  } : Mo;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
const mu = pu;
function Df(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function gu(e, t, n) {
  if (!t) return e;
  const r = n && n.encode || Df;
  y.isFunction(n) && (n = { serialize: n });
  const s = n && n.serialize;
  let i;
  if (i = s ? s(t, n) : y.isURLSearchParams(t) ? t.toString() : new mu(t, n).toString(r), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
const qo = class {
  constructor() {
    this.handlers = [];
  }
  use(e, t, n) {
    return this.handlers.push({ fulfilled: e, rejected: t, synchronous: !!n && n.synchronous, runWhen: n ? n.runWhen : null }), this.handlers.length - 1;
  }
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(e) {
    y.forEach(this.handlers, function(t) {
      t !== null && e(t);
    });
  }
}, vu = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, Ff = { isBrowser: !0, classes: { URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : mu, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, protocols: ["http", "https", "file", "blob", "url", "data"] }, fi = typeof window < "u" && typeof document < "u", Ys = typeof navigator == "object" && navigator || void 0, $f = fi && (!Ys || ["ReactNative", "NativeScript", "NS"].indexOf(Ys.product) < 0), Bf = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Mf = fi && window.location.href || "http://localhost", He = { ...qs, ...Ff }, bu = function(e) {
  function t(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), u = i >= n.length;
    return o = !o && y.isArray(s) ? s.length : o, u ? (y.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !a) : (s[o] && y.isObject(s[o]) || (s[o] = []), t(n, r, s[o], i) && y.isArray(s[o]) && (s[o] = function(c) {
      const l = {}, d = Object.keys(c);
      let f;
      const h = d.length;
      let v;
      for (f = 0; f < h; f++) v = d[f], l[v] = c[v];
      return l;
    }(s[o])), !a);
  }
  if (y.isFormData(e) && y.isFunction(e.entries)) {
    const n = {};
    return y.forEachEntry(e, (r, s) => {
      t(function(i) {
        return y.matchAll(/\w+|\[(\w*)]/g, i).map((o) => o[0] === "[]" ? "" : o[1] || o[0]);
      }(r), s, n, 0);
    }), n;
  }
  return null;
}, hi = { transitional: vu, adapter: ["xhr", "http", "fetch"], transformRequest: [function(e, t) {
  const n = t.getContentType() || "", r = n.indexOf("application/json") > -1, s = y.isObject(e);
  if (s && y.isHTMLForm(e) && (e = new FormData(e)), y.isFormData(e)) return r ? JSON.stringify(bu(e)) : e;
  if (y.isArrayBuffer(e) || y.isBuffer(e) || y.isStream(e) || y.isFile(e) || y.isBlob(e) || y.isReadableStream(e)) return e;
  if (y.isArrayBufferView(e)) return e.buffer;
  if (y.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
  let i;
  if (s) {
    if (n.indexOf("application/x-www-form-urlencoded") > -1) return function(o, a) {
      return Yr(o, new He.classes.URLSearchParams(), { visitor: function(u, c, l, d) {
        return He.isNode && y.isBuffer(u) ? (this.append(c, u.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
      }, ...a });
    }(e, this.formSerializer).toString();
    if ((i = y.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
      const o = this.env && this.env.FormData;
      return Yr(i ? { "files[]": e } : e, o && new o(), this.formSerializer);
    }
  }
  return s || r ? (t.setContentType("application/json", !1), function(o) {
    if (y.isString(o)) try {
      return (0, JSON.parse)(o), y.trim(o);
    } catch (a) {
      if (a.name !== "SyntaxError") throw a;
    }
    return (0, JSON.stringify)(o);
  }(e)) : e;
}], transformResponse: [function(e) {
  const t = this.transitional || hi.transitional, n = t && t.forcedJSONParsing, r = this.responseType === "json";
  if (y.isResponse(e) || y.isReadableStream(e)) return e;
  if (e && y.isString(e) && (n && !this.responseType || r)) {
    const s = !(t && t.silentJSONParsing) && r;
    try {
      return JSON.parse(e, this.parseReviver);
    } catch (i) {
      if (s)
        throw i.name === "SyntaxError" ? te.from(i, te.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return e;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: He.classes.FormData, Blob: He.classes.Blob }, validateStatus: function(e) {
  return e >= 200 && e < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
y.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  hi.headers[e] = {};
});
const pi = hi, zf = y.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), Ho = Symbol("internals");
function Tn(e) {
  return e && String(e).trim().toLowerCase();
}
function _r(e) {
  return e === !1 || e == null ? e : y.isArray(e) ? e.map(_r) : String(e);
}
function Cs(e, t, n, r, s) {
  return y.isFunction(r) ? r.call(this, t, n) : (s && (t = n), y.isString(t) ? y.isString(r) ? t.indexOf(r) !== -1 : y.isRegExp(r) ? r.test(t) : void 0 : void 0);
}
class Er {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function i(a, u, c) {
      const l = Tn(u);
      if (!l) throw new Error("header name must be a non-empty string");
      const d = y.findKey(s, l);
      (!d || s[d] === void 0 || c === !0 || c === void 0 && s[d] !== !1) && (s[d || u] = _r(a));
    }
    const o = (a, u) => y.forEach(a, (c, l) => i(c, l, u));
    if (y.isPlainObject(t) || t instanceof this.constructor) o(t, n);
    else if (y.isString(t) && (t = t.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim())) o(((a) => {
      const u = {};
      let c, l, d;
      return a && a.split(`
`).forEach(function(f) {
        d = f.indexOf(":"), c = f.substring(0, d).trim().toLowerCase(), l = f.substring(d + 1).trim(), !c || u[c] && zf[c] || (c === "set-cookie" ? u[c] ? u[c].push(l) : u[c] = [l] : u[c] = u[c] ? u[c] + ", " + l : l);
      }), u;
    })(t), n);
    else if (y.isObject(t) && y.isIterable(t)) {
      let a, u, c = {};
      for (const l of t) {
        if (!y.isArray(l)) throw TypeError("Object iterator must return a key-value pair");
        c[u = l[0]] = (a = c[u]) ? y.isArray(a) ? [...a, l[1]] : [a, l[1]] : l[1];
      }
      o(c, n);
    } else t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = Tn(t)) {
      const r = y.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n) return s;
        if (n === !0) return function(i) {
          const o = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
          let u;
          for (; u = a.exec(i); ) o[u[1]] = u[2];
          return o;
        }(s);
        if (y.isFunction(n)) return n.call(this, s, r);
        if (y.isRegExp(n)) return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Tn(t)) {
      const r = y.findKey(this, t);
      return !(!r || this[r] === void 0 || n && !Cs(0, this[r], r, n));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = Tn(o)) {
        const a = y.findKey(r, o);
        !a || n && !Cs(0, r[a], a, n) || (delete r[a], s = !0);
      }
    }
    return y.isArray(t) ? t.forEach(i) : i(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      t && !Cs(0, this[i], i, t, !0) || (delete this[i], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return y.forEach(this, (s, i) => {
      const o = y.findKey(r, i);
      if (o) return n[o] = _r(s), void delete n[i];
      const a = t ? function(u) {
        return u.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (c, l, d) => l.toUpperCase() + d);
      }(i) : String(i).trim();
      a !== i && delete n[i], n[a] = _r(s), r[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return y.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && y.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const n = (this[Ho] = this[Ho] = { accessors: {} }).accessors, r = this.prototype;
    function s(i) {
      const o = Tn(i);
      n[o] || (function(a, u) {
        const c = y.toCamelCase(" " + u);
        ["get", "set", "has"].forEach((l) => {
          Object.defineProperty(a, l + c, { value: function(d, f, h) {
            return this[l].call(this, u, d, f, h);
          }, configurable: !0 });
        });
      }(r, i), n[o] = !0);
    }
    return y.isArray(t) ? t.forEach(s) : s(t), this;
  }
}
Er.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), y.reduceDescriptors(Er.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return { get: () => e, set(r) {
    this[n] = r;
  } };
}), y.freezeMethods(Er);
const mt = Er;
function Ts(e, t) {
  const n = this || pi, r = t || n, s = mt.from(r.headers);
  let i = r.data;
  return y.forEach(e, function(o) {
    i = o.call(n, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function yu(e) {
  return !(!e || !e.__CANCEL__);
}
function wu(e, t, n) {
  te.call(this, e ?? "canceled", te.ERR_CANCELED, t, n), this.name = "CanceledError";
}
y.inherits(wu, te, { __CANCEL__: !0 });
const Qn = wu;
function Su(e, t, n) {
  const r = n.config.validateStatus;
  n.status && r && !r(n.status) ? t(new te("Request failed with status code " + n.status, [te.ERR_BAD_REQUEST, te.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : e(n);
}
const Xr = (e, t, n = 3) => {
  let r = 0;
  const s = function(i, o) {
    i = i || 10;
    const a = new Array(i), u = new Array(i);
    let c, l = 0, d = 0;
    return o = o !== void 0 ? o : 1e3, function(f) {
      const h = Date.now(), v = u[d];
      c || (c = h), a[l] = f, u[l] = h;
      let m = d, O = 0;
      for (; m !== l; ) O += a[m++], m %= i;
      if (l = (l + 1) % i, l === d && (d = (d + 1) % i), h - c < o) return;
      const K = v && h - v;
      return K ? Math.round(1e3 * O / K) : void 0;
    };
  }(50, 250);
  return function(i, o) {
    let a, u, c = 0, l = 1e3 / o;
    const d = (f, h = Date.now()) => {
      c = h, a = null, u && (clearTimeout(u), u = null), i(...f);
    };
    return [(...f) => {
      const h = Date.now(), v = h - c;
      v >= l ? d(f, h) : (a = f, u || (u = setTimeout(() => {
        u = null, d(a);
      }, l - v)));
    }, () => a && d(a)];
  }((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, u = o - r, c = s(u);
    r = o, e({ loaded: o, total: a, progress: a ? o / a : void 0, bytes: u, rate: c || void 0, estimated: c && a && o <= a ? (a - o) / c : void 0, event: i, lengthComputable: a != null, [t ? "download" : "upload"]: !0 });
  }, n);
}, Zo = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({ lengthComputable: n, total: e, loaded: r }), t[1]];
}, Go = (e) => (...t) => y.asap(() => e(...t)), qf = He.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, He.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(He.origin), He.navigator && /(msie|trident)/i.test(He.navigator.userAgent)) : () => !0, Hf = He.hasStandardBrowserEnv ? { write(e, t, n, r, s, i, o) {
  if (typeof document > "u") return;
  const a = [`${e}=${encodeURIComponent(t)}`];
  y.isNumber(n) && a.push(`expires=${new Date(n).toUTCString()}`), y.isString(r) && a.push(`path=${r}`), y.isString(s) && a.push(`domain=${s}`), i === !0 && a.push("secure"), y.isString(o) && a.push(`SameSite=${o}`), document.cookie = a.join("; ");
}, read(e) {
  if (typeof document > "u") return null;
  const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
  return t ? decodeURIComponent(t[1]) : null;
}, remove(e) {
  this.write(e, "", Date.now() - 864e5, "/");
} } : { write() {
}, read: () => null, remove() {
} };
function xu(e, t, n) {
  let r = !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
  return e && (r || n == 0) ? function(s, i) {
    return i ? s.replace(/\/?\/$/, "") + "/" + i.replace(/^\/+/, "") : s;
  }(e, t) : t;
}
const Wo = (e) => e instanceof mt ? { ...e } : e;
function Vt(e, t) {
  t = t || {};
  const n = {};
  function r(c, l, d, f) {
    return y.isPlainObject(c) && y.isPlainObject(l) ? y.merge.call({ caseless: f }, c, l) : y.isPlainObject(l) ? y.merge({}, l) : y.isArray(l) ? l.slice() : l;
  }
  function s(c, l, d, f) {
    return y.isUndefined(l) ? y.isUndefined(c) ? void 0 : r(void 0, c, 0, f) : r(c, l, 0, f);
  }
  function i(c, l) {
    if (!y.isUndefined(l)) return r(void 0, l);
  }
  function o(c, l) {
    return y.isUndefined(l) ? y.isUndefined(c) ? void 0 : r(void 0, c) : r(void 0, l);
  }
  function a(c, l, d) {
    return d in t ? r(c, l) : d in e ? r(void 0, c) : void 0;
  }
  const u = { url: i, method: i, data: i, baseURL: o, transformRequest: o, transformResponse: o, paramsSerializer: o, timeout: o, timeoutMessage: o, withCredentials: o, withXSRFToken: o, adapter: o, responseType: o, xsrfCookieName: o, xsrfHeaderName: o, onUploadProgress: o, onDownloadProgress: o, decompress: o, maxContentLength: o, maxBodyLength: o, beforeRedirect: o, transport: o, httpAgent: o, httpsAgent: o, cancelToken: o, socketPath: o, responseEncoding: o, validateStatus: a, headers: (c, l, d) => s(Wo(c), Wo(l), 0, !0) };
  return y.forEach(Object.keys({ ...e, ...t }), function(c) {
    const l = u[c] || s, d = l(e[c], t[c], c);
    y.isUndefined(d) && l !== a || (n[c] = d);
  }), n;
}
const Ru = (e) => {
  const t = Vt({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = t;
  if (t.headers = o = mt.from(o), t.url = gu(xu(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && o.set("Authorization", "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))), y.isFormData(n)) {
    if (He.hasStandardBrowserEnv || He.hasStandardBrowserWebWorkerEnv) o.setContentType(void 0);
    else if (y.isFunction(n.getHeaders)) {
      const u = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(u).forEach(([l, d]) => {
        c.includes(l.toLowerCase()) && o.set(l, d);
      });
    }
  }
  if (He.hasStandardBrowserEnv && (r && y.isFunction(r) && (r = r(t)), r || r !== !1 && qf(t.url))) {
    const u = s && i && Hf.read(i);
    u && o.set(s, u);
  }
  return t;
}, Zf = typeof XMLHttpRequest < "u" && function(e) {
  return new Promise(function(t, n) {
    const r = Ru(e);
    let s = r.data;
    const i = mt.from(r.headers).normalize();
    let o, a, u, c, l, { responseType: d, onUploadProgress: f, onDownloadProgress: h } = r;
    function v() {
      c && c(), l && l(), r.cancelToken && r.cancelToken.unsubscribe(o), r.signal && r.signal.removeEventListener("abort", o);
    }
    let m = new XMLHttpRequest();
    function O() {
      if (!m) return;
      const C = mt.from("getAllResponseHeaders" in m && m.getAllResponseHeaders());
      Su(function(J) {
        t(J), v();
      }, function(J) {
        n(J), v();
      }, { data: d && d !== "text" && d !== "json" ? m.response : m.responseText, status: m.status, statusText: m.statusText, headers: C, config: e, request: m }), m = null;
    }
    m.open(r.method.toUpperCase(), r.url, !0), m.timeout = r.timeout, "onloadend" in m ? m.onloadend = O : m.onreadystatechange = function() {
      m && m.readyState === 4 && (m.status !== 0 || m.responseURL && m.responseURL.indexOf("file:") === 0) && setTimeout(O);
    }, m.onabort = function() {
      m && (n(new te("Request aborted", te.ECONNABORTED, e, m)), m = null);
    }, m.onerror = function(C) {
      const J = C && C.message ? C.message : "Network Error", H = new te(J, te.ERR_NETWORK, e, m);
      H.event = C || null, n(H), m = null;
    }, m.ontimeout = function() {
      let C = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const J = r.transitional || vu;
      r.timeoutErrorMessage && (C = r.timeoutErrorMessage), n(new te(C, J.clarifyTimeoutError ? te.ETIMEDOUT : te.ECONNABORTED, e, m)), m = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in m && y.forEach(i.toJSON(), function(C, J) {
      m.setRequestHeader(J, C);
    }), y.isUndefined(r.withCredentials) || (m.withCredentials = !!r.withCredentials), d && d !== "json" && (m.responseType = r.responseType), h && ([u, l] = Xr(h, !0), m.addEventListener("progress", u)), f && m.upload && ([a, c] = Xr(f), m.upload.addEventListener("progress", a), m.upload.addEventListener("loadend", c)), (r.cancelToken || r.signal) && (o = (C) => {
      m && (n(!C || C.type ? new Qn(null, e, m) : C), m.abort(), m = null);
    }, r.cancelToken && r.cancelToken.subscribe(o), r.signal && (r.signal.aborted ? o() : r.signal.addEventListener("abort", o)));
    const K = function(C) {
      const J = /^([-+\w]{1,25})(:?\/\/|:)/.exec(C);
      return J && J[1] || "";
    }(r.url);
    K && He.protocols.indexOf(K) === -1 ? n(new te("Unsupported protocol " + K + ":", te.ERR_BAD_REQUEST, e)) : m.send(s || null);
  });
}, Gf = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r, s = new AbortController();
    const i = function(c) {
      if (!r) {
        r = !0, a();
        const l = c instanceof Error ? c : this.reason;
        s.abort(l instanceof te ? l : new Qn(l instanceof Error ? l.message : l));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new te(`timeout ${t} of ms exceeded`, te.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: u } = s;
    return u.unsubscribe = () => y.asap(a), u;
  }
}, Wf = function* (e, t) {
  let n = e.byteLength;
  if (n < t) return void (yield e);
  let r, s = 0;
  for (; s < n; ) r = s + t, yield e.slice(s, r), s = r;
}, Vo = (e, t, n, r) => {
  const s = async function* (u, c) {
    for await (const l of async function* (d) {
      if (d[Symbol.asyncIterator]) return void (yield* d);
      const f = d.getReader();
      try {
        for (; ; ) {
          const { done: h, value: v } = await f.read();
          if (h) break;
          yield v;
        }
      } finally {
        await f.cancel();
      }
    }(u)) yield* Wf(l, c);
  }(e, t);
  let i, o = 0, a = (u) => {
    i || (i = !0, r && r(u));
  };
  return new ReadableStream({ async pull(u) {
    try {
      const { done: c, value: l } = await s.next();
      if (c) return a(), void u.close();
      let d = l.byteLength;
      if (n) {
        let f = o += d;
        n(f);
      }
      u.enqueue(new Uint8Array(l));
    } catch (c) {
      throw a(c), c;
    }
  }, cancel: (u) => (a(u), s.return()) }, { highWaterMark: 2 });
}, { isFunction: fr } = y, Vf = (({ Request: e, Response: t }) => ({ Request: e, Response: t }))(y.global), { ReadableStream: Jo, TextEncoder: Ko } = y.global, Yo = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Jf = (e) => {
  e = y.merge.call({ skipUndefined: !0 }, Vf, e);
  const { fetch: t, Request: n, Response: r } = e, s = t ? fr(t) : typeof fetch == "function", i = fr(n), o = fr(r);
  if (!s) return !1;
  const a = s && fr(Jo), u = s && (typeof Ko == "function" ? (c = new Ko(), (h) => c.encode(h)) : async (h) => new Uint8Array(await new n(h).arrayBuffer()));
  var c;
  const l = i && a && Yo(() => {
    let h = !1;
    const v = new n(He.origin, { body: new Jo(), method: "POST", get duplex() {
      return h = !0, "half";
    } }).headers.has("Content-Type");
    return h && !v;
  }), d = o && a && Yo(() => y.isReadableStream(new r("").body)), f = { stream: d && ((h) => h.body) };
  return s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((h) => {
    !f[h] && (f[h] = (v, m) => {
      let O = v && v[h];
      if (O) return O.call(v);
      throw new te(`Response type '${h}' is not supported`, te.ERR_NOT_SUPPORT, m);
    });
  }), async (h) => {
    let { url: v, method: m, data: O, signal: K, cancelToken: C, timeout: J, onDownloadProgress: H, onUploadProgress: ie, responseType: Q, headers: De, withCredentials: Te = "same-origin", fetchOptions: Ye } = Ru(h), at = t || fetch;
    Q = Q ? (Q + "").toLowerCase() : "text";
    let xe = Gf([K, C && C.toAbortSignal()], J), Fe = null;
    const we = xe && xe.unsubscribe && (() => {
      xe.unsubscribe();
    });
    let ue;
    try {
      if (ie && l && m !== "get" && m !== "head" && (ue = await (async (Ee, Ce) => {
        const $e = y.toFiniteNumber(Ee.getContentLength());
        return $e ?? (async (Y) => Y == null ? 0 : y.isBlob(Y) ? Y.size : y.isSpecCompliantForm(Y) ? (await new n(He.origin, { method: "POST", body: Y }).arrayBuffer()).byteLength : y.isArrayBufferView(Y) || y.isArrayBuffer(Y) ? Y.byteLength : (y.isURLSearchParams(Y) && (Y += ""), y.isString(Y) ? (await u(Y)).byteLength : void 0))(Ce);
      })(De, O)) !== 0) {
        let Ee, Ce = new n(v, { method: "POST", body: O, duplex: "half" });
        if (y.isFormData(O) && (Ee = Ce.headers.get("content-type")) && De.setContentType(Ee), Ce.body) {
          const [$e, Y] = Zo(ue, Xr(Go(ie)));
          O = Vo(Ce.body, 65536, $e, Y);
        }
      }
      y.isString(Te) || (Te = Te ? "include" : "omit");
      const le = i && "credentials" in n.prototype, st = { ...Ye, signal: xe, method: m.toUpperCase(), headers: De.normalize().toJSON(), body: O, duplex: "half", credentials: le ? Te : void 0 };
      Fe = i && new n(v, st);
      let ke = await (i ? at(Fe, Ye) : at(v, st));
      const bt = d && (Q === "stream" || Q === "response");
      if (d && (H || bt && we)) {
        const Ee = {};
        ["status", "statusText", "headers"].forEach((Re) => {
          Ee[Re] = ke[Re];
        });
        const Ce = y.toFiniteNumber(ke.headers.get("content-length")), [$e, Y] = H && Zo(Ce, Xr(Go(H), !0)) || [];
        ke = new r(Vo(ke.body, 65536, $e, () => {
          Y && Y(), we && we();
        }), Ee);
      }
      Q = Q || "text";
      let Tt = await f[y.findKey(f, Q) || "text"](ke, h);
      return !bt && we && we(), await new Promise((Ee, Ce) => {
        Su(Ee, Ce, { data: Tt, headers: mt.from(ke.headers), status: ke.status, statusText: ke.statusText, config: h, request: Fe });
      });
    } catch (le) {
      throw we && we(), le && le.name === "TypeError" && /Load failed|fetch/i.test(le.message) ? Object.assign(new te("Network Error", te.ERR_NETWORK, h, Fe), { cause: le.cause || le }) : te.from(le, le && le.code, h, Fe);
    }
  };
}, Kf = /* @__PURE__ */ new Map(), Xo = (e) => {
  let t = e && e.env || {};
  const { fetch: n, Request: r, Response: s } = t, i = [r, s, n];
  let o, a, u = i.length, c = Kf;
  for (; u--; ) o = i[u], a = c.get(o), a === void 0 && c.set(o, a = u ? /* @__PURE__ */ new Map() : Jf(t)), c = a;
  return a;
}, Ou = (Xo(), { http: null, xhr: Zf, fetch: { get: Xo } });
y.forEach(Ou, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Qo = (e) => `- ${e}`, Yf = (e) => y.isFunction(e) || e === null || e === !1, _u = function(e, t) {
  e = y.isArray(e) ? e : [e];
  const { length: n } = e;
  let r, s;
  const i = {};
  for (let o = 0; o < n; o++) {
    let a;
    if (r = e[o], s = r, !Yf(r) && (s = Ou[(a = String(r)).toLowerCase()], s === void 0)) throw new te(`Unknown adapter '${a}'`);
    if (s && (y.isFunction(s) || (s = s.get(t)))) break;
    i[a || "#" + o] = s;
  }
  if (!s) {
    const o = Object.entries(i).map(([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build"));
    let a = n ? o.length > 1 ? `since :
` + o.map(Qo).join(`
`) : " " + Qo(o[0]) : "as no adapter specified";
    throw new te("There is no suitable adapter to dispatch the request " + a, "ERR_NOT_SUPPORT");
  }
  return s;
};
function js(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new Qn(null, e);
}
function ea(e) {
  return js(e), e.headers = mt.from(e.headers), e.data = Ts.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), _u(e.adapter || pi.adapter, e)(e).then(function(t) {
    return js(e), t.data = Ts.call(e, e.transformResponse, t), t.headers = mt.from(t.headers), t;
  }, function(t) {
    return yu(t) || (js(e), t && t.response && (t.response.data = Ts.call(e, e.transformResponse, t.response), t.response.headers = mt.from(t.response.headers))), Promise.reject(t);
  });
}
const Eu = "1.13.2", Qr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Qr[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ta = {};
Qr.transitional = function(e, t, n) {
  function r(s, i) {
    return "[Axios v" + Eu + "] Transitional option '" + s + "'" + i + (n ? ". " + n : "");
  }
  return (s, i, o) => {
    if (e === !1) throw new te(r(i, " has been removed" + (t ? " in " + t : "")), te.ERR_DEPRECATED);
    return t && !ta[i] && (ta[i] = !0, console.warn(r(i, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(s, i, o);
  };
}, Qr.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
const Cr = { assertOptions: function(e, t, n) {
  if (typeof e != "object") throw new te("options must be an object", te.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = t[i];
    if (o) {
      const a = e[i], u = a === void 0 || o(a, i, e);
      if (u !== !0) throw new te("option " + i + " must be " + u, te.ERR_BAD_OPTION_VALUE);
    } else if (n !== !0) throw new te("Unknown option " + i, te.ERR_BAD_OPTION);
  }
}, validators: Qr }, xt = Cr.validators;
class Tr {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = { request: new qo(), response: new qo() };
  }
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}).url = t : n = t || {}, n = Vt(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && Cr.assertOptions(r, { silentJSONParsing: xt.transitional(xt.boolean), forcedJSONParsing: xt.transitional(xt.boolean), clarifyTimeoutError: xt.transitional(xt.boolean) }, !1), s != null && (y.isFunction(s) ? n.paramsSerializer = { serialize: s } : Cr.assertOptions(s, { encode: xt.function, serialize: xt.function }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Cr.assertOptions(n, { baseUrl: xt.spelling("baseURL"), withXsrfToken: xt.spelling("withXSRFToken") }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && y.merge(i.common, i[n.method]);
    i && y.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (v) => {
      delete i[v];
    }), n.headers = mt.concat(o, i);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(v) {
      typeof v.runWhen == "function" && v.runWhen(n) === !1 || (u = u && v.synchronous, a.unshift(v.fulfilled, v.rejected));
    });
    const c = [];
    let l;
    this.interceptors.response.forEach(function(v) {
      c.push(v.fulfilled, v.rejected);
    });
    let d, f = 0;
    if (!u) {
      const v = [ea.bind(this), void 0];
      for (v.unshift(...a), v.push(...c), d = v.length, l = Promise.resolve(n); f < d; ) l = l.then(v[f++], v[f++]);
      return l;
    }
    d = a.length;
    let h = n;
    for (; f < d; ) {
      const v = a[f++], m = a[f++];
      try {
        h = v(h);
      } catch (O) {
        m.call(this, O);
        break;
      }
    }
    try {
      l = ea.call(this, h);
    } catch (v) {
      return Promise.reject(v);
    }
    for (f = 0, d = c.length; f < d; ) l = l.then(c[f++], c[f++]);
    return l;
  }
  getUri(t) {
    return gu(xu((t = Vt(this.defaults, t)).baseURL, t.url, t.allowAbsoluteUrls), t.params, t.paramsSerializer);
  }
}
y.forEach(["delete", "get", "head", "options"], function(e) {
  Tr.prototype[e] = function(t, n) {
    return this.request(Vt(n || {}, { method: e, url: t, data: (n || {}).data }));
  };
}), y.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(r, s, i) {
      return this.request(Vt(i || {}, { method: e, headers: n ? { "Content-Type": "multipart/form-data" } : {}, url: r, data: s }));
    };
  }
  Tr.prototype[e] = t(), Tr.prototype[e + "Form"] = t(!0);
});
const jr = Tr;
class mi {
  constructor(t) {
    if (typeof t != "function") throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; ) r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, t(function(s, i, o) {
      r.reason || (r.reason = new Qn(s, i, o), n(r.reason));
    });
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(t) {
    this.reason ? t(this.reason) : this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  unsubscribe(t) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  static source() {
    let t;
    return { token: new mi(function(n) {
      t = n;
    }), cancel: t };
  }
}
const Xf = mi, Xs = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511, WebServerIsDown: 521, ConnectionTimedOut: 522, OriginIsUnreachable: 523, TimeoutOccurred: 524, SslHandshakeFailed: 525, InvalidSslCertificate: 526 };
Object.entries(Xs).forEach(([e, t]) => {
  Xs[t] = e;
});
const Qf = Xs, Le = function e(t) {
  const n = new jr(t), r = lu(jr.prototype.request, n);
  return y.extend(r, jr.prototype, n, { allOwnKeys: !0 }), y.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(s) {
    return e(Vt(t, s));
  }, r;
}(pi);
Le.Axios = jr, Le.CanceledError = Qn, Le.CancelToken = Xf, Le.isCancel = yu, Le.VERSION = Eu, Le.toFormData = Yr, Le.AxiosError = te, Le.Cancel = Le.CanceledError, Le.all = function(e) {
  return Promise.all(e);
}, Le.spread = function(e) {
  return function(t) {
    return e.apply(null, t);
  };
}, Le.isAxiosError = function(e) {
  return y.isObject(e) && e.isAxiosError === !0;
}, Le.mergeConfig = Vt, Le.AxiosHeaders = mt, Le.formToJSON = (e) => bu(y.isHTMLForm(e) ? new FormData(e) : e), Le.getAdapter = _u, Le.HttpStatusCode = Qf, Le.default = Le;
const N = Le;
function Cu(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Qs(e, t, n) {
  return Qs = gi() ? Reflect.construct : function(r, s, i) {
    var o = [null];
    o.push.apply(o, s);
    var a = new (Function.bind.apply(r, o))();
    return i && Vn(a, i.prototype), a;
  }, Qs.apply(null, arguments);
}
function kr(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Wn(e) {
  return Wn = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Wn(e);
}
function Vn(e, t) {
  return Vn = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, Vn(e, t);
}
function ei(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return ei = function(n) {
    if (n === null || (r = n, Function.toString.call(r).indexOf("[native code]") === -1)) return n;
    var r;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n)) return t.get(n);
      t.set(n, s);
    }
    function s() {
      return Qs(n, arguments, Wn(this).constructor);
    }
    return s.prototype = Object.create(n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), Vn(s, n);
  }, ei(e);
}
function gi() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (gi = function() {
    return !!e;
  })();
}
var D = "http://localhost".replace(/\/+$/, ""), Qe = function e(t) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : D, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : N;
  Cu(this, e), kr(this, "basePath", void 0), kr(this, "axios", void 0), kr(this, "configuration", void 0), this.basePath = r, this.axios = s, t && (this.configuration = t, this.basePath = (n = t.basePath) !== null && n !== void 0 ? n : r);
}, eh = function() {
  function e(t, n) {
    var r;
    return Cu(this, e), kr(r = function(s, i, o) {
      return i = Wn(i), function(a, u) {
        return !u || ((c = u) && typeof Symbol < "u" && c.constructor === Symbol ? "symbol" : typeof c) != "object" && typeof u != "function" ? function(l) {
          if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return l;
        }(a) : u;
        var c;
      }(s, gi() ? Reflect.construct(i, o || [], Wn(s).constructor) : i.apply(s, o));
    }(this, e, [n]), "field", void 0), r.field = t, r.name = "RequiredError", r;
  }
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(n && n.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), n && Vn(t, n);
  }(e, ei(Error)), e;
}(), F = {};
function na(e, t, n, r, s, i, o) {
  try {
    var a = e[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? t(u) : Promise.resolve(u).then(r, s);
}
function th(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var $ = "https://example.com", I = function(e, t, n) {
  if (n == null) throw new eh(t, "Required parameter ".concat(t, " was null or undefined when calling ").concat(e, "."));
}, q = function(e, t) {
  return (n = function() {
    var r, s;
    return function(i, o) {
      var a, u, c, l = { label: 0, sent: function() {
        if (1 & c[0]) throw c[1];
        return c[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = f(0), d.throw = f(1), d.return = f(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function f(h) {
        return function(v) {
          return function(m) {
            if (a) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, m[0] && (l = 0)), l; ) try {
              if (a = 1, u && (c = 2 & m[0] ? u.return : m[0] ? u.throw || ((c = u.return) && c.call(u), 0) : u.next) && !(c = c.call(u, m[1])).done) return c;
              switch (u = 0, c && (m = [2 & m[0], c.value]), m[0]) {
                case 0:
                case 1:
                  c = m;
                  break;
                case 4:
                  return l.label++, { value: m[1], done: !1 };
                case 5:
                  l.label++, u = m[1], m = [0];
                  continue;
                case 7:
                  m = l.ops.pop(), l.trys.pop();
                  continue;
                default:
                  if (!((c = (c = l.trys).length > 0 && c[c.length - 1]) || m[0] !== 6 && m[0] !== 2)) {
                    l = 0;
                    continue;
                  }
                  if (m[0] === 3 && (!c || m[1] > c[0] && m[1] < c[3])) {
                    l.label = m[1];
                    break;
                  }
                  if (m[0] === 6 && l.label < c[1]) {
                    l.label = c[1], c = m;
                    break;
                  }
                  if (c && l.label < c[2]) {
                    l.label = c[2], l.ops.push(m);
                    break;
                  }
                  c[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }
              m = o.call(i, l);
            } catch (O) {
              m = [6, O], u = 0;
            } finally {
              a = c = 0;
            }
            if (5 & m[0]) throw m[1];
            return { value: m[0] ? m[1] : void 0, done: !0 };
          }([h, v]);
        };
      }
    }(this, function(i) {
      switch (i.label) {
        case 0:
          return t && t.accessToken ? typeof t.accessToken != "function" ? [3, 2] : [4, t.accessToken()] : [3, 5];
        case 1:
          return s = i.sent(), [3, 4];
        case 2:
          return [4, t.accessToken];
        case 3:
          s = i.sent(), i.label = 4;
        case 4:
          r = s, e.Authorization = "Bearer " + r, i.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var r = this, s = arguments;
    return new Promise(function(i, o) {
      var a = n.apply(r, s);
      function u(l) {
        na(a, i, o, u, c, "next", l);
      }
      function c(l) {
        na(a, i, o, u, c, "throw", l);
      }
      u(void 0);
    });
  })();
  var n;
};
function ti(e, t) {
  var n, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  t != null && ((t === void 0 ? "undefined" : (n = t) && typeof Symbol < "u" && n.constructor === Symbol ? "symbol" : typeof n) == "object" ? Array.isArray(t) ? t.forEach(function(s) {
    return ti(e, s, r);
  }) : Object.keys(t).forEach(function(s) {
    return ti(e, t[s], "".concat(r).concat(r !== "" ? "." : "").concat(s));
  }) : e.has(r) ? e.append(r, t) : e.set(r, t));
}
var B = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  var s = new URLSearchParams(e.search);
  ti(s, n), e.search = s.toString();
}, Se = function(e, t, n) {
  var r = typeof e != "string";
  return (r && n && n.isJsonMime ? n.isJsonMime(t.headers["Content-Type"]) : r) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, M = function(e) {
  return e.pathname + e.search + e.hash;
}, z = function(e, t, n, r) {
  return function() {
    var s, i, o, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n, c = (i = function(l) {
      for (var d = 1; d < arguments.length; d++) {
        var f = arguments[d] != null ? arguments[d] : {}, h = Object.keys(f);
        typeof Object.getOwnPropertySymbols == "function" && (h = h.concat(Object.getOwnPropertySymbols(f).filter(function(v) {
          return Object.getOwnPropertyDescriptor(f, v).enumerable;
        }))), h.forEach(function(v) {
          th(l, v, f[v]);
        });
      }
      return l;
    }({}, e.options), o = (o = { url: (a.defaults.baseURL ? "" : (s = r == null ? void 0 : r.basePath) !== null && s !== void 0 ? s : u) + e.url }) != null ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : function(l) {
      var d = Object.keys(l);
      if (Object.getOwnPropertySymbols) {
        var f = Object.getOwnPropertySymbols(l);
        d.push.apply(d, f);
      }
      return d;
    }(Object(o)).forEach(function(l) {
      Object.defineProperty(i, l, Object.getOwnPropertyDescriptor(o, l));
    }), i);
    return a.request(c);
  };
};
function ra(e, t, n, r, s, i, o) {
  try {
    var a = e[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? t(u) : Promise.resolve(u).then(r, s);
}
function S(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, s) {
      var i = e.apply(t, n);
      function o(u) {
        ra(i, r, s, o, a, "next", u);
      }
      function a(u) {
        ra(i, r, s, o, a, "throw", u);
      }
      o(void 0);
    });
  };
}
function et(e, t, n) {
  return t = es(t), function(r, s) {
    return !s || ((i = s) && typeof Symbol < "u" && i.constructor === Symbol ? "symbol" : typeof i) != "object" && typeof s != "function" ? function(o) {
      if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return o;
    }(r) : s;
    var i;
  }(e, Tu() ? Reflect.construct(t, n || [], es(e).constructor) : t.apply(e, n));
}
function tt(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function nh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function nt(e, t, n) {
  return t && nh(e.prototype, t), e;
}
function rh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function es(e) {
  return es = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, es(e);
}
function rt(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && ni(e, t);
}
function w(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      rh(e, s, n[s]);
    });
  }
  return e;
}
function ni(e, t) {
  return ni = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, ni(e, t);
}
function Tu() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Tu = function() {
    return !!e;
  })();
}
function x(e, t) {
  var n, r, s, i = { label: 0, sent: function() {
    if (1 & s[0]) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return function(l) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, l[0] && (i = 0)), i; ) try {
          if (n = 1, r && (s = 2 & l[0] ? r.return : l[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, l[1])).done) return s;
          switch (r = 0, s && (l = [2 & l[0], s.value]), l[0]) {
            case 0:
            case 1:
              s = l;
              break;
            case 4:
              return i.label++, { value: l[1], done: !1 };
            case 5:
              i.label++, r = l[1], l = [0];
              continue;
            case 7:
              l = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!((s = (s = i.trys).length > 0 && s[s.length - 1]) || l[0] !== 6 && l[0] !== 2)) {
                i = 0;
                continue;
              }
              if (l[0] === 3 && (!s || l[1] > s[0] && l[1] < s[3])) {
                i.label = l[1];
                break;
              }
              if (l[0] === 6 && i.label < s[1]) {
                i.label = s[1], s = l;
                break;
              }
              if (s && i.label < s[2]) {
                i.label = s[2], i.ops.push(l);
                break;
              }
              s[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          l = t.call(e, i);
        } catch (d) {
          l = [6, d], r = 0;
        } finally {
          n = s = 0;
        }
        if (5 & l[0]) throw l[1];
        return { value: l[0] ? l[1] : void 0, done: !0 };
      }([u, c]);
    };
  }
}
var sh = function(e) {
  return { listBreaks: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("listBreaks", "showId", t), s = new URL("/break", $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, r), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), t !== void 0 && (u.showId = t), n !== void 0 && (u.ring = n), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, r.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  } };
}, ih = function(e) {
  var t = sh(e);
  return { listBreaks: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.listBreaks(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["BreaksApi.listBreaks"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "listBreaks", value: function(n, r, s) {
    var i = this;
    return ih(this.configuration).listBreaks(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Qe);
var oh = function(e) {
  return { getClass: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getClass", "classId", t), r = "/class/{classId}".replace("{classId}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, listClasses: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("listClasses", "showId", t), s = new URL("/class", $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, r), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), t !== void 0 && (u.showId = t), n !== void 0 && (u.mine = n), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, r.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassErrorDeductionScheme", "classId", t), I("setClassErrorDeductionScheme", "setClassErrorDeductionSchemeRequest", n), s = "/class/{classId}/error-deduction-scheme".replace("{classId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassFaultTimeLimit", "classId", t), I("setClassFaultTimeLimit", "setClassFaultTimeLimitRequest", n), s = "/class/{classId}/fault-time-limit".replace("{classId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, setClassQualityJudging: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassQualityJudging", "classId", t), I("setClassQualityJudging", "setClassQualityJudgingRequest", n), s = "/class/{classId}/quality-judging".replace("{classId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, setClassScribeAssignment: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassScribeAssignment", "classId", t), I("setClassScribeAssignment", "setClassScribeAssignmentRequest", n), s = "/class/{classId}/scribe-assignments".replace("{classId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassSectionJudgeAssignments", "classId", t), s = "/class/{classId}/section-judge-assignments".replace("{classId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, setClassSkipUsefUpload: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassSkipUsefUpload", "classId", t), I("setClassSkipUsefUpload", "setClassSkipUsefUploadRequest", n), s = "/class/{classId}/skip-usef-upload".replace("{classId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, setRingScribeAssignments: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setRingScribeAssignments", "ring", t), I("setRingScribeAssignments", "setRingScribeAssignmentsRequest", n), s = "/ring/{ring}/scribe-assignments".replace("{ring}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  } };
}, It = function(e) {
  var t = oh(e);
  return { getClass: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getClass(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["ClassesApi.getClass"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, listClasses: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.listClasses(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ClassesApi.listClasses"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassErrorDeductionScheme(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ClassesApi.setClassErrorDeductionScheme"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassFaultTimeLimit(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ClassesApi.setClassFaultTimeLimit"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, setClassQualityJudging: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassQualityJudging(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ClassesApi.setClassQualityJudging"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, setClassScribeAssignment: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassScribeAssignment(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ClassesApi.setClassScribeAssignment"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassSectionJudgeAssignments(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ClassesApi.setClassSectionJudgeAssignments"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, setClassSkipUsefUpload: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassSkipUsefUpload(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ClassesApi.setClassSkipUsefUpload"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, setRingScribeAssignments: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setRingScribeAssignments(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ClassesApi.setRingScribeAssignments"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "getClass", value: function(n, r) {
    var s = this;
    return It(this.configuration).getClass(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listClasses", value: function(n, r, s) {
    var i = this;
    return It(this.configuration).listClasses(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassErrorDeductionScheme", value: function(n, r, s) {
    var i = this;
    return It(this.configuration).setClassErrorDeductionScheme(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassFaultTimeLimit", value: function(n, r, s) {
    var i = this;
    return It(this.configuration).setClassFaultTimeLimit(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassQualityJudging", value: function(n, r, s) {
    var i = this;
    return It(this.configuration).setClassQualityJudging(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassScribeAssignment", value: function(n, r, s) {
    var i = this;
    return It(this.configuration).setClassScribeAssignment(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassSectionJudgeAssignments", value: function(n, r, s) {
    var i = this;
    return It(this.configuration).setClassSectionJudgeAssignments(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassSkipUsefUpload", value: function(n, r, s) {
    var i = this;
    return It(this.configuration).setClassSkipUsefUpload(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRingScribeAssignments", value: function(n, r, s) {
    var i = this;
    return It(this.configuration).setRingScribeAssignments(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Qe);
var ah = function(e) {
  return { getDaysheetReconcileStatus: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getDaysheetReconcileStatus", "showId", t), r = "/daysheet/{showId}/status".replace("{showId}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, reconcileDaysheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("reconcileDaysheet", "showId", t), r = "/daysheet/{showId}/reconcile".replace("{showId}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "POST" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  } };
}, sa = function(e) {
  var t = ah(e);
  return { getDaysheetReconcileStatus: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getDaysheetReconcileStatus(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["DaySheetApi.getDaysheetReconcileStatus"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, reconcileDaysheet: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.reconcileDaysheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["DaySheetApi.reconcileDaysheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "getDaysheetReconcileStatus", value: function(n, r) {
    var s = this;
    return sa(this.configuration).getDaysheetReconcileStatus(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "reconcileDaysheet", value: function(n, r) {
    var s = this;
    return sa(this.configuration).reconcileDaysheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), t;
})(Qe);
var uh = function(e) {
  return { reseedDemo: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u;
      return x(this, function(c) {
        switch (c.label) {
          case 0:
            return I("reseedDemo", "reseedDemoRequest", t), r = new URL("/demo/reseed", $), e && (s = e.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, q(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", B(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = Se(t, i, e), [2, { url: M(r), options: i }];
        }
      });
    })();
  } };
}, ch = function(e) {
  var t = uh(e);
  return { reseedDemo: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.reseedDemo(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["DemoApi.reseedDemo"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "reseedDemo", value: function(n, r) {
    var s = this;
    return ch(this.configuration).reseedDemo(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), t;
})(Qe);
var lh = function(e) {
  return { getHealth: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return S(function() {
      var n, r, s, i, o;
      return x(this, function(a) {
        return n = new URL("/health", $), e && (r = e.baseOptions), s = w({ method: "GET" }, r, t), i = {}, B(n, {}), o = r && r.headers ? r.headers : {}, s.headers = w({}, i, o, t.headers), [2, { url: M(n), options: s }];
      });
    })();
  } };
}, dh = function(e) {
  var t = lh(e);
  return { getHealth: function(n) {
    return S(function() {
      var r, s, i, o, a, u;
      return x(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.getHealth(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = F["HealthApi.getHealth"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return z(i, N, D, e)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "getHealth", value: function(n) {
    var r = this;
    return dh(this.configuration).getHealth(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), t;
})(Qe);
var fh = function(e) {
  return { getHorse: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getHorse", "id", t), r = "/horse/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, listHorses: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return S(function() {
      var n, r, s, i, o, a;
      return x(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/horse", $), e && (r = e.baseOptions), s = w({ method: "GET" }, r, t), o = {}, [4, q(i = {}, e)];
          case 1:
            return u.sent(), B(n, o), a = r && r.headers ? r.headers : {}, s.headers = w({}, i, a, t.headers), [2, { url: M(n), options: s }];
        }
      });
    })();
  } };
}, ia = function(e) {
  var t = fh(e);
  return { getHorse: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getHorse(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["HorsesApi.getHorse"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, listHorses: function(n) {
    return S(function() {
      var r, s, i, o, a, u;
      return x(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.listHorses(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = F["HorsesApi.listHorses"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return z(i, N, D, e)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "getHorse", value: function(n, r) {
    var s = this;
    return ia(this.configuration).getHorse(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listHorses", value: function(n) {
    var r = this;
    return ia(this.configuration).listHorses(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), t;
})(Qe);
var hh = function(e) {
  return { deleteJudgeSignature: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("deleteJudgeSignature", "id", t), r = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "DELETE" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, listJudges: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u;
      return x(this, function(c) {
        switch (c.label) {
          case 0:
            return I("listJudges", "showId", t), r = new URL("/judge", $), e && (s = e.baseOptions), i = w({ method: "GET" }, s, n), a = {}, [4, q(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.showId = t), B(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), [2, { url: M(r), options: i }];
        }
      });
    })();
  }, putJudgeSignature: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("putJudgeSignature", "id", t), I("putJudgeSignature", "putJudgeSignatureRequest", n), s = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  } };
}, ks = function(e) {
  var t = hh(e);
  return { deleteJudgeSignature: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deleteJudgeSignature(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["JudgesApi.deleteJudgeSignature"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, listJudges: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listJudges(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["JudgesApi.listJudges"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, putJudgeSignature: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.putJudgeSignature(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["JudgesApi.putJudgeSignature"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "deleteJudgeSignature", value: function(n, r) {
    var s = this;
    return ks(this.configuration).deleteJudgeSignature(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listJudges", value: function(n, r) {
    var s = this;
    return ks(this.configuration).listJudges(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "putJudgeSignature", value: function(n, r, s) {
    var i = this;
    return ks(this.configuration).putJudgeSignature(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Qe);
var ph = function(e) {
  return { createPerson: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u;
      return x(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/people", $), e && (s = e.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, q(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", B(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = Se(t, i, e), [2, { url: M(r), options: i }];
        }
      });
    })();
  }, deletePerson: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("deletePerson", "id", t), r = "/people/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "DELETE" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, getPerson: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getPerson", "id", t), r = "/people/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, listPeople: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u;
      return x(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/people", $), e && (s = e.baseOptions), i = w({ method: "GET" }, s, n), a = {}, [4, q(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.personType = t), B(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), [2, { url: M(r), options: i }];
        }
      });
    })();
  }, updatePerson: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("updatePerson", "id", t), s = "/people/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  } };
}, jn = function(e) {
  var t = ph(e);
  return { createPerson: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.createPerson(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["PeopleApi.createPerson"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, deletePerson: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deletePerson(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["PeopleApi.deletePerson"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, getPerson: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getPerson(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["PeopleApi.getPerson"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, listPeople: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listPeople(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["PeopleApi.listPeople"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, updatePerson: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.updatePerson(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["PeopleApi.updatePerson"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "createPerson", value: function(n, r) {
    var s = this;
    return jn(this.configuration).createPerson(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "deletePerson", value: function(n, r) {
    var s = this;
    return jn(this.configuration).deletePerson(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getPerson", value: function(n, r) {
    var s = this;
    return jn(this.configuration).getPerson(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listPeople", value: function(n, r) {
    var s = this;
    return jn(this.configuration).listPeople(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "updatePerson", value: function(n, r, s) {
    var i = this;
    return jn(this.configuration).updatePerson(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Qe);
var mh = function(e) {
  return { getClassResults: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getClassResults", "classId", t), r = "/class/{classId}/results".replace("{classId}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, getRideResult: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getRideResult", "rideId", t), r = "/ride/{rideId}/results".replace("{rideId}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, setClassPlacings: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassPlacings", "classId", t), I("setClassPlacings", "setClassPlacingsRequest", n), s = "/class/{classId}/placings".replace("{classId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, setRidePlacing: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setRidePlacing", "rideId", t), s = "/ride/{rideId}/placing".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  } };
}, hr = function(e) {
  var t = mh(e);
  return { getClassResults: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getClassResults(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["ResultsApi.getClassResults"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, getRideResult: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getRideResult(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["ResultsApi.getRideResult"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, setClassPlacings: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassPlacings(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ResultsApi.setClassPlacings"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, setRidePlacing: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setRidePlacing(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ResultsApi.setRidePlacing"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "getClassResults", value: function(n, r) {
    var s = this;
    return hr(this.configuration).getClassResults(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getRideResult", value: function(n, r) {
    var s = this;
    return hr(this.configuration).getRideResult(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "setClassPlacings", value: function(n, r, s) {
    var i = this;
    return hr(this.configuration).setClassPlacings(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRidePlacing", value: function(n, r, s) {
    var i = this;
    return hr(this.configuration).setRidePlacing(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Qe);
var gh = function(e) {
  return { batchRideStatus: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u;
      return x(this, function(c) {
        switch (c.label) {
          case 0:
            return I("batchRideStatus", "batchRideStatusRequest", t), r = new URL("/rides/status", $), e && (s = e.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, q(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", B(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = Se(t, i, e), [2, { url: M(r), options: i }];
        }
      });
    })();
  }, createRide: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u;
      return x(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/ride", $), e && (s = e.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, q(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", B(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = Se(t, i, e), [2, { url: M(r), options: i }];
        }
      });
    })();
  }, createRideUtilityEvent: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("createRideUtilityEvent", "rideId", t), I("createRideUtilityEvent", "createRideUtilityEventRequest", n), s = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("deleteRideUtilityEvent", "rideId", t), I("deleteRideUtilityEvent", "eventId", n), s = "/ride/{rideId}/utility-events/{eventId}".replace("{rideId}", encodeURIComponent(String(t))).replace("{eventId}", encodeURIComponent(String(n))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "DELETE" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, finalizeRide: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("finalizeRide", "rideId", t), s = "/ride/{rideId}/finalize".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, getRide: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getRide", "rideId", t), r = "/ride/{rideId}".replace("{rideId}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, listRideUtilityEvents: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("listRideUtilityEvents", "rideId", t), r = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, listRides: function(t, n, r, s, i, o, a) {
    var u = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {};
    return S(function() {
      var c, l, d, f, h, v;
      return x(this, function(m) {
        switch (m.label) {
          case 0:
            return c = new URL("/ride", $), e && (l = e.baseOptions), d = w({ method: "GET" }, l, u), h = {}, [4, q(f = {}, e)];
          case 1:
            return m.sent(), t !== void 0 && (h.classId = t), n !== void 0 && (h.showId = n), r !== void 0 && (h.day = r), s !== void 0 && (h.ring = s), i !== void 0 && (h.needsReview = i), o !== void 0 && (h.riderId = o), a !== void 0 && (h.horseId = a), B(c, h), v = l && l.headers ? l.headers : {}, d.headers = w({}, f, v, u.headers), [2, { url: M(c), options: d }];
        }
      });
    })();
  }, repointRide: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("repointRide", "rideId", t), I("repointRide", "repointRideRequest", n), s = "/ride/{rideId}/repoint".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, resolveManualRide: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("resolveManualRide", "rideId", t), I("resolveManualRide", "resolveManualRideRequest", n), s = "/ride/{rideId}/resolve".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, setRideStatus: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setRideStatus", "rideId", t), I("setRideStatus", "setRideStatusRequest", n), s = "/ride/{rideId}/status".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  } };
}, ft = function(e) {
  var t = gh(e);
  return { batchRideStatus: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.batchRideStatus(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["RidesApi.batchRideStatus"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, createRide: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.createRide(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["RidesApi.createRide"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, createRideUtilityEvent: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.createRideUtilityEvent(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["RidesApi.createRideUtilityEvent"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.deleteRideUtilityEvent(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["RidesApi.deleteRideUtilityEvent"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, finalizeRide: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.finalizeRide(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["RidesApi.finalizeRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, getRide: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getRide(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["RidesApi.getRide"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, listRideUtilityEvents: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listRideUtilityEvents(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["RidesApi.listRideUtilityEvents"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, listRides: function(n, r, s, i, o, a, u, c) {
    return S(function() {
      var l, d, f, h, v, m;
      return x(this, function(O) {
        switch (O.label) {
          case 0:
            return [4, t.listRides(n, r, s, i, o, a, u, c)];
          case 1:
            return f = O.sent(), v = (h = e == null ? void 0 : e.serverIndex) !== null && h !== void 0 ? h : 0, m = (d = F["RidesApi.listRides"]) === null || d === void 0 || (l = d[v]) === null || l === void 0 ? void 0 : l.url, [2, function(K, C) {
              return z(f, N, D, e)(K, m || C);
            }];
        }
      });
    })();
  }, repointRide: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.repointRide(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["RidesApi.repointRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, resolveManualRide: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.resolveManualRide(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["RidesApi.resolveManualRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, setRideStatus: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setRideStatus(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["RidesApi.setRideStatus"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "batchRideStatus", value: function(n, r) {
    var s = this;
    return ft(this.configuration).batchRideStatus(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "createRide", value: function(n, r) {
    var s = this;
    return ft(this.configuration).createRide(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "createRideUtilityEvent", value: function(n, r, s) {
    var i = this;
    return ft(this.configuration).createRideUtilityEvent(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "deleteRideUtilityEvent", value: function(n, r, s) {
    var i = this;
    return ft(this.configuration).deleteRideUtilityEvent(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "finalizeRide", value: function(n, r, s) {
    var i = this;
    return ft(this.configuration).finalizeRide(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getRide", value: function(n, r) {
    var s = this;
    return ft(this.configuration).getRide(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listRideUtilityEvents", value: function(n, r) {
    var s = this;
    return ft(this.configuration).listRideUtilityEvents(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listRides", value: function(n, r, s, i, o, a, u, c) {
    var l = this;
    return ft(this.configuration).listRides(n, r, s, i, o, a, u, c).then(function(d) {
      return d(l.axios, l.basePath);
    });
  } }, { key: "repointRide", value: function(n, r, s) {
    var i = this;
    return ft(this.configuration).repointRide(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "resolveManualRide", value: function(n, r, s) {
    var i = this;
    return ft(this.configuration).resolveManualRide(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRideStatus", value: function(n, r, s) {
    var i = this;
    return ft(this.configuration).setRideStatus(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Qe);
var vh = function(e) {
  return { completeScoreSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("completeScoreSheet", "id", t), r = "/scoresheet/{id}/complete".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "POST" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("confirmScoreSheetMarks", "id", t), r = "/scoresheet/{id}/confirm-marks".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "POST" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, createScoreSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u;
      return x(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/scoresheet", $), e && (s = e.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, q(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", B(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = Se(t, i, e), [2, { url: M(r), options: i }];
        }
      });
    })();
  }, getRideAuditTrail: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getRideAuditTrail", "rideId", t), r = "/ride/{rideId}/audit".replace("{rideId}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, getScoreSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getScoreSheet", "id", t), r = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getScoreSheetAuditTrail", "id", t), r = "/scoresheet/{id}/audit".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, getScoreSheetSignature: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getScoreSheetSignature", "id", t), r = "/scoresheet/{id}/signature".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, listScoreSheets: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/scoresheet", $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, r), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), t !== void 0 && (u.rideId = t), n !== void 0 && (u.judgeId = n), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, r.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, reopenScoreSheet: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("reopenScoreSheet", "id", t), I("reopenScoreSheet", "reopenScoreSheetRequest", n), s = "/scoresheet/{id}/reopen".replace("{id}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, updateScoreSheet: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("updateScoreSheet", "id", t), s = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  } };
}, Rt = function(e) {
  var t = vh(e);
  return { completeScoreSheet: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.completeScoreSheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["ScoreSheetsApi.completeScoreSheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.confirmScoreSheetMarks(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["ScoreSheetsApi.confirmScoreSheetMarks"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, createScoreSheet: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.createScoreSheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["ScoreSheetsApi.createScoreSheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, getRideAuditTrail: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getRideAuditTrail(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["ScoreSheetsApi.getRideAuditTrail"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheet: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getScoreSheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["ScoreSheetsApi.getScoreSheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getScoreSheetAuditTrail(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["ScoreSheetsApi.getScoreSheetAuditTrail"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheetSignature: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getScoreSheetSignature(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["ScoreSheetsApi.getScoreSheetSignature"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, listScoreSheets: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.listScoreSheets(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ScoreSheetsApi.listScoreSheets"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, reopenScoreSheet: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.reopenScoreSheet(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ScoreSheetsApi.reopenScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, updateScoreSheet: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.updateScoreSheet(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ScoreSheetsApi.updateScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "completeScoreSheet", value: function(n, r) {
    var s = this;
    return Rt(this.configuration).completeScoreSheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "confirmScoreSheetMarks", value: function(n, r) {
    var s = this;
    return Rt(this.configuration).confirmScoreSheetMarks(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "createScoreSheet", value: function(n, r) {
    var s = this;
    return Rt(this.configuration).createScoreSheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getRideAuditTrail", value: function(n, r) {
    var s = this;
    return Rt(this.configuration).getRideAuditTrail(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheet", value: function(n, r) {
    var s = this;
    return Rt(this.configuration).getScoreSheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheetAuditTrail", value: function(n, r) {
    var s = this;
    return Rt(this.configuration).getScoreSheetAuditTrail(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheetSignature", value: function(n, r) {
    var s = this;
    return Rt(this.configuration).getScoreSheetSignature(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listScoreSheets", value: function(n, r, s) {
    var i = this;
    return Rt(this.configuration).listScoreSheets(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "reopenScoreSheet", value: function(n, r, s) {
    var i = this;
    return Rt(this.configuration).reopenScoreSheet(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "updateScoreSheet", value: function(n, r, s) {
    var i = this;
    return Rt(this.configuration).updateScoreSheet(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Qe);
var bh = function(e) {
  return { getShow: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getShow", "id", t), r = "/show/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, listShows: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return S(function() {
      var n, r, s, i, o, a;
      return x(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/show", $), e && (r = e.baseOptions), s = w({ method: "GET" }, r, t), o = {}, [4, q(i = {}, e)];
          case 1:
            return u.sent(), B(n, o), a = r && r.headers ? r.headers : {}, s.headers = w({}, i, a, t.headers), [2, { url: M(n), options: s }];
        }
      });
    })();
  }, setShowLogo: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setShowLogo", "id", t), s = "/show/{id}/logo".replace("{id}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, setShowNoFoxbox: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setShowNoFoxbox", "id", t), I("setShowNoFoxbox", "setShowNoFoxboxRequest", n), s = "/show/{id}/no-foxbox".replace("{id}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  }, setShowScribeUnlockPin: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setShowScribeUnlockPin", "id", t), s = "/show/{id}/scribe-unlock-pin".replace("{id}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  } };
}, kn = function(e) {
  var t = bh(e);
  return { getShow: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getShow(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["ShowsApi.getShow"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, listShows: function(n) {
    return S(function() {
      var r, s, i, o, a, u;
      return x(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.listShows(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = F["ShowsApi.listShows"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return z(i, N, D, e)(l, u || d);
            }];
        }
      });
    })();
  }, setShowLogo: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setShowLogo(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ShowsApi.setShowLogo"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, setShowNoFoxbox: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setShowNoFoxbox(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ShowsApi.setShowNoFoxbox"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  }, setShowScribeUnlockPin: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setShowScribeUnlockPin(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["ShowsApi.setShowScribeUnlockPin"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "getShow", value: function(n, r) {
    var s = this;
    return kn(this.configuration).getShow(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listShows", value: function(n) {
    var r = this;
    return kn(this.configuration).listShows(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }, { key: "setShowLogo", value: function(n, r, s) {
    var i = this;
    return kn(this.configuration).setShowLogo(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setShowNoFoxbox", value: function(n, r, s) {
    var i = this;
    return kn(this.configuration).setShowNoFoxbox(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setShowScribeUnlockPin", value: function(n, r, s) {
    var i = this;
    return kn(this.configuration).setShowScribeUnlockPin(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Qe);
var yh = function(e) {
  return { createTest: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u;
      return x(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/test", $), e && (s = e.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, q(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", B(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = Se(t, i, e), [2, { url: M(r), options: i }];
        }
      });
    })();
  }, deleteTest: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("deleteTest", "id", t), r = "/test/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "DELETE" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, getTest: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getTest", "id", t), r = "/test/{id}".replace("{id}", encodeURIComponent(String(t))), s = new URL(r, $), e && (i = e.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, q(a = {}, e)];
          case 1:
            return l.sent(), B(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: M(s), options: o }];
        }
      });
    })();
  }, listTests: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return S(function() {
      var r, s, i, o, a, u;
      return x(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/test", $), e && (s = e.baseOptions), i = w({ method: "GET" }, s, n), a = {}, [4, q(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.showId = t), B(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), [2, { url: M(r), options: i }];
        }
      });
    })();
  }, updateTest: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return S(function() {
      var s, i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return I("updateTest", "id", t), s = "/test/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(s, $), e && (o = e.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, q(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", B(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Se(n, a, e), [2, { url: M(i), options: a }];
        }
      });
    })();
  } };
}, In = function(e) {
  var t = yh(e);
  return { createTest: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.createTest(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["TestsApi.createTest"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, deleteTest: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deleteTest(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["TestsApi.deleteTest"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, getTest: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getTest(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["TestsApi.getTest"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, listTests: function(n, r) {
    return S(function() {
      var s, i, o, a, u, c;
      return x(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listTests(n, r)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = F["TestsApi.listTests"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return z(o, N, D, e)(d, c || f);
            }];
        }
      });
    })();
  }, updateTest: function(n, r, s) {
    return S(function() {
      var i, o, a, u, c, l;
      return x(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.updateTest(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = F["TestsApi.updateTest"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return z(a, N, D, e)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return tt(this, t), et(this, t, arguments);
  }
  return rt(t, e), nt(t, [{ key: "createTest", value: function(n, r) {
    var s = this;
    return In(this.configuration).createTest(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "deleteTest", value: function(n, r) {
    var s = this;
    return In(this.configuration).deleteTest(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getTest", value: function(n, r) {
    var s = this;
    return In(this.configuration).getTest(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listTests", value: function(n, r) {
    var s = this;
    return In(this.configuration).listTests(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "updateTest", value: function(n, r, s) {
    var i = this;
    return In(this.configuration).updateTest(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Qe);
function wh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function At(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function oa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      At(e, s, n[s]);
    });
  }
  return e;
}
(function() {
  function e() {
    var r, s, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(a, u) {
      if (!(a instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, e), At(this, "apiKey", void 0), At(this, "username", void 0), At(this, "password", void 0), At(this, "accessToken", void 0), At(this, "basePath", void 0), At(this, "serverIndex", void 0), At(this, "baseOptions", void 0), At(this, "formDataCtor", void 0), this.apiKey = o.apiKey, this.username = o.username, this.password = o.password, this.accessToken = o.accessToken, this.basePath = o.basePath, this.serverIndex = o.serverIndex, this.baseOptions = (s = oa({}, o.baseOptions), i = (i = { headers: oa({}, (r = o.baseOptions) === null || r === void 0 ? void 0 : r.headers) }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(i)) : function(a) {
      var u = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(a);
        u.push.apply(u, c);
      }
      return u;
    }(Object(i)).forEach(function(a) {
      Object.defineProperty(s, a, Object.getOwnPropertyDescriptor(i, a));
    }), s), this.formDataCtor = o.formDataCtor;
  }
  var t, n;
  return t = e, (n = [{ key: "isJsonMime", value: function(r) {
    var s = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return r !== null && (s.test(r) || r.toLowerCase() === "application/json-patch+json");
  } }]) && wh(t.prototype, n), e;
})();
const Sh = {
  [Xt.PENDING]: { color: "default", label: "Scheduled" },
  [Xt.IN_PROGRESS]: { color: "info", label: "In ring" },
  // #696 — score confirmed/frozen and released to the announcer + FVD, judge
  // may still be writing comments. Green like FINAL ("score ready"); the label
  // is what tells the two apart.
  [Xt.CONFIRMED]: { color: "success", label: "Confirmed" },
  [Xt.COMPLETED]: { color: "warning", label: "Scored" },
  [Xt.FINAL]: { color: "success", label: "Final" },
  [Xt.SCRATCHED]: { color: "error", label: "Scratched" }
}, xh = { color: "default", label: "—" };
function zp({ status: e, labels: t, size: n = "small", ...r }) {
  const s = Sh[e] ?? xh, i = (t == null ? void 0 : t[e]) ?? s.label;
  return /* @__PURE__ */ p.jsx(ba, { size: n, color: s.color, label: i, ...r });
}
function qp(e, t, { intervalMs: n, enabled: r = !0 } = {}) {
  const [s, i] = Z({}), [o, a] = Z(!1), [u, c] = Z(null), [l, d] = Z(null), f = Array.from(new Set((e ?? []).filter(Boolean))), h = f.join(","), v = Zt(t);
  v.current = t;
  const m = Zt(f);
  m.current = f;
  const O = r && f.length > 0 && typeof t == "function", K = Lt(async () => {
    const C = m.current;
    if (!(!C.length || typeof v.current != "function")) {
      a(!0);
      try {
        const J = await v.current(C), H = {};
        for (const ie of J ?? []) H[ie.rideId] = ie.status;
        i(H), c(null), d(/* @__PURE__ */ new Date());
      } catch (J) {
        c(J);
      } finally {
        a(!1);
      }
    }
  }, []);
  return Ie(() => {
    if (!f.length) {
      i({});
      return;
    }
    if (!O)
      return;
    if (!n) {
      K();
      return;
    }
    document.visibilityState !== "hidden" && K();
    let C = null;
    const J = () => {
      document.visibilityState !== "hidden" && C == null && (C = setInterval(K, n));
    }, H = () => {
      C != null && (clearInterval(C), C = null);
    }, ie = () => {
      document.visibilityState === "hidden" ? H() : (K(), J());
    };
    return J(), document.addEventListener("visibilitychange", ie), () => {
      H(), document.removeEventListener("visibilitychange", ie);
    };
  }, [h, O, n, K]), { statuses: s, loading: o, error: u, refresh: K, lastUpdated: l };
}
function Hp({
  judgeName: e,
  url: t,
  loading: n = !1,
  label: r = "Judge signature",
  ...s
}) {
  return n ? /* @__PURE__ */ p.jsxs(Dr, { spacing: 1, alignItems: "center", sx: { mt: 3 }, ...s, children: [
    /* @__PURE__ */ p.jsx(Nr, { variant: "rounded", width: 240, height: 90 }),
    /* @__PURE__ */ p.jsx(Nr, { variant: "text", width: 140 })
  ] }) : t ? /* @__PURE__ */ p.jsxs(
    Dr,
    {
      spacing: 1,
      alignItems: "center",
      "data-testid": "signature-box",
      sx: { mt: 3, pt: 2, borderTop: 1, borderColor: "divider" },
      ...s,
      children: [
        /* @__PURE__ */ p.jsx(Mn, { variant: "caption", color: "text.secondary", children: r }),
        /* @__PURE__ */ p.jsx(
          Be,
          {
            sx: {
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
              bgcolor: "#ffffff",
              p: 1,
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ p.jsx(
              Be,
              {
                component: "img",
                src: t,
                alt: e || r,
                "data-testid": "signature-box-image",
                sx: { maxWidth: 240, maxHeight: 90, objectFit: "contain" }
              }
            )
          }
        ),
        e && /* @__PURE__ */ p.jsx(
          Mn,
          {
            variant: "body2",
            color: "text.primary",
            fontWeight: 600,
            "data-testid": "signature-box-name",
            children: e
          }
        )
      ]
    }
  ) : null;
}
function Zp(e, t, { enabled: n = !0 } = {}) {
  const [r, s] = Z(null), [i, o] = Z(!1), [a, u] = Z(null), c = Zt(t);
  c.current = t;
  const l = n && !!e && typeof t == "function";
  return Ie(() => {
    if (!l) {
      s(null);
      return;
    }
    let d = !1;
    return o(!0), u(null), (async () => {
      try {
        const f = await c.current(e);
        d || s(f ?? null);
      } catch (f) {
        d || u(f);
      } finally {
        d || o(!1);
      }
    })(), () => {
      d = !0;
    };
  }, [l, e]), { signature: r, loading: i, error: a };
}
function Gp({ buildId: e, testId: t = "build-badge" }) {
  const n = e ?? (typeof __BUILD_ID__ < "u" ? __BUILD_ID__ : "dev");
  return n ? /* @__PURE__ */ p.jsx(
    ye,
    {
      "data-testid": t,
      "aria-hidden": "true",
      sx: {
        position: "fixed",
        bottom: 2,
        left: 86,
        // Above AppBar/NavRail (both 1300/1200 in common-fe) so it's never
        // hidden by app chrome, but below modals/dialogs so it doesn't cover
        // interactive overlays. It's pointer-events:none anyway.
        zIndex: 1250,
        pointerEvents: "none",
        userSelect: "none",
        // A subtle themed pill so the text reads on top of any content —
        // proven legible in both light and dark (mirrors PinLock's approach).
        px: 0.5,
        py: "1px",
        borderRadius: 0.5,
        bgcolor: "background.paper",
        opacity: 0.75,
        // text.secondary reads on both light and dark backgrounds; never MUI
        // `primary` (dark-grey, vanishes on dark).
        color: "text.secondary",
        fontFamily: "monospace",
        fontSize: "9px",
        lineHeight: 1.2,
        letterSpacing: 0,
        whiteSpace: "nowrap"
      },
      children: n
    }
  ) : null;
}
function Wp({ testId: e = "usa-badge" }) {
  return /* @__PURE__ */ p.jsxs(
    ye,
    {
      "data-testid": e,
      "aria-hidden": "true",
      sx: {
        position: "fixed",
        bottom: 2,
        left: 2,
        width: 80,
        // Above AppBar/NavRail (both 1300/1200 in common-fe), same layer as
        // BuildBadge so the pair reads as one unit; below modals/dialogs.
        zIndex: 1250,
        pointerEvents: "none",
        userSelect: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        opacity: 0.75
      },
      children: [
        /* @__PURE__ */ p.jsx(
          ye,
          {
            component: "svg",
            viewBox: "0 0 1200 1200",
            "aria-label": "Made in the USA",
            sx: {
              width: 28,
              height: 28,
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark) — same rule as
              // BuildBadge.
              color: "text.secondary",
              fill: "currentColor"
            },
            children: /* @__PURE__ */ p.jsx("path", { d: "m60.84 823.92h1078.4v-49.801h-1078.4zm0-99.48h1078.4v-49.801h-1078.4zm1078.3-398.16v-49.801h-1078.3v348.61h1078.4v-49.801l-647.16-0.003906v-49.801h647.04v-49.801h-647.04v-49.801h647.04v-49.801h-647.04v-49.801zm-718.92 0.95703 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.238 6.3633 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm12.363 107.52-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.719-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.883-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.8398-9.7227 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-32.16-93.121 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68zm283.8-11.398-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.598-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-28.32-58.199-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.562 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2773-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-26.043 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.3984-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-25.922 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.4023-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm199.56-81.48 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.8359 13.801-2.0391zm-42.117-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.363-6.4766-12.359 6.4805 2.3984-13.68-9.957-9.8398zm0 69.602 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9648 9.7227 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7227zm18.477 95.16-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.957-9.8398 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.637-41.281-12.238 6.3594 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2812-83.398 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.598 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-405.36 606.96h1078.4v-49.801h-1078.4z" })
          }
        ),
        /* @__PURE__ */ p.jsx(
          ye,
          {
            sx: {
              mt: "1px",
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: 1.15,
              letterSpacing: "0.2px",
              textAlign: "center",
              textTransform: "uppercase",
              whiteSpace: "normal",
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark).
              color: "text.secondary"
            },
            children: "Made in the USA"
          }
        )
      ]
    }
  );
}
const Rh = "5432";
function Vp({
  pin: e = Rh,
  onUnlock: t,
  testId: n = "pin-lock",
  ariaLabel: r = "Unlock"
}) {
  const [s, i] = Z(!1), [o, a] = Z(""), [u, c] = Z(!1), l = Zt(null);
  return Ie(() => {
    s || (a(""), c(!1));
  }, [s]), Ie(() => {
    if (!s || o.length !== e.length) return;
    const d = setTimeout(() => {
      o === e ? (i(!1), t == null || t()) : (c(!0), setTimeout(() => {
        var f;
        a(""), c(!1), (f = l.current) == null || f.focus();
      }, 600));
    }, 80);
    return () => clearTimeout(d);
  }, [o, s, e, t]), /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      Lr,
      {
        onClick: () => i(!0),
        "aria-label": r,
        "data-testid": n,
        sx: {
          position: "fixed",
          bottom: 12,
          right: 12,
          zIndex: 1300,
          // #628 — discreet, but actually findable and tappable: a scribe has to
          // hit it on a tablet when an admin walks over, so it can't be a 16px
          // ghost. Themed text color reads on both light and dark backgrounds.
          color: "text.secondary",
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          width: 40,
          height: 40,
          "&:hover": { bgcolor: "action.hover" }
        },
        children: /* @__PURE__ */ p.jsx(Nc, { sx: { fontSize: 20 } })
      }
    ),
    /* @__PURE__ */ p.jsxs(
      pr,
      {
        open: s,
        onClose: () => i(!1),
        maxWidth: "xs",
        fullWidth: !0,
        children: [
          /* @__PURE__ */ p.jsx(mr, { children: /* @__PURE__ */ p.jsx(ye, { sx: { pt: 1 }, children: /* @__PURE__ */ p.jsx(
            $n,
            {
              inputRef: l,
              autoFocus: !0,
              fullWidth: !0,
              type: "password",
              value: o,
              onChange: (d) => (
                // Strip non-digits + cap to PIN length so paste-overflow
                // doesn't sneak past the auto-submit threshold.
                a(
                  d.target.value.replace(/\D/g, "").slice(0, e.length)
                )
              ),
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: e.length,
                style: {
                  textAlign: "center",
                  fontFamily: "monospace",
                  fontSize: 24,
                  letterSpacing: 8
                }
              },
              error: u,
              helperText: u ? "Wrong PIN" : " "
            }
          ) }) }),
          /* @__PURE__ */ p.jsx(Ps, { children: /* @__PURE__ */ p.jsx(Ge, { color: "inherit", onClick: () => i(!1), children: "Cancel" }) })
        ]
      }
    )
  ] });
}
function Jp(e, t, n = [], r = !0) {
  const [s, i] = Z({ data: null, loading: !0, error: null }), [o, a] = Z(!1), [u, c] = Z(0);
  Ie(() => {
    let d = !1;
    return (async () => {
      let f;
      try {
        f = await e();
      } catch {
        f = void 0;
      }
      const h = f != null;
      if (!d && h && i({ data: f, loading: !1, error: null }), r)
        try {
          const v = await t();
          d || i({ data: v, loading: !1, error: null });
        } catch (v) {
          !d && !h && i({ data: null, loading: !1, error: v });
        } finally {
          d || a(!1);
        }
      else
        !d && !h && i({ data: null, loading: !1, error: null }), d || a(!1);
    })(), () => {
      d = !0;
    };
  }, [...n, r, u]);
  const l = Lt(() => {
    a(!0), c((d) => d + 1);
  }, []);
  return { ...s, refetch: l, refreshing: o };
}
function Kp(e, t = []) {
  const [n, r] = Z({ data: null, loading: !0, error: null });
  return Ie(() => {
    let s = !1;
    return r({ data: null, loading: !0, error: null }), e().then((i) => {
      s || r({ data: i, loading: !1, error: null });
    }).catch((i) => {
      s || r({ data: null, loading: !1, error: i });
    }), () => {
      s = !0;
    };
  }, t), n;
}
function Oh({ clientId: e, cognitoDomain: t, logoutUri: n }) {
  if (e && t && n) {
    const r = `https://${t}/logout?client_id=${e}&logout_uri=${encodeURIComponent(n)}`;
    window.location.replace(r);
  }
}
function Yp() {
  const { mode: e, setMode: t } = ha();
  return { mode: e, toggleTheme: () => {
    t(e === "dark" ? "light" : "dark");
  } };
}
function Xp({ t: e, mode: t, toggleTheme: n, navigate: r, cognitoConfig: s, settingsLink: i = "/settings" }) {
  return [
    {
      icon: /* @__PURE__ */ p.jsx(pa, {}),
      text: e("navigation.homeLink"),
      onClick: () => r("/")
    },
    {
      icon: /* @__PURE__ */ p.jsx(ma, {}),
      text: e("navigation.settingsLink"),
      onClick: () => window.location.href = i
    },
    {
      icon: t === "dark" ? /* @__PURE__ */ p.jsx(wa, { fontSize: "small" }) : /* @__PURE__ */ p.jsx(ya, { fontSize: "small" }),
      text: e(t === "dark" ? "navigation.theme.switchToLightMode" : "navigation.theme.switchToDarkMode"),
      onClick: n
    },
    {
      icon: /* @__PURE__ */ p.jsx(Sa, {}),
      text: e("navigation.logoutLink"),
      onClick: () => Oh(s)
    }
  ];
}
const _h = "Server Error";
let aa = !1;
function Qp(e = Dc) {
  aa || (aa = !0, e.interceptors.response.use(
    (t) => t,
    (t) => {
      var s, i, o;
      const n = (s = t == null ? void 0 : t.response) == null ? void 0 : s.data, r = ((i = n == null ? void 0 : n.data) == null ? void 0 : i.message) || (n == null ? void 0 : n.message) || (n == null ? void 0 : n.error) || (n == null ? void 0 : n.code) || (t == null ? void 0 : t.message);
      return console.error("[api error]", (o = t == null ? void 0 : t.response) == null ? void 0 : o.status, r, n), t && (t.serverErrorDetail = r, t.message = _h), Promise.reject(t);
    }
  ));
}
export {
  Bc as AccountMenu,
  Tp as ActiveOrgProvider,
  jp as ActiveShowProvider,
  zc as AppBar,
  fp as AppFooter,
  hp as AppLayout,
  Gp as BuildBadge,
  pp as CallbackPage,
  gp as CognitoAuthProvider,
  vp as ConfirmButton,
  gr as FullScreenLoader,
  Up as GateHeader,
  Cp as ItemCard,
  yp as LoggedOutPage,
  wp as LogoutPage,
  Hc as MainContent,
  Lp as MockAuthProvider,
  Dp as MockLoginPage,
  Np as MockProtectedRoute,
  Sp as MuiThemeProvider,
  xp as NavRail,
  Ep as NewItemCard,
  Sl as OrgSwitcher,
  Op as PageLayout,
  Ip as PermissionProvider,
  Vp as PinLock,
  Rp as ProtectedRoute,
  Sh as RIDE_STATUS_DISPLAY,
  Td as ReportList,
  Pd as ReportParamsForm,
  Bd as ReportViewer,
  Mp as Reports,
  zp as RideStatusBadge,
  Fd as RunHistory,
  _h as SERVER_ERROR_MESSAGE,
  kp as ShowSwitcher,
  Hp as SignatureBox,
  _p as StyledBreadcrumb,
  bp as TableSkeleton,
  Rh as UNLOCK_PIN,
  Wp as UsaBadge,
  wl as UserDisplayName,
  mp as beginSignOut,
  Xp as getDefaultAccountMenuItems,
  Qp as installServerErrorInterceptor,
  Xc as isSigningOut,
  Oh as logoutCognito,
  an as unwrapReport,
  ri as useActiveOrg,
  pl as useActiveShow,
  Od as useApiConfig,
  Kp as useApiResource,
  Jp as useCachedResource,
  Na as useMockAuth,
  Pp as usePermission,
  _d as useReportApi,
  qp as useRideStatuses,
  Zp as useSheetSignature,
  Yp as useThemeSwitcher,
  bl as userDisplayName,
  Ap as userFirstName
};
//# sourceMappingURL=common-fe.js.map
